import './operator.css';
import logo from '../../../assets/yantraimage.png';
import { FaRegClock, FaRegCalendarAlt, FaBell, FaSun, FaMoon, FaExternalLinkAlt, FaWifi, FaSyncAlt } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import { RxCross2 } from "react-icons/rx";
import { MdWifiOff, MdCloudOff, MdKeyboardHide, MdErrorOutline, MdKeyboard } from "react-icons/md";

import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import Swal from 'sweetalert2';
import { checkInternet, checkServerHealth, customerbaseddevices, customerbasedshift, Deviceattributeget, Downtimeadd1, getCustomerUsers, getFirstMachineActive, getMachineLock, operatorTelemetry, telemetrykeydata } from '../../Services/app/operatorservice';
import { createTbWebSocket } from '../../Services/app/tbWebSocketService';
import { enqueueReasonUnlock, flushReliableQueue, hasPendingReliableItem, subscribeReliableQueue, getReliableQueueState } from '../../Services/app/reliableTelemetry';
import ReactDOMClient from 'react-dom/client';
import { keyframes } from "@mui/system";

import {
    FormControl,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Autocomplete,
    TextField,
    InputLabel,
    Checkbox,
    ListItemText,
    IconButton,
    OutlinedInput,
    CircularProgress as MuiCircularProgress,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { ROLE_OPERATOR } from '../../Shared/constants/role'
import { getOperatorDetails, Loginapi, startTokenAutoRefresh } from '../../Services/app/loginservice';
import CircularProgress from '../../Shared/Pages/circularprogress/circularprogress';
import VerticalProgress from '../../Shared/Pages/verticalprogress/verticalprogress';
import { useLocation, useParams } from 'react-router-dom';
import { cleanCustomerId, shiftadd } from '../../Services/app/masterservice';
import DynamicSlidingKeyboard from '../../Shared/Pages/dynamicSlidingKeyboard/dynamicSlidingKeyboard';
import { getReportGenerate1, getReportToken, getCurrentMachinePlan } from '../../Services/app/reportservice';

/**
 * Best-effort local unlock for kiosk HMIs.
 * Each machine's kiosk box runs its own local Node-RED, so a loopback POST can
 * unlock the machine even when the internet / cloud ThingsBoard is down. On a
 * plain PC/laptop (no local Node-RED, or LOCAL_UNLOCK_URL unset) the request is
 * refused/skipped and silently ignored — the cloud reliable queue still records
 * and delivers the unlock when connectivity returns. This does NOT replace the
 * cloud write; it runs alongside it for instant offline cycle-start relief.
 */
async function sendLocalUnlock(deviceId, reason, ts) {
    const url = window._env_?.LOCAL_UNLOCK_URL;
    if (!url) return; // not configured (e.g. PC/laptop) — skip entirely
    try {
        await fetch(url, {
            method: "POST",
            mode: "no-cors", // loopback + no-cors avoids CORS/PNA preflight entirely
            headers: { "Content-Type": "text/plain" },
            body: JSON.stringify({
                deviceId,
                reason: reason?.reason || "",
                code: reason?.code || "",
                ts,
            }),
            signal: AbortSignal.timeout(2000),
        });
        console.log("[LOCAL-UNLOCK] sent to local Node-RED");
    } catch (e) {
        // No local Node-RED here, or unreachable — ignore; the cloud queue covers it.
        console.log("[LOCAL-UNLOCK] no local Node-RED (skipped):", e?.name || e);
    }
}

// Search-enabled dropdown for the downtime "Assign Reason" table (Reason / Group
// columns). Kept local to this file rather than adding search to the shared
// CustomDaySelect component, so other pages using CustomDaySelect are unaffected.
function SearchableTableSelect({ name, value, onChange, label, options, required }) {
    const [open, setOpen] = useState(false);
    const [search, setSearch] = useState("");
    const filteredOptions = (options || []).filter((o) =>
        o.label?.toString().toLowerCase().includes(search.toLowerCase())
    );
    return (
        <FormControl variant="outlined" fullWidth>
            <InputLabel
                htmlFor={name}
                shrink
                sx={{
                    color: 'black',
                    pointerEvents: 'none',
                    transform: value ? 'translate(14px, 0px) scale(0.75)' : 'translate(14px, 20px) scale(1)',
                    transition: 'transform 0.2s ease-out',
                    '&.Mui-focused': {
                        color: 'orange',
                        transform: 'translate(14px, 0px) scale(0.75)',
                    },
                }}
            >
                {label}
            </InputLabel>
            <Select
                name={name}
                value={value}
                onChange={onChange}
                placeholder={label}
                required={required}
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => { setOpen(false); setSearch(""); }}
                MenuProps={{
                    PaperProps: {
                        className: "operator-select-menu",
                        style: { maxHeight: "40vh" },
                    },
                    anchorOrigin: { vertical: "top", horizontal: "left" },
                    transformOrigin: { vertical: "bottom", horizontal: "left" },
                    autoFocus: false,
                }}
                input={<OutlinedInput
                    sx={{
                        '&.MuiOutlinedInput-root': {
                            '& fieldset': { borderColor: 'black' },
                            '&:hover fieldset': { borderColor: 'black' },
                            '&.Mui-focused fieldset': { borderColor: 'orange' },
                            '&.MuiInputBase-input': { color: 'black' },
                            '&.Mui-focused.MuiInputBase-input': { caretColor: 'orange' },
                        },
                        '&.MuiSelect-icon': { color: 'black' },
                        '&.Mui-focused.MuiSelect-icon': { color: 'orange' },
                    }}
                />}
            >
                <MenuItem
                    disableRipple
                    onKeyDown={(e) => e.stopPropagation()}
                    sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                >
                    <TextField
                        size="small"
                        placeholder={`Search ${(label || "").toLowerCase()}…`}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        autoFocus
                        fullWidth
                        onClick={(e) => e.stopPropagation()}
                        autoComplete="off"
                        sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                    />
                </MenuItem>
                {filteredOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

function Operator() {
    const [date, setDate] = useState(dayjs().format("DD-MM-YYYY"));
    const [time, setTime] = useState(dayjs().format("HH:mm:ss"));
    const [deviceThresholds, setDeviceThresholds] = useState({});
    const [currentShift, setCurrentShift] = useState(null)
    const [machines, setMachines] = useState([]);
    const [deviceNameIdJson, setDeviceNameIdJson] = useState({});
    const [selectedMachine, setSelectedMachine] = useState("");
    const [machineSearch, setMachineSearch] = useState("");
    const [machineMenuOpen, setMachineMenuOpen] = useState(false);
    const [operators, setOperators] = useState([]);
    const [selectedOperator, setSelectedOperator] = useState("");
    const [operatorSearch, setOperatorSearch] = useState("");
    const [operatorMenuOpen, setOperatorMenuOpen] = useState(false);
    const [reasonslist, setreasonslist] = useState([]);
    const [reasons, setreasons] = useState([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState(null);
    const [openDownTimeModal, setopenDownTimeModal] = useState(false);
    const [shifts, setShifts] = useState([]);
    const [shiftOptions, setShiftOptions] = useState([]);
    const [selectedDate, setSelectedDate] = useState(dayjs());
    const [selectedShift, setSelectedShift] = useState(null);
    const [filteredResult, setfilteredResult] = useState([]);
    const [epochRange, setEpochRange] = useState({ from: null, to: null });
    const [loading, setLoading] = useState(false);
    const [isLocked, setIsLocked] = useState(false);
    // Bound to the effect-internal manual-reopen function so the header button can
    // re-open the reason popup (whichever customer effect is active assigns this).
    const reopenReasonPopupRef = useRef(null);
    const location = useLocation();
    const { plantSlug: urlPlantSlugParam } = useParams();
    const CustomerEmail = localStorage.getItem("email");
    const [telemetry, setTelemetry] = useState({
        machineStatus: "Unknown",
        targetParts: 0,
        totalShots: 0,
        goodParts: 0,
        scrap: 0,
        ncr: 0,
        jobName: "",
        jobCode: "",
    });
    const [currentOperator, setCurrentOperator] = useState(null);
    const [pendingMachine, setPendingMachine] = useState("");
    const [pendingOperator, setPendingOperator] = useState("");
    const [confirmType, setConfirmType] = useState(null);
    const customerId1 = localStorage.getItem('CustomerID');
    const isSwalOpenRef = useRef(false);
    const [blueCardLogs, setBlueCardLogs] = useState([]);
    const [openBlueCardConfirm, setOpenBlueCardConfirm] = useState(false);
    const [requestPayload, setRequestPayload] = useState([]);
    const [isBlinking, setIsBlinking] = useState(false);
    const [blueCardText, setBlueCardText] = useState("Blue Card Push");
    const [openBlueCardSuccess, setOpenBlueCardSuccess] = useState(false);
    const [blueCardTimerStart, setBlueCardTimerStart] = useState(null);
    const [blueCardElapsed, setBlueCardElapsed] = useState(0);
    const blueCardTimerRef = useRef(null);
    const [routeCardNo, setRouteCardNo] = useState("");
    const [openReject, setOpenReject] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [existingCount, setExistingCount] = useState(0);
    const [rejectRows, setRejectRows] = useState([{ count: 0, reason: [], remark: "" }]);
    const [qualityReasonList, setQualityReasonList] = useState([]);
    const [rejectReasonSearch, setRejectReasonSearch] = useState("");
    const [isFetchingBluecard, setIsFetchingBluecard] = useState(false);
    const [prevOperatorData, setPrevOperatorData] = useState(null);
    // GPLAST only: { maxCount, count, reason, remark } while the already saved
    // operator rejection is being corrected. The count can only be lowered.
    const [editingPrevOperator, setEditingPrevOperator] = useState(null);
    const [isSavingPrevOperator, setIsSavingPrevOperator] = useState(false);
    const isValidRouteCard = /^[a-z0-9]+$/i.test(routeCardNo);
    const [openBlueCardResponse, setOpenBlueCardResponse] = useState(false);
    const [blueCardResponseData, setBlueCardResponseData] = useState(null);
    const prevRequestPayloadRef = useRef([]);
    const [isDark, setIsDark] = useState(() => localStorage.getItem('operatorTheme') === 'dark');


    useEffect(() => {
        document.body.setAttribute('data-theme', isDark ? 'dark' : 'light');
    }, [isDark]);

    const toggleTheme = () => {
        setIsDark(prev => {
            const next = !prev;
            localStorage.setItem('operatorTheme', next ? 'dark' : 'light');
            return next;
        });
    };

    const [keyboardEnabled, setKeyboardEnabled] = useState(() => localStorage.getItem('operatorKeyboardEnabled') !== 'false');

    const toggleKeyboard = () => {
        setKeyboardEnabled(prev => {
            const next = !prev;
            localStorage.setItem('operatorKeyboardEnabled', String(next));
            return next;
        });
    };

    const t = {
        bg: isDark ? '#22262e' : '#ffffff',
        bgCard: isDark ? '#2a2f3a' : '#f5f6fa',
        bgRow: isDark ? '#2a2f3a' : '#fafafa',
        text: isDark ? '#f1f5f9' : '#111827',
        textSub: isDark ? '#94a3b8' : '#6b7280',
        border: isDark ? '#334155' : '#e5e7eb',
        borderTable: isDark ? '#334155' : '#ccc',
        borderLight: isDark ? '#334155' : '#e0e0e0',
        borderRow: isDark ? '#334155' : '#f0f0f0',
        tableHeader: isDark ? '#2a2f3a' : '#f2f2f2',
        dialogContent: isDark ? '#22262e' : '#fff',
        headerBorder: isDark ? '#334155' : '#e8eaf0',
    };
    const [blueCardNotifications, setBlueCardNotifications] = useState([]);
    const [showBlueCardNotif, setShowBlueCardNotif] = useState(false);
    const prevComponentCodeRef = useRef(null);
    const notifBellRef = useRef(null);
    const [liveCompSelected, setLiveCompSelected] = useState('');
    const [liveCompSearch, setLiveCompSearch] = useState('');
    const [allocateCompModalOpen, setAllocateCompModalOpen] = useState(false);
    const [pendingCompValue, setPendingCompValue] = useState('');
    const [allocatingComp, setAllocatingComp] = useState(false);
    const [prevLiveComp, setPrevLiveComp] = useState(null);
    const prevShiftRef = useRef(null);
    const lastOperatorFetchRef = useRef(0);
    const lastShiftFetchRef = useRef(0);
    const shiftsCacheRef = useRef([]);
    const [currentMachinePlan, setCurrentMachinePlan] = useState(null);
    const getCustomerId = () => {
        const params = new URLSearchParams(location.search);
        const queryCustomerId = params.get('customer_id') || params.get('customer');
        if (queryCustomerId) {
            return queryCustomerId;
        } else if (location.pathname.endsWith("/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV")) {
            // Matches both the plain secret URL and the Plant-prefixed form
            // (/<plantSlug>/wP7n_...).
            return window._env_.CUSTOMER_ID;
        } else if (location.pathname === "/smc_operator_bf9tz") {
            return window._env_.SMC_CUSTOMER_ID;
        } else if (location.pathname === "/atech_operator_atc67") {
            return window._env_.ATECH_CUSTOMER_ID;
        } else if (location.pathname === "/marks_operator_ch8st") {
            return window._env_.MARKS_CUSTOMER_ID;
        } else if (location.pathname === "/makino_operator_av5tc") {
            return window._env_.MAKINO_CUSTOMER_ID;
        } else if (location.pathname === "/demo_operator_av3tc") {
            return window._env_.DEMO_CUSTOMER_ID;
        } else if (location.pathname === "/gplast_operator_awe6tc") {
            return window._env_.GPLAST_CUSTOMER_ID;
        } else if (location.pathname === "/operator_screen_biotek") {
            return window._env_.BIOTEK_CUSTOMER_ID;
        } else if (location.pathname === "/integra_operator_xw9kp") {
            return window._env_.INTEGRA_CUSTOMER_ID;
        } else {
            const customerIdStr = localStorage.getItem('CustomerID');
            try {
                return JSON.parse(customerIdStr);
            } catch (error) {
                console.error('Error parsing CustomerID from localStorage:', error);
                return customerIdStr;
            }
        }
    };

    // Optional device id in the URL (?device_id=... or ?device=...). When present
    // and it matches one of the customer's devices, the screen locks to that
    // machine and hides the machine dropdown. Absent or unknown → existing
    // behaviour is unchanged.
    const getUrlDeviceId = () => {
        const params = new URLSearchParams(location.search);
        const id = params.get('device_id') || params.get('device');
        return id ? id.trim() : null;
    };

    // Optional Plant code in the URL (?plant_code=...). When present and it
    // matches a configured Plant Group, the machine dropdown is narrowed to
    // that plant's machine groups' devices — lets a kiosk be physically
    // dedicated to one plant by appending this to its existing secret URL.
    // Absent, or naming an unknown plant, or the customer has no Plant Groups
    // configured → every device is offered, exactly as today.
    const getUrlPlantCode = () => {
        const params = new URLSearchParams(location.search);
        const code = params.get('plant_code');
        return code ? code.trim() : null;
    };

    // Same idea, but as a path segment ahead of the secret token instead of a
    // query string — e.g. /plant-a/wP7n_... — so a kiosk's whole URL reads
    // "plant, then token" the way the rest of the URL is host, then path.
    // Matched against a Plant Group's code OR a slugified version of its
    // name, since either could reasonably be typed into a kiosk's URL.
    const getUrlPlantSlug = () => (urlPlantSlugParam ? decodeURIComponent(urlPlantSlugParam).trim() : null);
    // Strips everything but letters/digits (not just collapsing to hyphens),
    // so "g-plant", "gplant" and "G Plant" all normalize the same way —
    // the URL segment need not match a Plant's configured code/name exactly.
    const slugify = (value) => (value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

    // The Plant this kiosk resolved to via the URL (?plant_code= or the
    // /<plantSlug>/ path segment) — set alongside the allowed-device Set
    // below, and read by fetchOperators() to narrow the Operator dropdown to
    // the same Plant. null whenever the kiosk isn't Plant-scoped.
    const resolvedPlantCodeRef = useRef(null);
    // The Cell (Machine Group) codes the resolved Plant grants — the primary
    // signal fetchOperators() filters on, since Userregistration now grants
    // an operator's Cells FROM their selected Plant (handlePlantAccessChange
    // there), the same cascade a Plant-scoped kiosk needs to reverse: show an
    // operator if one of their Cells belongs to this kiosk's Plant.
    const resolvedAllowedGroupCodesRef = useRef([]);
    // Raw ?plant_code=/plantSlug text when it doesn't match any configured
    // Plant Group — non-null here blocks the whole screen behind an "Unknown
    // plant" message instead of silently falling back to showing every
    // machine, since a kiosk parked under a mistyped plant URL shouldn't let
    // an operator pick devices from other plants.
    const [unknownPlantSlug, setUnknownPlantSlug] = useState(null);

    const resolvePlantAllowedDeviceNames = async (customerId) => {
        const plantCode = getUrlPlantCode();
        const plantSlug = getUrlPlantSlug();
        if (!plantCode && !plantSlug) {
            resolvedPlantCodeRef.current = null;
            resolvedAllowedGroupCodesRef.current = [];
            setUnknownPlantSlug(null);
            return null;
        }
        try {
            const [plantsRes, groupsRes] = await Promise.all([
                customerbasedshift(customerId, 'plantgroups'),
                customerbasedshift(customerId, 'machinegroups'),
            ]);
            const plantGroups = plantsRes?.[0]?.value || [];
            const machineGroups = groupsRes?.[0]?.value || [];
            const matchedPlant = plantGroups.find((p) =>
                (plantCode && p.code === plantCode) ||
                (plantSlug && (p.code === plantSlug || slugify(p.name) === slugify(plantSlug)))
            );
            if (!matchedPlant) {
                resolvedPlantCodeRef.current = null;
                resolvedAllowedGroupCodesRef.current = [];
                    setUnknownPlantSlug(plantSlug || plantCode);
                return null;
            }
            resolvedPlantCodeRef.current = matchedPlant.code;
            const allowedGroupCodes = matchedPlant.groupCodes || [];
            resolvedAllowedGroupCodesRef.current = allowedGroupCodes;
            setUnknownPlantSlug(null);
            const allowedNames = new Set();
            machineGroups
                .filter((g) => allowedGroupCodes.includes(g.code))
                .forEach((g) => (g.machines || []).forEach((m) => allowedNames.add(m)));
            return allowedNames;
        } catch (error) {
            console.error('Error resolving Plant-scoped devices:', error);
            resolvedPlantCodeRef.current = null;
            resolvedAllowedGroupCodesRef.current = [];
            setUnknownPlantSlug(null);
            return null;
        }
    };

    const isPMIBlueCardPage =
        location.pathname.endsWith("/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV") ||
        cleanCustomerId(getCustomerId()) === window._env_.CUSTOMER_ID;

    const isGplastCondition =
        location.pathname === "/gplast_operator_awe6tc" ||
        cleanCustomerId(getCustomerId()) === window._env_.GPLAST_CUSTOMER_ID;

    const isAtechCondition =
        location.pathname === "/atech_operator_atc67" ||
        cleanCustomerId(getCustomerId()) === window._env_.ATECH_CUSTOMER_ID ||
        cleanCustomerId(getCustomerId()) === window._env_.UNIJET_CUSTOMER_ID;

    const fetchDevices = async () => {
        try {
            const customerId = getCustomerId();
            const result = await customerbaseddevices(customerId, 1000, 0);
            const allDevicesList = result.data || [];
            const plantAllowedNames = await resolvePlantAllowedDeviceNames(customerId);
            const devicesList = plantAllowedNames
                ? allDevicesList.filter((d) => plantAllowedNames.has(d.name))
                : allDevicesList;
            setMachines(devicesList.map((d) => d.name).sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })));
            const nameIdMap = devicesList.reduce((acc, device) => {
                acc[device.name] = device.id.id;
                return acc;
            }, {});
            setDeviceNameIdJson(nameIdMap);
            const urlDeviceId = getUrlDeviceId();
            const urlMatch = urlDeviceId ? devicesList.find((d) => d.id.id === urlDeviceId) : null;
            const machineInfo = JSON.parse(localStorage.getItem("machineInfo"));
            if (urlMatch) {
                // Device id supplied in the URL — lock the screen to that machine
                // and skip the saved-machine / first-device selection entirely.
                // Not persisted to localStorage so it stays URL-scoped.
                setSelectedMachine(urlMatch.name);
            } else if (machineInfo?.machine_name && machineInfo?.machine_id) {
                setSelectedMachine(machineInfo.machine_name);
            } else if (devicesList.length > 0) {
                const savedMachine = localStorage.getItem("selectedMachine");
                if (savedMachine && devicesList.some((d) => d.name === savedMachine)) {
                    setSelectedMachine(savedMachine);
                } else {
                    const defaultMachine = devicesList[0].name;
                    setSelectedMachine(defaultMachine);
                    localStorage.setItem("selectedMachine", defaultMachine);
                }
            }
            const qualityResult = await customerbasedshift(customerId, "qualityreason");
            setQualityReasonList(qualityResult?.[0]?.value || []);
        } catch (err) {
            console.error("Failed to fetch devices", err);
        }
    };

    const formatDuration = (durationInSeconds) => {
        const hours = Math.floor(durationInSeconds / 3600);
        const minutes = Math.floor((durationInSeconds % 3600) / 60);
        const seconds = durationInSeconds % 60;
        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    };

    const formatEpochToIST = (epoch) => {
        const options = { timeZone: 'Asia/Kolkata' };
        const date = new Date(epoch).toLocaleString('en-US', options);
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = d.getFullYear();
        const hours = String(d.getHours()).padStart(2, '0');
        const minutes = String(d.getMinutes()).padStart(2, '0');
        const seconds = String(d.getSeconds()).padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };

    function getShiftEpoch(startTime = "06:00", endTime = "14:00") {
        const now = dayjs();
        const [startH, startM] = startTime.split(":").map(Number);
        const [endH, endM] = endTime.split(":").map(Number);
        let shiftStart = dayjs().hour(startH).minute(startM).second(0).millisecond(0);
        let shiftEnd = dayjs().hour(endH).minute(endM).second(0).millisecond(0);
        if (shiftEnd.isBefore(shiftStart)) {
            if (now.isBefore(shiftEnd)) {
                shiftStart = shiftStart.subtract(1, "day");
            } else {
                shiftEnd = shiftEnd.add(1, "day");
            }
        }
        const shiftStartEpoch = shiftStart.valueOf();
        const shiftEndEpoch = shiftEnd.valueOf();
        const nowEpoch = now.valueOf();
        const progress = Math.min(Math.max(((nowEpoch - shiftStartEpoch) / (shiftEndEpoch - shiftStartEpoch)) * 100, 0), 100);
        return { shiftStart: shiftStartEpoch, shiftEnd: shiftEndEpoch, now: nowEpoch, progress };
    }

    const statusText = (code) => {
        switch (code) {
            case 0:
            case 1:
            case 2:
                return "idle";
            case 3:
                return "running";
            case 5:
                return "alarm";
            case 100:
                return "disconnect";
            default:
                return "unknown";
        }
    };


    // const fetchOperators = async () => {
    //   try {
    //     let operatorList = [];

    //     if (location.pathname === "/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV") {
    //       const res = await customerbasedshift(getCustomerId(), "alloperator");
    //       const allData = res?.[0]?.value || [];
    //       operatorList = allData
    //         .filter(o => o?.mode?.toLowerCase() === 'operator')
    //         .map(op => ({ id: op.operatorid, name: op.operatorname }));
    //     } else {
    //       // 👤 From user list API
    //       const res = await getCustomerUsers(customerId1);
    //       const users = res.data || [];
    //       const parsedUsers = users.map(u => {
    //         let desc = "";
    //         try {
    //           desc = u.additionalInfo?.description
    //             ? JSON.parse(u.additionalInfo.description)
    //             : "";
    //         } catch {
    //           desc = u.additionalInfo?.description || "";
    //         }
    //         return { ...u, userDetails: desc };
    //       });

    //       operatorList = parsedUsers
    //         .filter(u => u.userDetails?.mode?.toLowerCase() === 'operator')
    //         .map(u => ({ id: u.userDetails?.userId, name: u.firstName }));
    //     }
    //     setOperators(operatorList);
    //   } catch (error) {
    //     console.error("Error fetching operators:", error);
    //     setOperators([]);
    //   }
    // };

    const fetchOperators = async () => {
        try {
            let operatorList = [];
            const res = await customerbasedshift(getCustomerId(), "alloperator");
            const allData = res?.[0]?.value || [];
            const seen = new Set();
            // Kiosk is scoped to a Plant (via the URL) — narrow the Operator
            // dropdown to operators assigned to that same Plant, same as the
            // machine dropdown is narrowed above. Unscoped kiosk (no Plant in
            // the URL) → every operator, exactly as before this filter existed.
            // Matches primarily on `groups` (Cell codes) since Userregistration
            // grants an operator's Cells FROM their selected Plant — that's the
            // cascade this reverses. `plant_code` is a secondary/direct signal
            // for operators saved via the older Operatorregistration page.
            const plantCode = resolvedPlantCodeRef.current;
            const allowedGroupCodes = resolvedAllowedGroupCodesRef.current;
            operatorList = allData
                .filter(o => o?.mode?.toLowerCase() === 'operator')
                .filter(o => {
                    if (!plantCode) return true;
                    const groupMatch = Array.isArray(o?.groups) && o.groups.some((g) => allowedGroupCodes.includes(g));
                    // plant_code is a single value for a one-Plant operator, or an
                    // array when they were saved with more than one Plant selected.
                    const plantMatch = Array.isArray(o?.plant_code) ? o.plant_code.includes(plantCode) : o?.plant_code === plantCode;
                    return groupMatch || plantMatch;
                })
                .map(op => ({ id: op.operatorid, name: op.operatorname }))
                .filter(op => {
                    const key = String(op.id);
                    if (seen.has(key)) return false;
                    seen.add(key);
                    return true;
                })
                .sort((a, b) => {
                    const numA = parseInt(a.id, 10);
                    const numB = parseInt(b.id, 10);
                    if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
                    return String(a.id).localeCompare(String(b.id));
                });
            setOperators(operatorList);
        } catch (error) {
            console.error("Error fetching operators:", error);
            setOperators([]);
        }
    };



    const fetchTelemetry = async (deviceId) => {
        try {
            const nowTs = Date.now();
            let shifts = shiftsCacheRef.current;
            if (!shifts.length || nowTs - lastShiftFetchRef.current >= 5 * 60 * 1000) {
                const response = await customerbasedshift(
                    getCustomerId(),
                    "allShift"
                );
                shifts = response[0]?.value || [];
                shiftsCacheRef.current = shifts;
                lastShiftFetchRef.current = nowTs;
                setShifts(shifts);
            }
            const currentActiveShift = await getCurrentShift(shifts, dayjs());
            const { shiftStart, now, shiftEnd } = getShiftEpoch(currentActiveShift?.start_time, currentActiveShift?.end_time);
            if (nowTs - lastOperatorFetchRef.current >= 5 * 60 * 1000) {
                lastOperatorFetchRef.current = nowTs;
                await fetchOperators();
            }
            const keysConfig = [
                { key: "machine_status", isJson: false },
                { key: "targetparts", isJson: false },
                { key: "totalparts", isJson: true },
                { key: "live_operator", isJson: true },
                { key: "live_component", isJson: true },
                { key: "operations", isJson: true },
                { key: "live_plan", isJson: true },
            ];
            const data = await getFirstMachineActive("DEVICE", deviceId, {
                keys: keysConfig.map(k => k.key).join(","),
                startTs: shiftStart || Date.now() - 3600000,
                endTs: shiftEnd || Date.now(),
            });
            const filteredData = {
                ...data,
                live_operator: (data.live_operator || []).filter(item => item.ts <= now),
                live_plan: (data.live_plan || []).filter(item => item.ts <= now),
            };
            const getLatest = (key, isJson = false) => {
                const arr = filteredData[key];
                if (!arr || arr.length === 0) return isJson ? {} : null;
                const value = arr[0].value;
                if (!isJson) return value;
                try {
                    return JSON.parse(value);
                } catch (err) {
                    console.error(`Error parsing JSON for key: ${key}`, err);
                    return {};
                }
            };
            const getLatestWithTs = (key, isJson = false) => {
                const arr = filteredData[key];
                if (!Array.isArray(arr) || arr.length === 0) return isJson ? {} : null;
                const value = arr[0];
                if (!isJson) return value;
                try {
                    return {
                        ts: value.ts,
                        value: JSON.parse(value.value)
                    };
                } catch (err) {
                    console.error(`Error parsing JSON for key: ${key}`, err);
                    return { ts: value.ts, value: null };
                }
            };
            // Picks the entry whose [start_time, end_time) window contains `atTs`,
            // instead of always taking the most-recently-written entry — entries can be
            // written out of chronological order (e.g. a job queued/logged ahead of time).
            const getEntryForTime = (key, atTs) => {
                const arr = filteredData[key];
                if (!Array.isArray(arr) || arr.length === 0) return { ts: null, value: {} };
                const parsed = arr
                    .map(item => {
                        try {
                            return { ts: item.ts, value: JSON.parse(item.value) };
                        } catch (err) {
                            console.error(`Error parsing JSON for key: ${key}`, err);
                            return null;
                        }
                    })
                    .filter(Boolean);
                const activeEntry = parsed.find(({ value }) =>
                    value?.start_time != null && value?.end_time != null &&
                    atTs >= value.start_time && atTs < value.end_time
                );
                if (activeEntry) return activeEntry;
                // No window contains `atTs` (e.g. gap between jobs) — fall back to the
                // most recently *started* entry rather than the most recently written one.
                const startedEntries = parsed.filter(({ value }) => value?.start_time != null && atTs >= value.start_time);
                if (startedEntries.length) {
                    return startedEntries.reduce((a, b) => (a.value.start_time > b.value.start_time ? a : b));
                }
                return parsed[0];
            };
            const machineStatusArray = filteredData.machine_status || [];
            const latestStatusCode = parseInt(machineStatusArray[0]?.value || 0, 10);
            const machineStatus = statusText(latestStatusCode);
            const firstActive = machineStatusArray
                .slice()
                .reverse()
                .find(item => item.value === "3")?.ts || null;
            const statusColor =
                machineStatus.toLowerCase() === "running"
                    ? "#3DA06A"
                    : machineStatus.toLowerCase() === "idle"
                        ? "#DD6B20"
                        : machineStatus.toLowerCase() === "alarm"
                            ? "#E53E3E"
                            : machineStatus.toLowerCase() === "disconnect"
                                ? "#808080"
                                : "#ccc";
            const targetParts = parseInt(getLatest("targetparts") || 0, 10);
            const totalParts = getLatest("totalparts", true);
            const { totalshots = 0, goodparts = 0, scrap = 0, ncr = 0 } = totalParts;
            const livePlan = getLatest("live_plan", true);
            const liveComponentEntry = getEntryForTime("live_component", now);
            const liveComponent = liveComponentEntry.value || {};
            const operations = getLatest("operations", true);
            const livePlanTs = filteredData.live_plan?.[0]?.ts || null;
            const liveComponentTs = liveComponentEntry.ts || null;
            const operationsTs = filteredData.operations?.[0]?.ts || null;
            const shouldUseGplastPlan = isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceId);
            const jobName = (shouldUseGplastPlan ? livePlan.name : liveComponent.name) || "Route card not assigned";
            const jobCode = (shouldUseGplastPlan ? livePlan.code : liveComponent.code) || "";
            const liveOperator = getLatestWithTs("live_operator", true);
            const liveOperatorCode = liveOperator?.value?.code || null;
            setTelemetry({
                machineStatus,
                machineColor: statusColor,
                firstActive,
                targetParts,
                totalShots: totalshots,
                goodParts: goodparts,
                scrap,
                ncr,
                jobName,
                jobCode,
                livePlan,
                livePlanTs,
                liveComponent,
                liveComponentTs,
                operations,
                operationsTs,
                liveOperatorCode,
                liveOperator
            });
            if (liveOperator?.value) {
                setCurrentOperator({ ...liveOperator.value, ts: liveOperator.ts });
            }
            return filteredData;
        } catch (err) {
            console.error("Telemetry fetch failed", err);
        }
    };

    const getCurrentShift = (allShifts, selectedDate = dayjs()) => {
        const now = dayjs(selectedDate);
        for (let shift of allShifts) {
            const [startH, startM, startS = 0] = shift.start_time.split(":").map(Number);
            const [endH, endM, endS = 0] = shift.end_time.split(":").map(Number);
            let start = dayjs(now).hour(startH).minute(startM).second(startS).millisecond(0);
            let end = dayjs(now).hour(endH).minute(endM).second(endS).millisecond(0);
            if (end.isBefore(start)) {
                if (now.isBefore(end)) {
                    start = start.subtract(1, "day");
                } else {
                    end = end.add(1, "day");
                }
            }
            if (now.isAfter(start) && now.isBefore(end)) {
                return shift;
            }
        }
        return null;
    };

    const fetchReasonGroups = async () => {
        const key = "reasongroups";
        try {
            const customerId = getCustomerId();
            const data = await customerbasedshift(customerId, key);
            const allReasonGroups = Array.isArray(data?.[0]?.value)
                ? data[0].value
                : [];
            const mappedGroups = allReasonGroups.map(item => ({
                value: item.groupName || item.name || "",
                label: item.groupName || item.name || "",
            }));
            setReasonGroupOptions(mappedGroups);
            return mappedGroups;
        } catch (error) {
            console.error("❌ Error fetching reason groups:", error);
            setReasonGroupOptions([]);
            return [];
        }
    };

    const downtimereason = async ({ shiftNo, selectedDate, fromEpoch, toEpoch, deviceId }) => {
        if (!deviceId || !shiftNo || !selectedDate || !fromEpoch || !toEpoch) return [];
        await fetchReasonGroups()
        const fromTime = fromEpoch;
        const toTime = toEpoch;

        try {
            const machineStatusResponse = await telemetrykeydata(deviceId, "DEVICE", "machine_status", fromTime, toTime);
            const machineData = machineStatusResponse?.machine_status || [];

            const sortedData = [...machineData].sort((a, b) => Number(a.ts) - Number(b.ts));
            const transformedData = sortedData
                .filter(item => item.ts && item.value !== undefined)
                .map(item => ({ ts: item.ts, value: Number(item.value) }));
            const IDLE_START_CODES = [0, 1, 2];
            const IDLE_END_CODES = [3, 4, 5, 100];

            const extractIdleSegments = (data) => {
                const result = [];
                let recording = false;
                let segment = { start: null, value: null };

                for (let i = 0; i < data.length; i++) {
                    const current = data[i];
                    const val = current.value;

                    if (!recording && IDLE_START_CODES.includes(val)) {
                        segment.start = current.ts;
                        segment.value = val;
                        recording = true;
                    }

                    if (recording && IDLE_END_CODES.includes(val)) {
                        segment.end = current.ts;
                        const duration = Math.floor((segment.end - segment.start) / 1000);
                        result.push({
                            start: segment.start,
                            end: segment.end,
                            duration,
                            value: segment.value,
                            status: "IDLE",
                        });
                        recording = false;
                        segment = { start: null, value: null };
                    }

                    if (recording && IDLE_START_CODES.includes(val)) {
                        segment.value = val;
                    }
                }

                if (recording) {
                    const lastKnownTs = data.length > 0 ? data[data.length - 1].ts : fromTime;
                    const now = Date.now();
                    const safeEnd = Math.min(toTime, now, lastKnownTs);
                    segment.end = safeEnd;
                    const duration = Math.floor((segment.end - segment.start) / 1000);
                    result.push({
                        start: segment.start,
                        end: segment.end,
                        duration,
                        value: segment.value,
                        status: "IDLE",
                        // No IDLE_END event closed this segment, so its idle_end isn't
                        // real (the source reason has idle_end: 0). Mark it open so the
                        // save skips it — only patch reasons with a real start AND end.
                        open: true,
                    });
                }

                return result.length > 0
                    ? result
                    : [{ start: fromTime, end: toTime, duration: 0, value: 0, status: "NO_DATA" }];
            };

            const key = "downtime_threasold";
            const results = await Deviceattributeget(deviceId, key);
            let filteredResult = [];
            if (results && results.length > 0) {
                const downtime = results[0].value;
                const extracted = extractIdleSegments(transformedData);
                filteredResult = extracted.filter(entry => entry.duration > downtime);
            }

            const response = await telemetrykeydata(deviceId, "DEVICE", "live_reason", fromEpoch, toEpoch);
            if (response?.live_reason?.length > 0) {
                const parsedLiveReasons = response.live_reason
                    .map(entry => {
                        try { return { ts: entry.ts, ...JSON.parse(entry.value) }; }
                        catch { return null; }
                    })
                    .filter(reason => reason);

                const unusedLiveReasons = [...parsedLiveReasons];

                filteredResult = filteredResult.map(item => {
                    const index = unusedLiveReasons.findIndex(reason => {
                        const reasonStart = Number(reason.idle_start);
                        const reasonEnd = reason.idle_end && reason.idle_end !== 0 ? Number(reason.idle_end) : reasonStart;
                        return reasonStart <= item.end && reasonEnd >= item.start;
                    });
                    let reasonName = "";
                    let reasonGroup = "";
                    let matchedIdleEnd = item.matchedIdleEnd;
                    if (index !== -1) {
                        reasonName = unusedLiveReasons[index].name;
                        // Remember the matched record's idle_end. If it's 0 the reason is
                        // still open, and the save must leave it untouched (don't close it).
                        matchedIdleEnd = Number(unusedLiveReasons[index].idle_end) || 0;
                        const matchedReason = reasonsList2.find(
                            r =>
                                r.reason?.toLowerCase() === reasonName?.toLowerCase() ||
                                r.code?.toString() === unusedLiveReasons[index].code?.toString()
                        );
                        // GPLAST only: "Unknown" reasons default to no group selected
                        // rather than inheriting whatever group was previously saved/matched.
                        const isUnknownGplast = getCustomerId() === window._env_.GPLAST_CUSTOMER_ID
                            && reasonName?.trim().toLowerCase() === "unknown";
                        reasonGroup = isUnknownGplast ? "" : (matchedReason?.group || "");
                        unusedLiveReasons.splice(index, 1);
                    }

                    return {
                        ...item,
                        groupselected: reasonGroup,
                        reasonselected: reasonName || item.reasonselected || "",
                        matchedIdleEnd
                    };
                });

            }
            return filteredResult;
        } catch (error) {
            console.error("Error fetching downtime data:", error);
            return [];
        }
    };

    const handleGroupChange = (index, selectedGroup) => {
        setfilteredResult(prev => {
            const updated = [...prev];
            updated[index].groupselected = selectedGroup;
            updated[index].reasonselected = "";
            return updated;
        });
    };
    const [firstMachineActive, setFirstMachineActive] = useState(null);

    useEffect(() => {
        let timer;
        let interval;

        const getAllShifts = async () => {
            try {
                if (!Object.keys(deviceNameIdJson).length) {
                    await fetchDevices();
                }

                const response = await customerbasedshift(
                    getCustomerId(),
                    "allShift"
                );
                const shifts = response[0]?.value || [];
                setShifts(shifts);
                const currentActiveShift = await getCurrentShift(shifts, dayjs());
                if (!currentActiveShift) return;

                const formattedShift = {
                    ...currentActiveShift,
                    start_time: currentActiveShift.start_time.slice(0, 5),
                    end_time: currentActiveShift.end_time.slice(0, 5),
                };
                setCurrentShift(formattedShift);
                setSelectedShift(currentActiveShift.shift_no);
                const startTime = dayjs(`${dayjs().format("YYYY-MM-DD")} ${formattedShift.start_time}`, "YYYY-MM-DD HH:mm");
                let endTime = dayjs(`${dayjs().format("YYYY-MM-DD")} ${formattedShift.end_time}`, "YYYY-MM-DD HH:mm");
                if (currentActiveShift.start_day !== currentActiveShift.end_day) {
                    endTime = endTime.add(1, "day");
                }

                const now = dayjs();
                const jitter = Math.floor(Math.random() * 8000); // re-randomized every call, spreads all kiosks out
                const delay = endTime.diff(now) + jitter;

                if (delay > 0) {
                    timer = setTimeout(() => {
                        getAllShifts();
                    }, delay);
                }
            } catch (err) {
                console.error("Error in getAllShifts:", err);
            }
        };

        getAllShifts();

        interval = setInterval(() => {
            getAllShifts();
        }, 60 * 1000);

        return () => {
            clearTimeout(timer);
            clearInterval(interval);
        };
    }, [selectedMachine]);

    const getShiftDate = (shift) => {
        const now = new Date();
        const [startH, startM] = shift.start_time.split(':').map(Number);
        const [endH, endM] = shift.end_time.split(':').map(Number);
        const nowMins = now.getHours() * 60 + now.getMinutes();
        const startMins = startH * 60 + startM;
        const endMins = endH * 60 + endM;
        // Midnight-crossing shift: end time is earlier than start time (e.g. 22:00 → 06:00)
        const isMidnightShift = endMins <= startMins;
        const startDay = Number(shift.start_day || 1);
        const shiftDate = new Date(now);
        if (startDay > 1) {
            // Shift starts on Day 2 of operational day (e.g. 01:00 → 08:00 with start_day: 2)
            shiftDate.setDate(shiftDate.getDate() - (startDay - 1));
        } else if (isMidnightShift && nowMins < endMins) {
            // We're in the early-morning portion — shift started yesterday
            shiftDate.setDate(shiftDate.getDate() - 1);
        }
        const yyyy = shiftDate.getFullYear();
        const mm = String(shiftDate.getMonth() + 1).padStart(2, '0');
        const dd = String(shiftDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const planDate = currentShift ? getShiftDate(currentShift) : null;

    useEffect(() => {
        if (!selectedMachine || !currentShift?.shift_no || !planDate) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const shouldUseGplastPlan = isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceId);
        if (!shouldUseGplastPlan) return;
        const fetchCurrentMachinePlan = async () => {
            try {
                const credential = isGplastCondition ? "gd" : "gd";
                await getReportToken(credential, credential);
                const data = await getCurrentMachinePlan(selectedMachine, currentShift.shift_no, planDate);
                const planList = Array.isArray(data) ? data : (data?.plans || []);
                setCurrentMachinePlan(planList);
                console.log('Current machine plan:', planList);
            } catch (err) {
                console.error('Error fetching current machine plan:', err);
            }
        };
        fetchCurrentMachinePlan();
    }, [selectedMachine, currentShift?.shift_no, planDate]);

    const openDownTime = async (devicename, deviceid) => {
        const customerId = getCustomerId();
        setLoading(true);
        try {
            const [reasonsData, shiftsData] = await Promise.all([
                customerbasedshift(customerId, "reason"),
                customerbasedshift(customerId, "allShift"),
            ]);
            const allReasons = reasonsData[0]?.value || [];
            setreasonslist(allReasons);
            setreasons(allReasons.map(r => ({ value: r.reason, label: r.reason, group: r.group || "" })));
            const allShifts = shiftsData[0]?.value || [];
            setShifts(allShifts);
            const options = allShifts.map(shift => ({
                value: shift.shift_no,
                label: `Shift${shift.shift_no}`,
            }));
            setShiftOptions(options);
            setSelectedDeviceId(deviceid);
            setSelectedDate(dayjs());
            setfilteredResult([]);
            const currentShift = getCurrentShift(allShifts);
            let chosenShiftNo = currentShift?.shift_no || (options.length > 0 ? options[0].value : null);
            if (chosenShiftNo) {
                setSelectedShift(chosenShiftNo);
                const { shiftStart: fromEpoch, now: toEpoch } = getShiftEpoch(currentShift?.start_time);
                setEpochRange({ from: fromEpoch, to: toEpoch });
                const data = await downtimereason({
                    shiftNo: chosenShiftNo,
                    selectedDate: dayjs(),
                    fromEpoch,
                    toEpoch,
                    deviceId: deviceid,
                });
                console.log([...data].reverse(), 'data table')
                setfilteredResult([...data].reverse());
                setopenDownTimeModal(true);
            } else {
                console.warn("⚠️ No active shift found right now");
            }
        } catch (err) {
            console.error("Error in openDownTime:", err);
        } finally {
            setLoading(false);
        }
    };


    const [reasonsList2, setReasonsList2] = useState([])

    useEffect(() => {
        const getReasons = async () => {
            try {
                const response = await customerbasedshift(getCustomerId(), "reason");
                const reasons = response?.[0]?.value || [];
                // Keep the SAME array reference when the content is unchanged. reasonsList2
                // is a dependency of the lock/WebSocket effect; a fresh reference every 5s
                // was tearing that effect down and reconnecting the WS each tick, which made
                // the status header glitch. Only push a new reference on a real change (which
                // still triggers the one re-run the reason-deferral fix relies on).
                setReasonsList2(prev =>
                    Array.isArray(prev) && JSON.stringify(prev) === JSON.stringify(reasons)
                        ? prev
                        : reasons
                );
            } catch (err) {
                console.error("Error fetching reasons:", err);
            }
        };
        getReasons();
        const interval = setInterval(getReasons, 5000);
        return () => clearInterval(interval);
    }, []);

    const [idleStartTime, setIdleStartTime] = useState(null);

    // near top of component

    // near top of component
    // --- refs only ---
    const prevStatusRef = useRef(null);
    const lockedIdleStartRef = useRef(null);
    const activeReasonRef = useRef(null);
    const isLockedRef = useRef(false);
    const isConfirmingRef = useRef(false);
    const prevMachineRef = useRef(null); // tracks the last selected machine to detect real switches

    // Reliable-delivery queue state (drives the "reconnecting / unlocking" banner).
    const [reliableStatus, setReliableStatus] = useState({ pending: 0, online: true, processing: false, oldestAttempts: 0 });
    useEffect(() => subscribeReliableQueue(setReliableStatus), []);

    // Persistent server-status indicator in the header.
    // 'online'  = browser online AND ThingsBoard reachable
    // 'offline' = browser has no network
    // 'server-down' = browser online but TB not responding
    const [netStatus, setNetStatus] = useState('online');
    useEffect(() => {
        let cancelled = false;
        let timer = null;
        const check = async () => {
            const tbUp = await checkServerHealth();
            if (!cancelled) {
                if (tbUp) {
                    setNetStatus('online');
                } else {
                    // TB didn't answer. navigator.onLine is unreliable on some HMI
                    // browsers, so actively probe the internet to tell the two apart:
                    //   internet reachable  -> TB itself is down  ('server-down')
                    //   internet unreachable -> no network at all ('offline')
                    const net = await checkInternet();
                    if (!cancelled) setNetStatus(net ? 'server-down' : 'offline');
                }
            }
            if (!cancelled) timer = setTimeout(check, 20000); // re-check every 20s
        };
        const goOffline = () => { if (!cancelled) setNetStatus('offline'); };
        const goOnline = () => check(); // re-verify TB immediately on reconnect
        window.addEventListener('online', goOnline);
        window.addEventListener('offline', goOffline);
        check();
        return () => {
            cancelled = true;
            if (timer) clearTimeout(timer);
            window.removeEventListener('online', goOnline);
            window.removeEventListener('offline', goOffline);
        };
    }, []);

    // Watchdog: self-heal a wedged delivery. Every minute, re-flush the queue; if an
    // unlock has been stuck through many retries (several minutes) and the operator is
    // not mid-action (no dialog open), soft-reload to clear any wedged WS/JS state.
    // The queue persists in localStorage, so delivery resumes automatically after reload.
    // Device-agnostic and safe on kiosks, tablets and monitors alike.
    useEffect(() => {
        const STUCK_ATTEMPTS = 40;            // ~10 min of continuous failed retries
        const RELOAD_THROTTLE_MS = 10 * 60000; // reload at most once per 10 min
        const LAST_RELOAD_KEY = "reliableWatchdogLastReload";
        const check = () => {
            const st = getReliableQueueState();
            if (st.pending > 0) {
                // Keep pushing regardless — retry alone delivers a 10-min outage once TB returns.
                flushReliableQueue();
                // Reload is only a last resort to clear wedged WS/JS state after a very long
                // stall. Throttle it so a sustained outage can't cause a reload loop.
                const now = Date.now();
                const lastReload = Number(localStorage.getItem(LAST_RELOAD_KEY) || 0);
                if (
                    st.oldestAttempts >= STUCK_ATTEMPTS &&
                    !Swal.isVisible() &&
                    now - lastReload > RELOAD_THROTTLE_MS
                ) {
                    localStorage.setItem(LAST_RELOAD_KEY, String(now));
                    console.warn("[watchdog] delivery stuck; reloading to recover (queue persists)");
                    window.location.reload();
                }
            }
        };
        const iv = setInterval(check, 60000);
        return () => clearInterval(iv);
    }, []);

    // On mount, restore any locked idle info from localStorage
    useEffect(() => {
        const savedLockedIdleStart = localStorage.getItem("lockedIdleStartTime");
        const savedActiveReason = localStorage.getItem("activeReason");

        if (savedLockedIdleStart && savedActiveReason) {
            lockedIdleStartRef.current = Number(savedLockedIdleStart);
            activeReasonRef.current = JSON.parse(savedActiveReason);
            isLockedRef.current = true;
            console.log("[INIT] restored locked idle from storage", savedLockedIdleStart, savedActiveReason);
        }
    }, []);

    // Standalone close-writer for a device that's about to stop being watched (the
    // operator is switching away from it). Same logic as the closeIdlePeriod defined
    // inside each per-machine effect, duplicated here because this runs from the
    // machine-switch effect below, independent of those. Without this, switching away
    // from a machine mid-lock stops that machine's WS/poll/self-heal entirely (its
    // effect tears down) while still clearing the shared refs — leaving its open
    // reason unmonitored until the operator happens to reselect it later.
    const flushDeviceIdlePeriod = async (deviceId, idleStart, reasonFields) => {
        if (!deviceId || !idleStart || !reasonFields) return false;
        const IDLE_END_CODES = ["3", "4", "5", "100"];
        try {
            const history = await telemetrykeydata(deviceId, "DEVICE", "machine_status", idleStart, Date.now());
            const samples = (history?.machine_status || [])
                .map(item => ({ ts: item.ts, value: Number(item.value) }))
                .sort((a, b) => a.ts - b.ts);
            const transition = samples.find(s => s.ts > idleStart && IDLE_END_CODES.includes(String(s.value)));
            if (!transition) return false; // still genuinely open

            const idleEndTime = transition.ts;
            const parsedShifts = generateShiftInstances(idleStart, idleEndTime, shifts);
            const splitSegments = splitIdleByShifts(idleStart, idleEndTime, parsedShifts);
            const segmentsToWrite = splitSegments.length > 0
                ? splitSegments
                : [{ start: idleStart, end: idleEndTime }];
            for (const seg of segmentsToWrite) {
                await operatorTelemetry("DEVICE", deviceId, {
                    ts: seg.start,
                    values: {
                        live_reason: {
                            name: reasonFields.name || "",
                            code: reasonFields.code || "",
                            mode: reasonFields.mode || "",
                            category: reasonFields.category || "",
                            group: reasonFields.group || null,
                            idle_start: seg.start,
                            idle_end: seg.end,
                            idle_duration: Math.floor((seg.end - seg.start) / 1000),
                        },
                    },
                });
            }
            console.log("[CLOSE-IDLE-ON-SWITCH] closed", deviceId, idleStart, "->", idleEndTime);
            return true;
        } catch (e) {
            console.error("[CLOSE-IDLE-ON-SWITCH] failed:", e);
            return false;
        }
    };

    // When the operator switches to a DIFFERENT machine, clear the previous machine's
    // lock state so it can't leak into the newly selected one — a leftover popup, a
    // stuck isLockedRef that blocks the new machine's lock detection, or (GPLast, whose
    // idle-close has no isLockedRef guard) the close posting the old reason to the new
    // device. Guarded on prevMachineRef so the initial selection (and the mount-time
    // localStorage restore above) is preserved — this only fires on a real A→B switch.
    useEffect(() => {
        if (!selectedMachine) return;
        if (prevMachineRef.current && prevMachineRef.current !== selectedMachine) {
            // Best-effort flush of the OLD machine's still-open reason before its own
            // effect tears down and stops watching it entirely. Fire-and-forget: the
            // switch itself shouldn't wait on a network round trip, and if the
            // transition hasn't happened yet this correctly finds nothing to close.
            const oldDeviceId = deviceNameIdJson[prevMachineRef.current];
            const staleIdleStart = lockedIdleStartRef.current;
            const staleReason = activeReasonRef.current;
            if (oldDeviceId && staleIdleStart && staleReason) {
                flushDeviceIdlePeriod(oldDeviceId, staleIdleStart, {
                    name: staleReason.reason || staleReason.name,
                    code: staleReason.code,
                    mode: staleReason.mode,
                    category: staleReason.category,
                    group: staleReason.group,
                }).then(closed => {
                    if (closed) {
                        localStorage.removeItem("lockedIdleStartTime");
                        localStorage.removeItem("activeReason");
                    }
                });
            }
            isLockedRef.current = false;
            isSwalOpenRef.current = false;
            lockedIdleStartRef.current = null;
            activeReasonRef.current = null;
            setIsLocked(false);
            Swal.close();
            console.log(`[MACHINE SWITCH] ${prevMachineRef.current} -> ${selectedMachine}; cleared previous lock state`);
        }
        prevMachineRef.current = selectedMachine;
    }, [selectedMachine]);


    function parseShifts(allShifts) {
        return allShifts.map(shift => {
            const today = dayjs();
            const startDayOffset = shift.start_day - 1;
            const endDayOffset = shift.end_day - 1;
            let startTs = dayjs(today)
                .startOf("day")
                .add(startDayOffset, "day")
                .hour(Number(shift.start_time.split(":")[0]))
                .minute(Number(shift.start_time.split(":")[1]))
                .second(Number(shift.start_time.split(":")[2]));
            let endTs = dayjs(today)
                .startOf("day")
                .add(endDayOffset, "day")
                .hour(Number(shift.end_time.split(":")[0]))
                .minute(Number(shift.end_time.split(":")[1]))
                .second(Number(shift.end_time.split(":")[2]));
            if (endTs.isBefore(startTs)) {
                endTs = endTs.add(1, "day");
            }
            return {
                shift_no: shift.shift_no,
                startTs: startTs.valueOf(),
                endTs: endTs.valueOf(),
            };
        });
    }

    function splitIdleByShifts(idleStart, idleEnd, shifts) {
        const segments = [];
        shifts.forEach((shift) => {
            const overlapStart = Math.max(idleStart, shift.startTs);
            const overlapEnd = Math.min(idleEnd, shift.endTs);
            if (overlapStart < overlapEnd) {
                segments.push({
                    shift_no: shift.shift_no,
                    start: overlapStart,
                    end: overlapEnd
                });
            }
        });

        return segments;
    }

    useEffect(() => {
        const customerId = getCustomerId();
        if (cleanCustomerId(customerId) === window._env_.GPLAST_CUSTOMER_ID) return;
        if (!selectedMachine || !deviceNameIdJson[selectedMachine]) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const openReasonSwal = (idleStart, reasonsList2, previousReason = null) => {
            if (isSwalOpenRef.current) return;
            isSwalOpenRef.current = true;

            const selectedReasonRef = { current: previousReason };
            const SwalContent = () => {
                const [reasonId, setReasonId] = React.useState(selectedReasonRef.current?.id || "");
                const [reasonMenuOpen, setReasonMenuOpen] = React.useState(false);
                const [reasonSearch, setReasonSearch] = React.useState("");
                React.useEffect(() => {
                    const matched = reasonsList2.find(r => r.id === reasonId);
                    selectedReasonRef.current = matched || null;
                }, [reasonId]);
                const filteredReasons = reasonsList2.filter((r) =>
                    r.reason?.toLowerCase().includes(reasonSearch.toLowerCase())
                );
                return (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, textAlign: "left" }}>
                        <p>Machine has been locked due to downtime threshold reached.</p>
                        <FormControl fullWidth size="small">
                            <InputLabel id="reason-select-label">Select Reason</InputLabel>
                            <Select
                                labelId="reason-select-label"
                                id="reason"
                                value={reasonId}
                                label="Select Reason"
                                open={reasonMenuOpen}
                                onOpen={() => setReasonMenuOpen(true)}
                                onClose={() => { setReasonMenuOpen(false); setReasonSearch(""); }}
                                onChange={(e) => setReasonId(e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        className: "operator-select-menu",
                                        style: {
                                            maxHeight: "40vh",
                                        },
                                    },
                                    anchorOrigin: { vertical: "top", horizontal: "left" },
                                    transformOrigin: { vertical: "bottom", horizontal: "left" },
                                    autoFocus: false,
                                }}
                            >
                                <MenuItem
                                    disableRipple
                                    onKeyDown={(e) => e.stopPropagation()}
                                    sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                >
                                    <TextField
                                        size="small"
                                        placeholder="Search reason…"
                                        value={reasonSearch}
                                        onChange={(e) => setReasonSearch(e.target.value)}
                                        autoFocus
                                        fullWidth
                                        onClick={(e) => e.stopPropagation()}
                                        autoComplete="off"
                                        sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                    />
                                </MenuItem>
                                <MenuItem value="">
                                    <em>-- Select --</em>
                                </MenuItem>
                                {filteredReasons.map((r) => (
                                    <MenuItem key={r.id} value={r.id}>
                                        {r.reason}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                );
            };

            Swal.fire({
                icon: "info",
                title: "Machine Locked",
                html: '<div id="swal-root"></div>',
                showConfirmButton: true,
                confirmButtonText: "Submit",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    const container = document.getElementById("swal-root");
                    if (container) {
                        ReactDOMClient.createRoot(container).render(<SwalContent />);
                    }
                },
                preConfirm: () => {
                    if (!selectedReasonRef.current) {
                        Swal.showValidationMessage("Please select a reason");
                        return false;
                    }
                    return selectedReasonRef.current;
                },
            }).then(result => {
                if (result.isConfirmed && result.value) {
                    const selectedReason = result.value;
                    activeReasonRef.current = selectedReason;
                    localStorage.setItem("lockedIdleStartTime", idleStart);
                    localStorage.setItem("activeReason", JSON.stringify(selectedReason));

                    isConfirmingRef.current = true;
                    Swal.fire({
                        icon: "question",
                        title: "Confirm Submission",
                        text: `You selected: ${selectedReason.reason}. Do you want to confirm?`,
                        showCancelButton: true,
                        confirmButtonText: "Yes, Submit",
                        cancelButtonText: "No, Go Back",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then(async confirmResult => {
                        isConfirmingRef.current = false;
                        isSwalOpenRef.current = false;
                        if (confirmResult.isConfirmed) {
                            const payload = {
                                ts: idleStart,
                                values: {
                                    live_reason: {
                                        name: selectedReason.reason,
                                        code: selectedReason.code || "",
                                        mode: selectedReason.mode || "",
                                        category: selectedReason.category || "",
                                        idle_start: idleStart,
                                        idle_end: 0,
                                        idle_duration: 0,
                                    },
                                },
                            };
                            // Queue reason + unlock for guaranteed delivery. The queue
                            // retries indefinitely until ThingsBoard acknowledges, so a
                            // network/TB outage can no longer drop the unlock. isLockedRef
                            // stays true until delivery is confirmed (onDelivered).
                            enqueueReasonUnlock({
                                deviceId,
                                reasonPayload: payload,
                                onDelivered: () => {
                                    isLockedRef.current = false;
                                    console.log("[LOCKED_IDLE] reason+unlock delivered to server");
                                },
                            });
                            setIsLocked(false); // reason submitted → hide the manual reopen button
                            // Only unlock locally when the cloud path is unreachable (offline
                            // or TB WS down). When online + connected, the queued cloud unlock
                            // drives Node-RED normally, so we skip the local call.
                            if (!navigator.onLine || !tbWs.isConnected()) {
                                sendLocalUnlock(deviceId, selectedReason, idleStart);
                            }
                            Swal.fire({
                                icon: "success",
                                title: "Reason Saved",
                                text: "Reason saved. Unlocking the machine…",
                                timer: 1500,
                                showConfirmButton: false,
                            });
                        } else {
                            openReasonSwal(idleStart, reasonsList2, selectedReason);
                        }
                    });
                } else {
                    isSwalOpenRef.current = false;
                }
            });
        };

        const IDLE_START_CODES = ["0", "1", "2"];
        const IDLE_END_CODES = ["3", "4", "5", "100"];
        const wsStatusRef = { current: null };

        // Shared close-writer: given an idle_start + reason, checks machine_status
        // history for a transition past idle_start and, if found, writes the real
        // idle_end/idle_duration (split across shift boundaries, same as the regular
        // auto-close in refreshData below). Reused at every point that can race the
        // regular 5s poll — a new lock cycle starting before the old one closed, an
        // unlock firing, or a tab restore — so none of them have to wait on the poll
        // to catch a transition that's already happened. Temporary, frontend-only
        // mitigation until the backend reconciliation service is live.
        const closeIdlePeriod = async (idleStart, reasonFields) => {
            if (!idleStart || !reasonFields) return false;
            try {
                const history = await telemetrykeydata(deviceId, "DEVICE", "machine_status", idleStart, Date.now());
                const samples = (history?.machine_status || [])
                    .map(item => ({ ts: item.ts, value: Number(item.value) }))
                    .sort((a, b) => a.ts - b.ts);
                const transition = samples.find(s => s.ts > idleStart && IDLE_END_CODES.includes(String(s.value)));
                if (!transition) return false; // still genuinely open — nothing to do

                const idleEndTime = transition.ts;
                const parsedShifts = generateShiftInstances(idleStart, idleEndTime, shifts);
                const splitSegments = splitIdleByShifts(idleStart, idleEndTime, parsedShifts);
                const segmentsToWrite = splitSegments.length > 0
                    ? splitSegments
                    : [{ start: idleStart, end: idleEndTime }];
                for (const seg of segmentsToWrite) {
                    await operatorTelemetry("DEVICE", deviceId, {
                        ts: seg.start,
                        values: {
                            live_reason: {
                                name: reasonFields.name || "",
                                code: reasonFields.code || "",
                                mode: reasonFields.mode || "",
                                category: reasonFields.category || "",
                                idle_start: seg.start,
                                idle_end: seg.end,
                                idle_duration: Math.floor((seg.end - seg.start) / 1000),
                            },
                        },
                    });
                }
                console.log("[CLOSE-IDLE] closed", idleStart, "->", idleEndTime);
                return true;
            } catch (e) {
                console.error("[CLOSE-IDLE] failed:", e);
                return false;
            }
        };

        const handleLockDetected = async () => {
            if (isLockedRef.current) return;
            // Don't open the popup until the reason list has loaded, or the dropdown is
            // empty. We deliberately DON'T latch isLockedRef here — reasonsList2 is an
            // effect dependency, so when it populates the effect re-runs and this fires
            // again with reasons present. Self-heals within the first fetch; no refresh.
            if (!reasonsList2 || reasonsList2.length === 0) {
                console.log("[WS] lock detected but reasons not loaded yet — deferring popup");
                return;
            }
            isLockedRef.current = true;
            console.log("[WS] lock detected, fetching machine history");
            // Flush a still-open PREVIOUS idle period before starting this new one.
            // Without this, a machine that flaps idle->alarm->idle (or similar)
            // before the previous unlock's delivery confirms overwrites
            // lockedIdleStartRef/activeReasonRef here, orphaning the old period's
            // idle_end forever — this was the dominant cause of stuck idle_end: 0
            // entries. Best-effort: if the transition can't be found yet, the
            // periodic self-heal sweep below will retry it later.
            if (lockedIdleStartRef.current && activeReasonRef.current) {
                const staleIdleStart = lockedIdleStartRef.current;
                const staleReason = activeReasonRef.current;
                const closed = await closeIdlePeriod(staleIdleStart, {
                    name: staleReason.reason || staleReason.name,
                    code: staleReason.code,
                    mode: staleReason.mode,
                    category: staleReason.category,
                });
                if (closed) {
                    localStorage.removeItem("lockedIdleStartTime");
                    localStorage.removeItem("activeReason");
                    console.log("[WS] flushed previous unclosed idle period before new lock cycle");
                }
            }
            // Compute idle-start from history, but NEVER let a failed history fetch
            // block the popup — fall back to current time so the operator is always
            // prompted for a reason when the machine locks.
            let idleStart = dayjs().valueOf();
            try {
                const histData = await getFirstMachineActive("DEVICE", deviceId, {
                    keys: "machine_status",
                    startTs: Date.now() - 12 * 3600000,
                    endTs: Date.now(),
                    limit: 1000,
                });
                const arr = (histData?.machine_status || []).slice().sort((a, b) => b.ts - a.ts);
                let lastIdleOrAlarm = null;
                for (let i = 0; i < arr.length - 1; i++) {
                    const current = arr[i];
                    const next = arr[i + 1];
                    if (IDLE_END_CODES.includes(String(next.value)) && IDLE_START_CODES.includes(String(current.value))) {
                        lastIdleOrAlarm = current;
                        break;
                    }
                }
                if (!lastIdleOrAlarm) {
                    lastIdleOrAlarm = arr.find(item => IDLE_START_CODES.includes(String(item.value)));
                }
                if (lastIdleOrAlarm) idleStart = lastIdleOrAlarm.ts;
            } catch (e) {
                console.error("[WS] error fetching history on lock, using current time:", e);
            }
            // If an unlock arrived while we were fetching history (lock_status flipped to a
            // non-"locked" value almost immediately — same-second), abort. Otherwise we'd open
            // an orphaned popup that nothing closes: WS won't re-fire (no newer lock_status),
            // and isLockedRef is already false so reconcile can't clear it either.
            if (!isLockedRef.current) {
                console.log("[WS] unlock arrived during history fetch — not opening popup");
                return;
            }
            setIsLocked(true); // machine is locked → surface the manual "reopen reason" button
            lockedIdleStartRef.current = idleStart;
            console.log("[LOCKED_IDLE START] at", idleStart);
            let previousReason = null;
            try { previousReason = JSON.parse(localStorage.getItem("activeReason")); } catch { }
            openReasonSwal(idleStart, reasonsList2, previousReason);
        };

        const handleUnlockDetected = async () => {
            if (!isLockedRef.current) return;
            console.log("[WS] unlock detected");
            isLockedRef.current = false;
            setIsLocked(false);
            isSwalOpenRef.current = false;
            Swal.close();
            // Don't wait for the next 5s refreshData tick — try closing right now.
            // Shrinks the window where a second flap could start a new lock cycle
            // (see handleLockDetected's flush) before this period is recorded closed.
            const idleStart = lockedIdleStartRef.current;
            const reason = activeReasonRef.current;
            if (idleStart && reason) {
                const closed = await closeIdlePeriod(idleStart, {
                    name: reason.reason || reason.name,
                    code: reason.code,
                    mode: reason.mode,
                    category: reason.category,
                });
                if (closed) {
                    lockedIdleStartRef.current = null;
                    activeReasonRef.current = null;
                    localStorage.removeItem("lockedIdleStartTime");
                    localStorage.removeItem("activeReason");
                }
            }
        };

        // Manual reopen of the reason popup, bound to the header "Enter / Change Reason"
        // button. Resets the guard flags and reuses the normal lock flow so idleStart is
        // recomputed from history and any previously chosen reason is preselected.
        reopenReasonPopupRef.current = () => {
            isSwalOpenRef.current = false;
            isLockedRef.current = false;
            handleLockDetected();
        };

        // Safety net for the WS: a lock/unlock update can be silently dropped on a
        // flaky link that never fully closes the socket (so no reconnect/re-subscribe
        // snapshot fires) and the popup would never appear. Poll the authoritative
        // lock_status periodically and drive the same handlers the WS uses. This
        // restores the reliability the old 5s HTTP polling had, while keeping WS for
        // fast response.
        // Guards re-entry while a prompt is being prepared (handleLockDetected does an
        // async history fetch before the Swal appears, which can span reconcile ticks).
        let repromptInFlight = false;
        const reconcileLock = async () => {
            if (isConfirmingRef.current || repromptInFlight) return; // don't interfere with an in-progress submit/prompt
            try {
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                // Reconcile against what's actually on screen, not just the latch. Re-prompt
                // whenever the backend is locked but no popup is visible — this covers a
                // missed WS "locked" frame (latch false) AND a stuck latch (latch true but
                // the popup was dismissed/replaced by another Swal.fire). Skip if a
                // reason+unlock is already queued for delivery.
                if (locked && !Swal.isVisible() && !hasPendingReliableItem(deviceId)) {
                    console.log("[RECONCILE] lock_status=locked but no popup on screen — re-prompting");
                    repromptInFlight = true;
                    isLockedRef.current = false; // clear a possibly-stuck latch so handleLockDetected proceeds
                    try {
                        // Reasons may not have loaded yet (handleLockDetected defers silently in
                        // that case) — actively re-fetch here so every 5s tick can self-heal
                        // instead of waiting on the unrelated getReasons interval to catch up.
                        if (!reasonsList2 || reasonsList2.length === 0) {
                            try {
                                const reasonsResponse = await customerbasedshift(getCustomerId(), "reason");
                                const fetchedReasons = reasonsResponse?.[0]?.value || [];
                                if (fetchedReasons.length > 0) setReasonsList2(fetchedReasons);
                            } catch (e) {
                                console.error("[RECONCILE] failed to refresh reasons:", e);
                            }
                        }
                        await handleLockDetected();
                    } finally {
                        repromptInFlight = false;
                    }
                } else if (!locked && isLockedRef.current) {
                    console.log("[RECONCILE] lock_status=unlocked but still marked locked — clearing");
                    handleUnlockDetected();
                }
            } catch (e) {
                // TB/network unreachable — WS or a later poll will reconcile.
            }
        };

        const checkRestoreOnLoad = async () => {
            try {
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                if (locked && hasPendingReliableItem(deviceId)) {
                    // Unlock is still queued for delivery (e.g. TB was down at submit time).
                    // Don't re-prompt — the queue will deliver and the WS "unlocked" event
                    // will clear the locked state. Flush now that we're back online.
                    isLockedRef.current = true;
                    flushReliableQueue();
                    console.log("[RESTORE] pending unlock in queue, skipping re-prompt");
                    return;
                }
                if (locked && !isLockedRef.current) {
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            // Wait for the reason list before reopening, else the dropdown is
                            // empty. Not latching isLockedRef here means the effect re-run (when
                            // reasonsList2 loads) reopens this with reasons present.
                            if (!reasonsList2 || reasonsList2.length === 0) {
                                console.log("[RESTORE] reasons not loaded yet — deferring popup");
                                return;
                            }
                            lockedIdleStartRef.current = parseInt(savedIdleStart, 10);
                            activeReasonRef.current = parsedReason;
                            isLockedRef.current = true;
                            console.log("[RESTORE] Reopening Swal after refresh with saved reason");
                            openReasonSwal(lockedIdleStartRef.current, reasonsList2, parsedReason);
                        } catch (e) {
                            console.error("Failed to restore reason from localStorage:", e);
                        }
                    } else {
                        await handleLockDetected();
                    }
                } else if (!locked) {
                    // Device already transitioned out of the locked state while this tab
                    // was closed/reloaded. The previous cycle's data can still be sitting
                    // in localStorage, unclosed — this used to just do nothing, leaving it
                    // orphaned forever. Try to close it now using history instead.
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            const closed = await closeIdlePeriod(parseInt(savedIdleStart, 10), {
                                name: parsedReason.reason || parsedReason.name,
                                code: parsedReason.code,
                                mode: parsedReason.mode,
                                category: parsedReason.category,
                            });
                            if (closed) {
                                localStorage.removeItem("lockedIdleStartTime");
                                localStorage.removeItem("activeReason");
                                console.log("[RESTORE] closed stale idle period left over from before reload");
                            }
                        } catch (e) {
                            console.error("[RESTORE] failed to close stale idle period:", e);
                        }
                    }
                }
            } catch (e) {
                console.error("[checkRestore] error:", e);
            }
        };

        const refreshData = async () => {
            try {
                const data = await fetchTelemetry(deviceId);
                // fetchTelemetry rendered the header from the HTTP sample. Reconcile it
                // against the WS value by TIMESTAMP so neither source can get stuck: keep
                // whichever is newer. If the HTTP poll is newer than the WS cache, the WS
                // value was stale (a dropped frame) — adopt HTTP and refresh the cache so
                // the display self-corrects instead of freezing on a wrong value.
                let machineStatusArray = (data?.machine_status || []).slice().sort((a, b) => b.ts - a.ts);
                const latestSample = machineStatusArray[0];
                if (wsStatusRef.current !== null && (!latestSample || wsStatusRef.current.ts >= latestSample.ts)) {
                    const newStatus = statusText(parseInt(wsStatusRef.current.value, 10));
                    const newColor =
                        newStatus.toLowerCase() === "running" ? "#3DA06A"
                            : newStatus.toLowerCase() === "idle" ? "#DD6B20"
                                : newStatus.toLowerCase() === "alarm" ? "#E53E3E"
                                    : newStatus.toLowerCase() === "disconnect" ? "#808080"
                                        : "#ccc";
                    setTelemetry(prev => ({ ...prev, machineStatus: newStatus, machineColor: newColor }));
                } else if (latestSample) {
                    // WS stale/absent — HTTP is authoritative. fetchTelemetry already rendered
                    // it; just refresh the WS cache so later ticks compare against a fresh value.
                    wsStatusRef.current = { ts: latestSample.ts, value: String(latestSample.value) };
                }
                if (!machineStatusArray.length) return;
                const latestStatus = wsStatusRef.current !== null
                    ? wsStatusRef.current.value
                    : String(latestSample?.value ?? "0").trim();
                const latestStatusText = statusText(latestStatus).toLowerCase();
                const prevStatus = prevStatusRef.current;
                if (prevStatus !== latestStatusText) {
                    console.log(`[refreshData] status changed ${prevStatus} -> ${latestStatusText}`);
                }
                if (IDLE_END_CODES.includes(String(latestStatus)) &&
                    !isLockedRef.current &&
                    lockedIdleStartRef.current &&
                    activeReasonRef.current) {
                    const endEvent = machineStatusArray.find(
                        item => IDLE_END_CODES.includes(String(item.value)) && item.ts >= lockedIdleStartRef.current
                    ) || latestSample;
                    if (endEvent) {
                        const idleEndTime = endEvent.ts;
                        const duration = Math.floor((idleEndTime - lockedIdleStartRef.current) / 1000);
                        const parsedShifts = generateShiftInstances(lockedIdleStartRef.current, idleEndTime, shifts);
                        const segments = splitIdleByShifts(lockedIdleStartRef.current, idleEndTime, parsedShifts);
                        let allDelivered = true;
                        for (const seg of segments) {
                            const payload = {
                                ts: seg.start,
                                values: {
                                    live_reason: {
                                        name: activeReasonRef.current.reason,
                                        code: activeReasonRef.current.code || "",
                                        mode: activeReasonRef.current.mode || "",
                                        category: activeReasonRef.current.category || "",
                                        idle_start: seg.start,
                                        idle_end: seg.end,
                                        idle_duration: Math.floor((seg.end - seg.start) / 1000),
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                            } catch (err) {
                                console.error("Error submitting locked idle end:", err);
                                allDelivered = false;
                            }
                        }
                        // Only finalize (clear refs/localStorage) once EVERY segment is confirmed
                        // written. If any POST failed on a transient network/TB blip, keep the
                        // state so the next refreshData tick (5s) re-posts. Writes are keyed by
                        // ts=seg.start, so a re-post overwrites the same point — no duplicates.
                        // Happy path (all succeed) is identical to before.
                        if (allDelivered) {
                            console.log("[LOCKED_IDLE END] at", idleEndTime, "duration:", duration, "sec");
                            lockedIdleStartRef.current = null;
                            activeReasonRef.current = null;
                            isLockedRef.current = false;
                            localStorage.removeItem("lockedIdleStartTime");
                            localStorage.removeItem("activeReason");
                        } else {
                            console.warn("[LOCKED_IDLE END] some segments failed to write — keeping state, will retry next tick");
                        }
                    }
                }
                prevStatusRef.current = latestStatusText;
            } catch (err) {
                console.error("Error refreshing telemetry:", err);
            }
        };

        // Lightweight self-heal: scan this device's OWN live_reason history for any
        // entry left with idle_end: 0 that machine_status now shows should already be
        // closed, and close it. Covers gaps the flush points above can miss (e.g. the
        // tab wasn't open at all when the transition happened). Scoped to just the
        // currently selected device and a 24h lookback — a stand-in for the backend
        // reconciliation service until that's deployed, not a replacement for it.
        const selfHealStaleReasons = async () => {
            console.log(`[SELF-HEAL] sweep running for ${deviceId} (mount/refresh/machine-change, or 60s tick)`);
            try {
                const lookbackMs = 24 * 3600000;
                const now = Date.now();
                const response = await telemetrykeydata(deviceId, "DEVICE", "live_reason", now - lookbackMs, now);
                const entries = response?.live_reason || [];
                let openCount = 0;
                let closedCount = 0;
                for (const entry of entries) {
                    let parsed;
                    try { parsed = JSON.parse(entry.value); } catch { continue; }
                    if (!parsed?.idle_start || parsed.idle_end) continue; // not open
                    openCount += 1;
                    // The period currently being tracked live is already owned by the
                    // regular poll / flush points above — don't double up on it here.
                    if (isLockedRef.current && lockedIdleStartRef.current === parsed.idle_start) continue;
                    const closed = await closeIdlePeriod(parsed.idle_start, {
                        name: parsed.name,
                        code: parsed.code,
                        mode: parsed.mode,
                        category: parsed.category,
                    });
                    if (closed) closedCount += 1;
                }
                console.log(`[SELF-HEAL] sweep done for ${deviceId}: ${entries.length} entries checked, ${openCount} open, ${closedCount} closed`);
            } catch (e) {
                console.error("[SELF-HEAL] sweep failed:", e);
            }
        };

        const wsUrl = window._env_.SERVER_URL.replace(/\/$/, "")
            .replace(/^https:\/\//, "wss://")
            .replace(/^http:\/\//, "ws://");
        const token = localStorage.getItem("token1");
        let wsReconnectAttempts = 0;
        const tbWs = createTbWebSocket({
            url: `${wsUrl}/api/ws/plugins/telemetry?token=${token}`,
            onOpen: () => {
                wsReconnectAttempts = 0;
                tbWs.subscribe([deviceId]);
                // WS open means TB is reachable — push any queued reason+unlock now.
                flushReliableQueue();
            },
            onMessage: (msg) => {
                const data = msg.data || {};
                if (data.lock_status) {
                    const val = data.lock_status[0]?.[1];
                    if (val !== undefined && !isConfirmingRef.current) {
                        const locked = String(val).toLowerCase() === "locked";
                        if (locked) handleLockDetected();
                        else handleUnlockDetected();
                    }
                }
                if (data.machine_status) {
                    // TB may batch several [ts, value] pairs — take the NEWEST by ts, not [0].
                    let newest = null;
                    for (const pair of data.machine_status) {
                        if (Array.isArray(pair) && (newest === null || pair[0] > newest[0])) newest = pair;
                    }
                    const ts = newest?.[0];
                    const val = newest?.[1];
                    // Accept only if newer than what we already have (guards out-of-order frames).
                    if (val !== undefined && (wsStatusRef.current === null || ts >= wsStatusRef.current.ts)) {
                        wsStatusRef.current = { ts, value: String(val) };
                        const code = parseInt(String(val), 10);
                        const newStatus = statusText(code);
                        const newColor =
                            newStatus.toLowerCase() === "running" ? "#3DA06A"
                                : newStatus.toLowerCase() === "idle" ? "#DD6B20"
                                    : newStatus.toLowerCase() === "alarm" ? "#E53E3E"
                                        : newStatus.toLowerCase() === "disconnect" ? "#808080"
                                            : "#ccc";
                        setTelemetry(prev => ({ ...prev, machineStatus: newStatus, machineColor: newColor }));
                    }
                }
            },
            onClose: () => {
                // Reconnect with capped backoff + light jitter (was a flat 3s loop).
                const delay = Math.min(30000, 2000 * Math.pow(1.5, wsReconnectAttempts)) + (wsReconnectAttempts % 3) * 500;
                wsReconnectAttempts += 1;
                setTimeout(() => tbWs.connect(), delay);
            },
        });
        tbWs.connect();

        checkRestoreOnLoad();
        refreshData();
        selfHealStaleReasons();
        const interval = setInterval(refreshData, 5000);
        const lockInterval = setInterval(reconcileLock, 5000); // WS safety-net
        const selfHealInterval = setInterval(selfHealStaleReasons, 60000);
        return () => {
            tbWs.disconnect();
            clearInterval(interval);
            clearInterval(lockInterval);
            clearInterval(selfHealInterval);
        };
    }, [selectedMachine, deviceNameIdJson, reasonsList2]);

    const [reasonGroupOptions, setReasonGroupOptions] = useState([]);
    useEffect(() => {
        const customerId = getCustomerId();
        if (cleanCustomerId(customerId) != window._env_.GPLAST_CUSTOMER_ID) return;
        if (!selectedMachine || !deviceNameIdJson[selectedMachine]) return;
        const deviceId = deviceNameIdJson[selectedMachine];
        const openReasonSwal = (idleStart, reasonsList2, previousReason = null) => {
            if (isSwalOpenRef.current) return;
            isSwalOpenRef.current = true;
            const uniqueGroups = Array.from(
                new Set(reasonsList2.map(r => r.group).filter(g => g && g.trim() !== ""))
            );
            const hasGroups = uniqueGroups.length > 0;
            const allGroups = hasGroups
                ? [{ label: "All Groups", value: "all" }, ...uniqueGroups.map(g => ({ label: g, value: g }))]
                : [];
            const defaultGroup =
                previousReason && previousReason.group && uniqueGroups.includes(previousReason.group)
                    ? previousReason.group
                    : "all";
            const selectedReasonRef = { current: previousReason };
            const SwalContent = () => {
                const [group, setGroup] = React.useState(defaultGroup);
                const [reason, setReason] = React.useState(selectedReasonRef.current);
                const filteredReasons = React.useMemo(() => {
                    return group === "all" ? reasonsList2 : reasonsList2.filter(r => r.group === group);
                }, [group]);
                React.useEffect(() => {
                    selectedReasonRef.current = reason;
                }, [reason]);
                return (
                    <div style={{ display: "flex", flexDirection: "column", gap: 10, textAlign: "left", minHeight: 150 }}>
                        <p>Machine has been locked due to downhold threshold reached.</p>

                        {hasGroups && (
                            <>
                                <label>Select Group:</label>
                                <Autocomplete
                                    options={allGroups}
                                    value={allGroups.find(g => g.value === group)}
                                    onChange={(_, newValue) => {
                                        setGroup(newValue?.value || "all");
                                        setReason(null);
                                    }}
                                    getOptionLabel={(opt) => opt?.label || ""}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Group" variant="outlined" size="small" />
                                    )}
                                />
                            </>
                        )}

                        <label>Select Reason:</label>
                        <Autocomplete
                            options={filteredReasons}
                            value={reason}
                            onChange={(_, newValue) => setReason(newValue)}
                            getOptionLabel={(opt) => opt?.reason || ""}
                            renderInput={(params) => (
                                <TextField {...params} label="Reason" variant="outlined" size="small" />
                            )}
                        />
                    </div>
                );
            };

            Swal.fire({
                icon: "info",
                title: "Machine Locked",
                html: '<div id="swal-root"></div>',
                showConfirmButton: true,
                confirmButtonText: "Submit",
                allowOutsideClick: false,
                allowEscapeKey: false,
                didOpen: () => {
                    const container = document.getElementById("swal-root");
                    if (container) {
                        ReactDOMClient.createRoot(container).render(<SwalContent />);
                    }
                },
                preConfirm: () => {
                    if (!selectedReasonRef.current) {
                        Swal.showValidationMessage("Please select a reason");
                        return false;
                    }
                    return selectedReasonRef.current;
                },
            }).then((result) => {
                if (result.isConfirmed && result.value) {
                    const selectedReason = result.value;
                    activeReasonRef.current = selectedReason;
                    localStorage.setItem("lockedIdleStartTime", idleStart);
                    localStorage.setItem("activeReason", JSON.stringify(selectedReason));

                    const saveReason = async () => {
                        const payload = {
                            ts: idleStart,
                            values: {
                                live_reason: {
                                    name: selectedReason.reason,
                                    code: selectedReason.code || "",
                                    mode: selectedReason.mode || "",
                                    category: selectedReason.category || "",
                                    group: selectedReason.group || null,
                                    idle_start: idleStart,
                                    idle_end: 0,
                                    idle_duration: 0,
                                },
                            },
                        };
                        // Queue reason + unlock for guaranteed delivery (retries until
                        // ThingsBoard acknowledges). isLockedRef stays true until
                        // delivery is confirmed (onDelivered).
                        enqueueReasonUnlock({
                            deviceId,
                            reasonPayload: payload,
                            onDelivered: () => {
                                isLockedRef.current = false;
                                console.log("[LOCKED_IDLE-GPLAST] reason+unlock delivered to server");
                            },
                        });
                        setIsLocked(false); // reason submitted → hide the manual reopen button
                        // Only unlock locally when the cloud path is unreachable (offline
                        // or TB WS down). When online + connected, the queued cloud unlock
                        // drives Node-RED normally, so we skip the local call.
                        if (!navigator.onLine || !tbWs.isConnected()) {
                            sendLocalUnlock(deviceId, selectedReason, idleStart);
                        }
                        Swal.fire({
                            icon: "success",
                            title: "Reason Saved",
                            text: "Reason saved. Unlocking the machine…",
                            timer: 1500,
                            showConfirmButton: false,
                        });
                    };

                    const isDieChangeReason = selectedReason?.reason?.trim().toUpperCase() === "DIE CHANGE";
                    if (isDieChangeReason && window._env_.GPLAST_DEVICE_IDS?.includes(deviceId)) {
                        // Die-change reason skips the generic "Confirm Submission" step
                        // and goes straight from Submit to the die-change confirmation.
                        Swal.fire({
                            icon: "warning",
                            html: '<div style="font-size: 1.1em; font-weight: 600; margin-bottom: 8px;">You have selected "DIE CHANGE" as the idle reason.</div>Please confirm that you have selected the correct die for the component you are going to run.<br>Are you sure you want to continue?',
                            showCancelButton: true,
                            confirmButtonText: "YES",
                            cancelButtonText: "NO",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(async (dieConfirmResult) => {
                            isSwalOpenRef.current = false;
                            if (dieConfirmResult.isConfirmed) {
                                await saveReason();
                            } else {
                                openReasonSwal(idleStart, reasonsList2, selectedReason);
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "question",
                            title: "Confirm Submission",
                            text: `You selected: ${selectedReason.reason}. Do you want to confirm?`,
                            showCancelButton: true,
                            confirmButtonText: "Yes, Submit",
                            cancelButtonText: "No, Go Back",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                        }).then(async (confirmResult) => {
                            isSwalOpenRef.current = false;
                            if (confirmResult.isConfirmed) {
                                await saveReason();
                            } else {
                                openReasonSwal(idleStart, reasonsList2, selectedReason);
                            }
                        });
                    }
                } else {
                    isSwalOpenRef.current = false;
                }
            });
        };
        const IDLE_START_CODES = ["0", "1", "2"];
        const IDLE_END_CODES = ["3", "4", "5", "100"];
        const wsStatusRef = { current: null };

        // Shared close-writer: given an idle_start + reason, checks machine_status
        // history for a transition past idle_start and, if found, writes the real
        // idle_end/idle_duration (split across shift boundaries, same as the regular
        // auto-close in refreshData below). Reused at every point that can race the
        // regular 5s poll — a new lock cycle starting before the old one closed, an
        // unlock firing, or a tab restore — so none of them have to wait on the poll
        // to catch a transition that's already happened. Temporary, frontend-only
        // mitigation until the backend reconciliation service is live.
        const closeIdlePeriod = async (idleStart, reasonFields) => {
            if (!idleStart || !reasonFields) return false;
            try {
                const history = await telemetrykeydata(deviceId, "DEVICE", "machine_status", idleStart, Date.now());
                const samples = (history?.machine_status || [])
                    .map(item => ({ ts: item.ts, value: Number(item.value) }))
                    .sort((a, b) => a.ts - b.ts);
                const transition = samples.find(s => s.ts > idleStart && IDLE_END_CODES.includes(String(s.value)));
                if (!transition) return false; // still genuinely open — nothing to do

                const idleEndTime = transition.ts;
                const parsedShifts = generateShiftInstances(idleStart, idleEndTime, shifts);
                const splitSegments = splitIdleByShifts(idleStart, idleEndTime, parsedShifts);
                const segmentsToWrite = splitSegments.length > 0
                    ? splitSegments
                    : [{ start: idleStart, end: idleEndTime }];
                for (const seg of segmentsToWrite) {
                    await operatorTelemetry("DEVICE", deviceId, {
                        ts: seg.start,
                        values: {
                            live_reason: {
                                name: reasonFields.name || "",
                                code: reasonFields.code || "",
                                mode: reasonFields.mode || "",
                                category: reasonFields.category || "",
                                group: reasonFields.group || null,
                                idle_start: seg.start,
                                idle_end: seg.end,
                                idle_duration: Math.floor((seg.end - seg.start) / 1000),
                            },
                        },
                    });
                }
                console.log("[CLOSE-IDLE-GPLAST] closed", idleStart, "->", idleEndTime);
                return true;
            } catch (e) {
                console.error("[CLOSE-IDLE-GPLAST] failed:", e);
                return false;
            }
        };

        const handleLockDetected = async () => {
            if (isLockedRef.current || isSwalOpenRef.current) return;
            // Don't open the popup until the reason list has loaded, or the dropdown is
            // empty. We deliberately DON'T latch isLockedRef here — reasonsList2 is an
            // effect dependency, so when it populates the effect re-runs and this fires
            // again with reasons present. Self-heals within the first fetch; no refresh.
            if (!reasonsList2 || reasonsList2.length === 0) {
                console.log("[WS-GPLAST] lock detected but reasons not loaded yet — deferring popup");
                return;
            }
            isLockedRef.current = true;
            console.log("[WS-GPLAST] lock detected, fetching machine history");
            // Flush a still-open PREVIOUS idle period before starting this new one —
            // see the non-GPLAST block for the full rationale (a status flap before
            // the previous unlock's delivery confirms would otherwise overwrite these
            // refs and orphan the old period's idle_end forever).
            if (lockedIdleStartRef.current && activeReasonRef.current) {
                const staleIdleStart = lockedIdleStartRef.current;
                const staleReason = activeReasonRef.current;
                const closed = await closeIdlePeriod(staleIdleStart, {
                    name: staleReason.reason || staleReason.name,
                    code: staleReason.code,
                    mode: staleReason.mode,
                    category: staleReason.category,
                    group: staleReason.group,
                });
                if (closed) {
                    localStorage.removeItem("lockedIdleStartTime");
                    localStorage.removeItem("activeReason");
                    console.log("[WS-GPLAST] flushed previous unclosed idle period before new lock cycle");
                }
            }
            // Never let a failed history fetch block the popup — fall back to current time.
            let idleStart = dayjs().valueOf();
            try {
                const histData = await getFirstMachineActive("DEVICE", deviceId, {
                    keys: "machine_status",
                    startTs: Date.now() - 12 * 3600000,
                    endTs: Date.now(),
                    limit: 1000,
                });
                const arr = (histData?.machine_status || []).slice().sort((a, b) => b.ts - a.ts);
                let lastIdleOrAlarm = null;
                for (let i = 0; i < arr.length - 1; i++) {
                    const current = arr[i];
                    const next = arr[i + 1];
                    if (IDLE_END_CODES.includes(String(next.value)) && IDLE_START_CODES.includes(String(current.value))) {
                        lastIdleOrAlarm = current;
                        break;
                    }
                }
                if (!lastIdleOrAlarm) {
                    lastIdleOrAlarm = arr.find(item => IDLE_START_CODES.includes(String(item.value)));
                }
                if (lastIdleOrAlarm) idleStart = lastIdleOrAlarm.ts;
            } catch (e) {
                console.error("[WS-GPLAST] error fetching history on lock, using current time:", e);
            }
            // If an unlock arrived while we were fetching history (lock_status flipped to a
            // non-"locked" value almost immediately — same-second), abort. Otherwise we'd open
            // an orphaned popup that nothing closes: WS won't re-fire (no newer lock_status),
            // and isLockedRef is already false so reconcile can't clear it either.
            if (!isLockedRef.current) {
                console.log("[WS-GPLAST] unlock arrived during history fetch — not opening popup");
                return;
            }
            setIsLocked(true); // machine is locked → surface the manual "reopen reason" button
            lockedIdleStartRef.current = idleStart;
            let previousReason = null;
            try { previousReason = JSON.parse(localStorage.getItem("activeReason")); } catch { }
            openReasonSwal(idleStart, reasonsList2, previousReason);
        };

        const handleUnlockDetected = async () => {
            if (!isLockedRef.current) return;
            console.log("[WS-GPLAST] unlock detected");
            isLockedRef.current = false;
            isSwalOpenRef.current = false;
            setIsLocked(false);
            Swal.close();
            // Don't wait for the next 5s refreshData tick — try closing right now.
            // Shrinks the window where a second flap could start a new lock cycle
            // (see handleLockDetected's flush) before this period is recorded closed.
            const idleStart = lockedIdleStartRef.current;
            const reason = activeReasonRef.current;
            if (idleStart && reason) {
                const closed = await closeIdlePeriod(idleStart, {
                    name: reason.reason || reason.name,
                    code: reason.code,
                    mode: reason.mode,
                    category: reason.category,
                    group: reason.group,
                });
                if (closed) {
                    lockedIdleStartRef.current = null;
                    activeReasonRef.current = null;
                    localStorage.removeItem("lockedIdleStartTime");
                    localStorage.removeItem("activeReason");
                }
            }
        };

        // Manual reopen of the reason popup, bound to the header "Enter / Change Reason"
        // button. Resets the guard flags and reuses the normal lock flow so idleStart is
        // recomputed from history and any previously chosen reason is preselected.
        reopenReasonPopupRef.current = () => {
            isSwalOpenRef.current = false;
            isLockedRef.current = false;
            handleLockDetected();
        };

        // Safety net for missed WS lock/unlock frames (see the non-GPLAST block for
        // the full rationale): poll the authoritative lock_status and drive the same
        // handlers so a dropped WS update can't leave the popup unshown.
        // Guards re-entry while a prompt is being prepared (handleLockDetected does an
        // async history fetch before the Swal appears, which can span reconcile ticks).
        let repromptInFlight = false;
        const reconcileLock = async () => {
            if (isConfirmingRef.current || repromptInFlight) return;
            try {
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                // Reconcile against what's actually on screen, not just the latch/flag. Re-prompt
                // whenever the backend is locked but no popup is visible — this covers a missed
                // WS "locked" frame AND a stuck latch/flag (marked locked but the popup was
                // dismissed/replaced by another Swal.fire). Skip if a reason+unlock is already
                // queued for delivery.
                if (locked && !Swal.isVisible() && !hasPendingReliableItem(deviceId)) {
                    console.log("[RECONCILE-GPLAST] lock_status=locked but no popup on screen — re-prompting");
                    repromptInFlight = true;
                    isLockedRef.current = false;   // clear possibly-stuck latch
                    isSwalOpenRef.current = false;  // clear possibly-stuck open flag so openReasonSwal proceeds
                    try {
                        // Reasons may not have loaded yet (handleLockDetected defers silently in
                        // that case) — actively re-fetch here so every 5s tick can self-heal
                        // instead of waiting on the unrelated getReasons interval to catch up.
                        if (!reasonsList2 || reasonsList2.length === 0) {
                            try {
                                const reasonsResponse = await customerbasedshift(getCustomerId(), "reason");
                                const fetchedReasons = reasonsResponse?.[0]?.value || [];
                                if (fetchedReasons.length > 0) setReasonsList2(fetchedReasons);
                            } catch (e) {
                                console.error("[RECONCILE-GPLAST] failed to refresh reasons:", e);
                            }
                        }
                        await handleLockDetected();
                    } finally {
                        repromptInFlight = false;
                    }
                } else if (!locked && isLockedRef.current) {
                    console.log("[RECONCILE-GPLAST] lock_status=unlocked but still marked locked — clearing");
                    handleUnlockDetected();
                }
            } catch (e) {
                // TB/network unreachable — WS or a later poll will reconcile.
            }
        };

        const checkRestoreOnLoad = async () => {
            try {
                const response = await getMachineLock("DEVICE", deviceId, { keys: "lock_status" });
                const lockValue = response?.lock_status?.[0]?.value || "";
                const locked = String(lockValue).toLowerCase() === "locked";
                if (locked && hasPendingReliableItem(deviceId)) {
                    // Unlock is still queued for delivery; don't re-prompt — the queue will
                    // deliver and the WS "unlocked" event will clear the locked state.
                    isLockedRef.current = true;
                    flushReliableQueue();
                    console.log("[RESTORE-GPLAST] pending unlock in queue, skipping re-prompt");
                    return;
                }
                if (locked && !isSwalOpenRef.current) {
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            // Wait for the reason list before reopening, else the dropdown is
                            // empty. Not latching isLockedRef here means the effect re-run (when
                            // reasonsList2 loads) reopens this with reasons present.
                            if (!reasonsList2 || reasonsList2.length === 0) {
                                console.log("[RESTORE-GPLAST] reasons not loaded yet — deferring popup");
                                return;
                            }
                            lockedIdleStartRef.current = parseInt(savedIdleStart, 10);
                            activeReasonRef.current = parsedReason;
                            isLockedRef.current = true;
                            openReasonSwal(lockedIdleStartRef.current, reasonsList2, parsedReason);
                        } catch (e) {
                            console.error("Failed to restore reason:", e);
                        }
                    } else {
                        await handleLockDetected();
                    }
                } else if (!locked) {
                    // Device already transitioned out of the locked state while this tab
                    // was closed/reloaded. The previous cycle's data can still be sitting
                    // in localStorage, unclosed — this used to just do nothing, leaving it
                    // orphaned forever. Try to close it now using history instead.
                    const savedIdleStart = localStorage.getItem("lockedIdleStartTime");
                    const savedReason = localStorage.getItem("activeReason");
                    if (savedIdleStart && savedReason) {
                        try {
                            const parsedReason = JSON.parse(savedReason);
                            const closed = await closeIdlePeriod(parseInt(savedIdleStart, 10), {
                                name: parsedReason.reason || parsedReason.name,
                                code: parsedReason.code,
                                mode: parsedReason.mode,
                                category: parsedReason.category,
                                group: parsedReason.group,
                            });
                            if (closed) {
                                localStorage.removeItem("lockedIdleStartTime");
                                localStorage.removeItem("activeReason");
                                console.log("[RESTORE-GPLAST] closed stale idle period left over from before reload");
                            }
                        } catch (e) {
                            console.error("[RESTORE-GPLAST] failed to close stale idle period:", e);
                        }
                    }
                }
            } catch (e) {
                console.error("[checkRestore-GPLAST] error:", e);
            }
        };

        const refreshData = async () => {
            try {
                const data = await fetchTelemetry(deviceId);
                // fetchTelemetry rendered the header from the HTTP sample. Reconcile it
                // against the WS value by TIMESTAMP so neither source can get stuck: keep
                // whichever is newer. If the HTTP poll is newer than the WS cache, the WS
                // value was stale (a dropped frame) — adopt HTTP and refresh the cache so
                // the display self-corrects instead of freezing on a wrong value.
                let machineStatusArray = (data?.machine_status || []).slice().sort((a, b) => b.ts - a.ts);
                const latestSample = machineStatusArray[0];
                if (wsStatusRef.current !== null && (!latestSample || wsStatusRef.current.ts >= latestSample.ts)) {
                    const newStatus = statusText(parseInt(wsStatusRef.current.value, 10));
                    const newColor =
                        newStatus.toLowerCase() === "running" ? "#3DA06A"
                            : newStatus.toLowerCase() === "idle" ? "#DD6B20"
                                : newStatus.toLowerCase() === "alarm" ? "#E53E3E"
                                    : newStatus.toLowerCase() === "disconnect" ? "#808080"
                                        : "#ccc";
                    setTelemetry(prev => ({ ...prev, machineStatus: newStatus, machineColor: newColor }));
                } else if (latestSample) {
                    // WS stale/absent — HTTP is authoritative. fetchTelemetry already rendered
                    // it; just refresh the WS cache so later ticks compare against a fresh value.
                    wsStatusRef.current = { ts: latestSample.ts, value: String(latestSample.value) };
                }
                if (!machineStatusArray.length) return;
                const latestStatus = wsStatusRef.current !== null
                    ? wsStatusRef.current.value
                    : String(latestSample?.value ?? "0").trim();
                const latestStatusText = statusText(latestStatus).toLowerCase();
                if (
                    IDLE_END_CODES.includes(String(latestStatus)) &&
                    lockedIdleStartRef.current &&
                    activeReasonRef.current
                ) {
                    const endEvent = machineStatusArray.find(
                        item => IDLE_END_CODES.includes(String(item.value)) && item.ts >= lockedIdleStartRef.current
                    ) || latestSample;
                    if (endEvent) {
                        const idleEndTime = endEvent.ts;
                        const parsedShifts = generateShiftInstances(lockedIdleStartRef.current, idleEndTime, shifts);
                        const segments = splitIdleByShifts(lockedIdleStartRef.current, idleEndTime, parsedShifts);
                        let allDelivered = true;
                        for (const seg of segments) {
                            const payload = {
                                ts: seg.start,
                                values: {
                                    live_reason: {
                                        name: activeReasonRef.current.reason,
                                        code: activeReasonRef.current.code || "",
                                        mode: activeReasonRef.current.mode || "",
                                        category: activeReasonRef.current.category || "",
                                        group: activeReasonRef.current.group || null,
                                        idle_start: seg.start,
                                        idle_end: seg.end,
                                        idle_duration: Math.floor((seg.end - seg.start) / 1000),
                                    },
                                },
                            };
                            try {
                                await operatorTelemetry("DEVICE", deviceId, payload);
                            } catch (err) {
                                console.error("Error submitting locked idle segment:", err);
                                allDelivered = false;
                            }
                        }
                        // Only finalize once EVERY segment is confirmed written; otherwise keep
                        // state and let the next refreshData tick (5s) re-post. Re-posts are keyed
                        // by ts=seg.start so they overwrite the same point — no duplicates.
                        if (allDelivered) {
                            lockedIdleStartRef.current = null;
                            activeReasonRef.current = null;
                            isLockedRef.current = false;
                            isSwalOpenRef.current = false;
                            localStorage.removeItem("lockedIdleStartTime");
                            localStorage.removeItem("activeReason");
                        } else {
                            console.warn("[LOCKED_IDLE-GPLAST END] some segments failed to write — keeping state, will retry next tick");
                        }
                    }
                }
                prevStatusRef.current = latestStatusText;
            } catch (err) {
                console.error("Error refreshing telemetry:", err);
            }
        };

        // Lightweight self-heal: scan this device's OWN live_reason history for any
        // entry left with idle_end: 0 that machine_status now shows should already be
        // closed, and close it. Covers gaps the flush points above can miss (e.g. the
        // tab wasn't open at all when the transition happened). Scoped to just the
        // currently selected device and a 24h lookback — a stand-in for the backend
        // reconciliation service until that's deployed, not a replacement for it.
        const selfHealStaleReasons = async () => {
            console.log(`[SELF-HEAL-GPLAST] sweep running for ${deviceId} (mount/refresh/machine-change, or 60s tick)`);
            try {
                const lookbackMs = 24 * 3600000;
                const now = Date.now();
                const response = await telemetrykeydata(deviceId, "DEVICE", "live_reason", now - lookbackMs, now);
                const entries = response?.live_reason || [];
                let openCount = 0;
                let closedCount = 0;
                for (const entry of entries) {
                    let parsed;
                    try { parsed = JSON.parse(entry.value); } catch { continue; }
                    if (!parsed?.idle_start || parsed.idle_end) continue; // not open
                    openCount += 1;
                    // The period currently being tracked live is already owned by the
                    // regular poll / flush points above — don't double up on it here.
                    if (isLockedRef.current && lockedIdleStartRef.current === parsed.idle_start) continue;
                    const closed = await closeIdlePeriod(parsed.idle_start, {
                        name: parsed.name,
                        code: parsed.code,
                        mode: parsed.mode,
                        category: parsed.category,
                        group: parsed.group,
                    });
                    if (closed) closedCount += 1;
                }
                console.log(`[SELF-HEAL-GPLAST] sweep done for ${deviceId}: ${entries.length} entries checked, ${openCount} open, ${closedCount} closed`);
            } catch (e) {
                console.error("[SELF-HEAL-GPLAST] sweep failed:", e);
            }
        };

        const wsUrl = window._env_.SERVER_URL.replace(/\/$/, "")
            .replace(/^https:\/\//, "wss://")
            .replace(/^http:\/\//, "ws://");
        const token = localStorage.getItem("token1");
        let wsReconnectAttempts = 0;
        const tbWs = createTbWebSocket({
            url: `${wsUrl}/api/ws/plugins/telemetry?token=${token}`,
            onOpen: () => {
                wsReconnectAttempts = 0;
                tbWs.subscribe([deviceId]);
                // WS open means TB is reachable — push any queued reason+unlock now.
                flushReliableQueue();
            },
            onMessage: (msg) => {
                const data = msg.data || {};
                if (data.lock_status) {
                    const val = data.lock_status[0]?.[1];
                    if (val !== undefined) {
                        const locked = String(val).toLowerCase() === "locked";
                        if (locked) handleLockDetected();
                        else handleUnlockDetected();
                    }
                }
                if (data.machine_status) {
                    // TB may batch several [ts, value] pairs — take the NEWEST by ts, not [0].
                    let newest = null;
                    for (const pair of data.machine_status) {
                        if (Array.isArray(pair) && (newest === null || pair[0] > newest[0])) newest = pair;
                    }
                    const ts = newest?.[0];
                    const val = newest?.[1];
                    // Accept only if newer than what we already have (guards out-of-order frames).
                    if (val !== undefined && (wsStatusRef.current === null || ts >= wsStatusRef.current.ts)) {
                        wsStatusRef.current = { ts, value: String(val) };
                        const code = parseInt(String(val), 10);
                        const newStatus = statusText(code);
                        const newColor =
                            newStatus.toLowerCase() === "running" ? "#3DA06A"
                                : newStatus.toLowerCase() === "idle" ? "#DD6B20"
                                    : newStatus.toLowerCase() === "alarm" ? "#E53E3E"
                                        : newStatus.toLowerCase() === "disconnect" ? "#808080"
                                            : "#ccc";
                        setTelemetry(prev => ({ ...prev, machineStatus: newStatus, machineColor: newColor }));
                    }
                }
            },
            onClose: () => {
                // Reconnect with capped backoff + light jitter (was a flat 3s loop).
                const delay = Math.min(30000, 2000 * Math.pow(1.5, wsReconnectAttempts)) + (wsReconnectAttempts % 3) * 500;
                wsReconnectAttempts += 1;
                setTimeout(() => tbWs.connect(), delay);
            },
        });
        tbWs.connect();

        checkRestoreOnLoad();
        refreshData();
        selfHealStaleReasons();
        const interval = setInterval(refreshData, 5000);
        const lockInterval = setInterval(reconcileLock, 5000); // WS safety-net
        const selfHealInterval = setInterval(selfHealStaleReasons, 60000);
        return () => {
            tbWs.disconnect();
            clearInterval(interval);
            clearInterval(lockInterval);
            clearInterval(selfHealInterval);
        };
    }, [selectedMachine, deviceNameIdJson, reasonsList2]);

    function generateShiftInstances(startEpoch, endEpoch, shifts) {
        const startTimeOfDay = dayjs(startEpoch).hour() * 60 + dayjs(startEpoch).minute();
        const earliestShiftStart = Math.min(
            ...shifts.map((s) => {
                const [h, m] = s.start_time.split(":").map(Number);
                return h * 60 + m;
            })
        );
        const latestShiftEnd = Math.max(
            ...shifts.map((s) => {
                const [h, m] = s.end_time.split(":").map(Number);
                return h * 60 + m;
            })
        );
        const needsPreviousDay = startTimeOfDay < earliestShiftStart;
        const needsNextDay = (dayjs(endEpoch).hour() * 60 + dayjs(endEpoch).minute()) > latestShiftEnd;
        const startDate = dayjs(startEpoch)
            .startOf("day")
            .subtract(needsPreviousDay ? 1 : 0, "day");
        const endDate = dayjs(endEpoch)
            .endOf("day")
            .add(needsNextDay ? 1 : 0, "day");
        const result = [];
        let currentDate = startDate;
        while (currentDate.valueOf() <= endDate.valueOf()) {
            shifts.forEach((shift) => {
                const [startH, startM, startS] = shift.start_time.split(":").map(Number);
                const [endH, endM, endS] = shift.end_time.split(":").map(Number);
                let startTs = currentDate
                    .add(shift.start_day - 1, "day")
                    .hour(startH)
                    .minute(startM)
                    .second(startS);
                let endTs = currentDate
                    .add(shift.end_day - 1, "day")
                    .hour(endH)
                    .minute(endM)
                    .second(endS);
                if (endTs.isBefore(startTs)) endTs = endTs.add(1, "day");

                if (endTs.valueOf() >= startEpoch && startTs.valueOf() <= endEpoch) {
                    result.push({
                        shift_no: shift.shift_no,
                        startTs: startTs.valueOf(),
                        endTs: endTs.valueOf(),
                    });
                }
            });
            currentDate = currentDate.add(1, "day");
        }
        return result;
    }

    useEffect(() => {
        if (!operators.length) return;
        if (!telemetry.liveOperatorCode) {
            setSelectedOperator("");
            return;
        }
        const found = operators.find(
            op => String(op.id) === String(telemetry.liveOperatorCode)
        );
        if (found) {
            setSelectedOperator(found.id);
        } else {
            setSelectedOperator("");
        }
    }, [telemetry.liveOperatorCode, operators]);

    useEffect(() => {
        if (!currentShift) return;
        const code = telemetry?.liveComponent?.code || '';
        if (!code) {
            setLiveCompSelected('');
            return;
        }
        // Only auto-select if the component belongs to the current shift
        const compStartTime = telemetry.liveComponent?.start_time;
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
        if (!compStartTime || compStartTime < shiftStart || compStartTime > shiftEnd) {
            setLiveCompSelected('');
            return;
        }
        // Resolve the stored component back to its "PLANNO|DETAILIDX" dropdown key
        const planList = Array.isArray(currentMachinePlan) ? currentMachinePlan : [];
        const plan = planList.find(p => p.plan_no === telemetry.liveComponent?.plan_no);
        const detailIdx = (Array.isArray(plan?.details) ? plan.details : [])
            .findIndex(d => (Array.isArray(d?.Item) ? d.Item : []).map(i => i.Item).join(' & ') === code);
        setLiveCompSelected(detailIdx >= 0 ? `${plan.plan_no}|${detailIdx}` : code);
        if (!prevLiveComp && telemetry.liveComponentTs) {
            const { plan_id, plan_no, unit_desc, type, line, machine_name, Cavity, Item, ItemDesc, PlanQty, name, code: compCode, start_time, end_time, duration, cycle_time, handling_time, setup_time, factorval, factor, ShiftDesc } = telemetry.liveComponent || {};
            setPrevLiveComp({
                plan_id,
                plan_no,
                unit_desc,
                type,
                line,
                machine_name,
                Cavity,
                Item,
                ItemDesc,
                PlanQty,
                name,
                code: compCode,
                start_time,
                end_time,
                duration,
                cycle_time,
                handling_time,
                setup_time,
                factorval,
                factor,
                ShiftDesc,
                ts: telemetry.liveComponentTs,
            });
        }
    }, [telemetry.liveComponent, currentShift, currentMachinePlan]);

    const cancelreason = async () => {
        setopenDownTimeModal(false);
    }

    const handleSaveThreshold2 = async () => {
        try {
            const completedRows = filteredResult.filter(item => item.reasonselected);
            if (completedRows.length === 0) {
                Swal.fire('Warning', 'No reasons selected to save.', 'warning');
                return;
            }
            // A segment is only genuinely still open when NEITHER source has a real
            // end: the server's own live_reason record has idle_end 0/missing, AND
            // the local machine_status re-scan never observed a closing transition
            // (open). If either source has a real end, patch it — preferring the
            // server's matchedIdleEnd when it's real, else the locally-observed
            // item.end (covers the case where machine_status already shows it
            // closed but the live_reason record hasn't been updated yet).
            let skippedCount = 0;
            // DEBUG: shows per-row why a reason is patched or skipped. Remove once verified.
            console.log('[downtime-save] rows:', completedRows.map(r => {
                const hasRealServerEnd = r.matchedIdleEnd && r.matchedIdleEnd > 0;
                const hasRealLocalEnd = !r.open && r.end;
                const isStillOpen = !hasRealServerEnd && !hasRealLocalEnd;
                return {
                    start: r.start, end: r.end, reason: r.reasonselected,
                    matchedIdleEnd: r.matchedIdleEnd, open: r.open,
                    willSkip: !!(isStillOpen || !r.start || !r.end),
                };
            }));
            for (const item of completedRows) {
                // Only patch a reason for a truly closed idle — see comment above
                // for what counts as "closed."
                const hasRealServerEnd = item.matchedIdleEnd && item.matchedIdleEnd > 0;
                const hasRealLocalEnd = !item.open && item.end;
                const isStillOpen = !hasRealServerEnd && !hasRealLocalEnd;
                if (isStillOpen || !item.start || !item.end) {
                    skippedCount++;
                    continue;
                }
                const operator = reasonslist.find(op => op.reason === item.reasonselected);
                const code = operator ? operator.code : null;
                const mode = operator ? operator.mode : null;
                const category = operator ? operator.category : null;
                // Prefer the server's real idle_end when available; otherwise the
                // locally-observed item.end (machine_status already shows it closed,
                // even though the live_reason record still says idle_end: 0).
                const realEnd = hasRealServerEnd ? item.matchedIdleEnd : item.end;
                const key = {
                    ts: item.start,
                    values: {
                        live_reason: {
                            name: item.reasonselected,
                            code: code,
                            mode: mode,
                            category: category,
                            idle_start: item.start,
                            idle_end: realEnd,
                            idle_duration: Math.floor((realEnd - item.start) / 1000)
                        }
                    }
                };
                await Downtimeadd1('DEVICE', selectedDeviceId, 'SERVER_SCOPE', key);
                setDeviceThresholds(prev => ({
                    ...prev,
                    [selectedDeviceId.id || selectedDeviceId]: item.reasonselected
                }));
            }
            if (skippedCount === completedRows.length) {
                Swal.fire({
                    icon: "warning",
                    title: "Warning",
                    text: 'Selected segment(s) are still open (idle not yet closed) — nothing was saved.',
                });
            } else if (skippedCount > 0) {
                Swal.fire({
                    icon: "warning",
                    title: "Partial Success",
                    text: `Saved ${completedRows.length - skippedCount} reason(s); ${skippedCount} segment(s) skipped because they are still open.`,
                });
            } else {
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: 'Reasons assigned successfully.',
                    timer: 1500,
                    showConfirmButton: false,
                });
            }

        } catch (err) {
            console.error('Update error:', err);
            Swal.fire('Error', 'Failed to assign reason.', 'error');
        } finally {
            setopenDownTimeModal(false);
        }
    };

    const handleReasonChange = (index, val) => {
        setfilteredResult(prevResults => {
            const updatedResults = [...prevResults];
            let groupPatch = {};
            if (getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) {
                const isUnknown = typeof val === "string" && val.trim().toLowerCase() === "unknown";
                if (isUnknown) {
                    // "Unknown" has no meaningful group, so clear whatever group was selected.
                    groupPatch = { groupselected: "" };
                } else if (!updatedResults[index].groupselected) {
                    // No group chosen yet — auto-select the group this reason belongs to.
                    const matchedReason = reasons.find(r => r.value === val);
                    if (matchedReason?.group) {
                        groupPatch = { groupselected: matchedReason.group };
                    }
                }
            }
            updatedResults[index] = {
                ...updatedResults[index],
                reasonselected: val,
                ...groupPatch
            };
            return updatedResults;
        });
    };

    const getEpochFromShift2 = (shiftNo, selectedDateObj, shifts) => {
        if (!shiftNo || !selectedDateObj || !shifts || shifts.length === 0) {
            return { fromEpoch: null, toEpoch: null };
        }
        const selectedShiftData = shifts.find(shift => String(shift.shift_no) === String(shiftNo));
        if (!selectedShiftData) {
            return { fromEpoch: null, toEpoch: null };
        }
        const dateStr = selectedDateObj.format("YYYY-MM-DD");
        const startDateTime = dayjs(`${dateStr}T${selectedShiftData.start_time}`);
        let endDateTime;
        if (selectedShiftData.end_day !== selectedShiftData.start_day) {
            const nextDay = selectedDateObj.add(1, "day").format("YYYY-MM-DD");
            endDateTime = dayjs(`${nextDay}T${selectedShiftData.end_time}`);
        } else {
            endDateTime = dayjs(`${dateStr}T${selectedShiftData.end_time}`);
        }
        return {
            fromEpoch: startDateTime.valueOf(),
            toEpoch: endDateTime.valueOf(),
        };
    };

    useEffect(() => {
        if (
            // .endsWith (not !==) so this also matches the Plant-prefixed
            // form of this kiosk URL (/<plantSlug>/wP7n_...) — same suffix
            // check getCustomerId()/isPMIBlueCardPage use above for the same
            // token. An exact-match miss here used to skip the tenant
            // auto-login entirely, leaving resolvePlantAllowedDeviceNames()
            // to 401 and silently fall back to showing every machine instead
            // of the "Unknown plant" screen.
            !location.pathname.endsWith("/wP7n_AqZ9-rtY4X8jvS2T6eK0uL3MhQxGdN5oRc~1fHbJiV") &&
            location.pathname !== "/smc_operator_bf9tz" &&
            location.pathname !== "/marks_operator_ch8st" &&
            location.pathname !== "/makino_operator_av5tc" &&
            location.pathname !== "/gplast_operator_awe6tc" &&
            location.pathname !== "/demo_operator_av3tc" &&
            location.pathname !== "/atech_operator_atc67" &&
            location.pathname !== "/operator_screen_biotek" &&
            location.pathname !== "/integra_operator_xw9kp" &&
            location.pathname !== "/operator_screen"
        ) {
            return;
        }
        const init = async () => {
            try {
                const secondUsername = window._env_.TENANT_GMAIL;
                const secondPassword = window._env_.TENANT_PASSWORD;
                const secondResponse = await Loginapi(secondUsername, secondPassword);
                localStorage.setItem("email1", secondUsername);
                localStorage.setItem("token1", secondResponse.token);
                localStorage.setItem("refreshToken1", secondResponse.refreshToken);
                localStorage.setItem("Companyname1", secondResponse.Companyname);
                localStorage.setItem("role_name1", secondResponse.Role);
                startTokenAutoRefresh();
                await fetchDevices();
            } catch (err) {
                console.error("Init failed", err);
            }
        };
        init();
    }, [location.pathname]);

    // Reset blue card notifications when component changes
    useEffect(() => {
        const currentCode = telemetry?.liveComponent?.code || telemetry?.liveComponent?.name || null;
        if (prevComponentCodeRef.current !== null && prevComponentCodeRef.current !== currentCode) {
            setBlueCardNotifications([]);
        }
        prevComponentCodeRef.current = currentCode;
    }, [telemetry.liveComponent]);

    // When shift changes, close running component with shift end_time, then reset fresh
    useEffect(() => {
        if (!currentShift || !isGplastCondition || !window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine])) return;
        const prev = prevShiftRef.current;
        prevShiftRef.current = currentShift;
        if (!prev || prev.shift_no === currentShift.shift_no) return;

        // Shift has crossed — immediately reset dropdown, then close out the running component
        setLiveCompSelected('');
        setPrevLiveComp(null);

        if (!prevLiveComp) return;
        const { shiftEnd } = getShiftEpoch(prev.start_time, prev.end_time);
        const deviceId = deviceNameIdJson[selectedMachine];
        if (!deviceId || !shiftEnd) return;

        const duration = Math.floor((shiftEnd - prevLiveComp.start_time) / 1000);
        const { ts: _shiftTs, ...prevLiveCompDataShift } = prevLiveComp;
        operatorTelemetry('DEVICE', deviceId, {
            ts: prevLiveComp.ts,
            values: {
                live_plan: {
                    ...prevLiveCompDataShift,
                    end_time: shiftEnd,
                    duration,
                }
            }
        })
            .catch(err => console.error('Error closing component on shift change:', err));
    }, [currentShift, isGplastCondition, selectedMachine, deviceNameIdJson]);

    // Click outside handler for notification dropdown
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (notifBellRef.current && !notifBellRef.current.contains(e.target)) {
                setShowBlueCardNotif(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setDate(dayjs().format("DD-MM-YYYY"));
            setTime(dayjs().format("HH:mm:ss"));
        }, 1000);
        return () => clearInterval(interval);
    }, []);

    const handleConfirm = () => {
        if (confirmType === "machine") {
            setSelectedMachine(pendingMachine);
            localStorage.setItem("selectedMachine", pendingMachine);
        } else if (confirmType === "operator") {
            setSelectedOperator(pendingOperator);
            postOperator(pendingOperator);
        }
        setConfirmType(null);
        setPendingMachine("");
        setPendingOperator("");
    };

    const handleCancel = () => {
        setConfirmType(null);
        setPendingMachine("");
        setPendingOperator("");
    };

    const postOperator = async (pendingOperator) => {
        try {
            const deviceId = deviceNameIdJson[selectedMachine];
            const startTime = dayjs().valueOf();
            const operatorName = operators.find(res => res.id == pendingOperator)?.name;

            if (currentOperator && currentOperator.start_time) {
                const updatedPrevOperator = {
                    ...currentOperator,
                    end_time: startTime,
                    duration: Math.floor((startTime - currentOperator.start_time) / 1000)
                };
                const prevPayload = {
                    ts: currentOperator.ts || dayjs().valueOf(),
                    values: { live_operator: updatedPrevOperator }
                };
                await operatorTelemetry('DEVICE', deviceId, prevPayload);
            }

            const newOperatorData = {
                name: operatorName,
                code: pendingOperator,
                start_time: startTime,
                end_time: 0,
                duration: 0,
                ts: startTime
            };

            const payload = {
                ts: startTime,
                values: {
                    live_operator: newOperatorData
                }
            };

            await operatorTelemetry('DEVICE', deviceId, payload);
            setCurrentOperator(newOperatorData);
            const payload2 = { ts: payload.ts, value: payload.values.live_operator };
            localStorage.setItem('operator_details', JSON.stringify(payload2));
        } catch (err) {
            console.error('operator api failure', err);
        }
    };

    const buildPlanLabel = (plan) => {
        // Support both `details` (array) and legacy `detail` (single object)
        const details = Array.isArray(plan?.details)
            ? plan.details
            : plan?.detail ? [plan.detail] : [];

        const isMachining = (plan?.type || plan?.Type || "").toLowerCase() === "machining";

        if (isMachining) {
            // Machining: label from Process[] → ProcessId & ProcessDesc
            const processParts = details.flatMap(detail =>
                (detail?.Process || []).map(p => `(${p.ProcessId} - ${p.ProcessDesc})`)
            );
            return `${plan.plan_no} - ${processParts.length ? processParts.map(p => `[ ${p} ]`).join(' , ') : '[]'}`;
        }

        // Non-Machining: existing logic using Item[]
        const detailParts = details.map(detail => {
            const items = detail?.Item || [];
            if (items.length === 1) {
                return `(${items[0].Item} - ${items[0].ItemDesc})`;
            }
            const ids = items.map(i => i.Item).join(' & ');
            const descs = items.map(i => i.ItemDesc).join(' & ');
            return `(${ids}) - (${descs})`;
        });
        return `${plan.plan_no} - ${detailParts.length ? detailParts.map(p => `[ ${p} ]`).join(' , ') : '[]'}`;
    };

    const buildDetailLabel = (plan, detail) => {
        const items = (detail?.Item || []).map(i => ({ id: i.Item, desc: i.ItemDesc }));
        const ids = items.map(i => i.id).filter(Boolean).join(' & ');
        const descs = items.map(i => i.desc).filter(Boolean).join(' & ');
        return `${plan.plan_no}: (${ids}) - (${descs})`;
    };

    // Resolves a "PLANNO|DETAILIDX" key to its display label, falling back to the
    // last stored telemetry name while the plan list is still loading.
    const getComponentLabelForKey = (key) => {
        if (!key) return null;
        const [selPlanNo, selIdxStr] = key.split("|");
        const selIdx = parseInt(selIdxStr, 10);
        const planList = Array.isArray(currentMachinePlan) ? currentMachinePlan : [];
        const selPlan = planList.find(p => p.plan_no === selPlanNo);
        const selDetail = Array.isArray(selPlan?.details) ? selPlan.details[selIdx] : null;
        if (selPlan && selDetail) return buildDetailLabel(selPlan, selDetail);
        return telemetry?.liveComponent?.name || null;
    };

    const buildPlanCombinedLabel = (plan) => {
        const details = Array.isArray(plan?.details) ? plan.details : [];
        const items = details.flatMap(d => (d?.Item || []).map(i => ({ id: i.Item, desc: i.ItemDesc })));
        const ids = items.map(i => i.id).filter(Boolean).join(' & ');
        const descs = items.map(i => i.desc).filter(Boolean).join(' & ');
        return `${plan.plan_no}: (${ids}) - (${descs})`;
    };

    // selectedValue format: "PLANNO|DETAILIDX"
    const handleLiveComponentChange = async (selectedValue) => {
        if (!isGplastCondition || !window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine])) return;
        // Same component re-selected within the same shift - nothing changed, skip the post.
        if (selectedValue && selectedValue === liveCompSelected) return;
        const [planNo, detailIdxStr] = (selectedValue || "").split("|");
        const detailIdx = parseInt(detailIdxStr, 10);
        const planList = Array.isArray(currentMachinePlan) ? currentMachinePlan : [];
        const selectedPlan = planList.find(p => p.plan_no === planNo);
        const planDetails = Array.isArray(selectedPlan?.details) ? selectedPlan.details : [];
        const selectedDetail = planDetails[detailIdx];
        if (!selectedPlan || !selectedDetail) return;

        const detailLabel = buildDetailLabel(selectedPlan, selectedDetail);
        const selectedComp = { name: detailLabel, code: selectedValue };

        const deviceId = deviceNameIdJson[selectedMachine];
        const now = Date.now();
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift?.start_time, currentShift?.end_time);

        // Build live_component entry from selected detail's items
        const allItems = Array.isArray(selectedDetail?.Item) ? selectedDetail.Item : [];
        const itemIds = allItems.map(i => i.Item).join(' & ');
        const itemDescs = allItems.map(i => i.ItemDesc).join(' & ');
        const totalPlanQty = allItems.reduce((sum, i) => sum + (Number(i.PlanQty) || 0), 0);
        const cavities = allItems.map(i => i.Cavity ?? null);
        const totalCavity = cavities.reduce((sum, c) => sum + (Number(c) || 0), 0);

        const liveComponentEntry = {
            plan_id: selectedPlan?.id ?? selectedPlan?.plan_id ?? '-',
            plan_no: selectedPlan?.plan_no,
            unit_desc: selectedPlan?.unit_desc ?? '-',
            type: selectedPlan?.type ?? selectedPlan?.Type ?? '-',
            line: selectedDetail?.line ?? '-',
            machine_name: selectedDetail?.machine_name ?? selectedMachine ?? '-',
            Cavity: cavities,
            Item: itemIds,
            ItemDesc: itemDescs,
            PlanQty: totalPlanQty,
            name: itemDescs,
            code: itemIds,
            start_time: now,
            end_time: shiftEnd,
            duration: Math.floor((shiftEnd - now) / 1000),
            cycle_time: selectedDetail?.CycleTime
                ? `${String(selectedDetail.CycleTime.Hours ?? 0).padStart(2, '0')}:${String(selectedDetail.CycleTime.Minutes ?? 0).padStart(2, '0')}:${String(selectedDetail.CycleTime.Seconds ?? 0).padStart(2, '0')}`
                : "00:00:00",
            handling_time: "00:00:00",
            setup_time: "00:00:00",
            factorval: totalCavity || '-',
            factor: "Multiplication Factor",
        };

        try {
            if (!liveCompSelected) {
                const noOpsEntry = {
                    name: 'No Operations',
                    code: '',
                    start_time: shiftStart,
                    end_time: now,
                    duration: Math.floor((now - shiftStart) / 1000),
                    cycle_time: "00:00:00",
                    handling_time: "00:00:00",
                    setup_time: "00:00:00",
                    factorval: 1,
                    factor: "Multiplication Factor",
                    ShiftDesc: currentShift?.shift_name || 'SHIFT1',
                };
                await operatorTelemetry('DEVICE', deviceId, {
                    ts: shiftStart,
                    values: {
                        live_plan: noOpsEntry,
                        live_component: noOpsEntry,
                    }
                });
            } else if (prevLiveComp) {
                const duration = Math.floor((now - prevLiveComp.start_time) / 1000);
                const { ts: _ts, ...prevLiveCompData } = prevLiveComp;
                await operatorTelemetry('DEVICE', deviceId, {
                    ts: prevLiveComp.ts,
                    values: {
                        live_plan: {
                            ...prevLiveCompData,
                            end_time: now,
                            duration,
                        },
                        live_component: {
                            ...prevLiveCompData,
                            end_time: now,
                            duration,
                        }
                    }
                });
            }

            const newEntry = {
                ...liveComponentEntry,
                start_time: now,
                end_time: shiftEnd,
                duration: Math.floor((shiftEnd - now) / 1000),
                ShiftDesc: currentShift?.shift_name || 'SHIFT1',
            };

            await operatorTelemetry('DEVICE', deviceId, {
                ts: now,
                values: {
                    live_plan: newEntry,
                    live_component: { ...liveComponentEntry, ShiftDesc: currentShift?.shift_name || 'SHIFT1' },
                }
            });

            setPrevLiveComp({ ...liveComponentEntry, ts: now });
            setLiveCompSelected(selectedValue);

            Swal.fire({
                title: 'Success',
                text: `Component changed to "${selectedComp.name}" successfully.`,
                icon: 'success',
                timer: 2000,
                showConfirmButton: false,
            });
        } catch (error) {
            console.error('Error changing component:', error);
            Swal.fire('Error', 'Failed to change component.', 'error');
        }
    };

    const openAllocateCompModal = () => {
        setPendingCompValue(liveCompSelected || '');
        setLiveCompSearch('');
        setAllocateCompModalOpen(true);
    };

    const cancelAllocateCompModal = () => {
        if (allocatingComp) return;
        setAllocateCompModalOpen(false);
        setPendingCompValue('');
        setLiveCompSearch('');
    };

    const confirmAllocateCompModal = async () => {
        if (!pendingCompValue || allocatingComp) return;
        if (pendingCompValue === liveCompSelected) {
            Swal.fire({
                title: 'Already Running',
                html: 'This component is already allocated and running for this shift.<br />Please choose a different component.',
                icon: 'warning',
                confirmButtonColor: '#F99022',
            });
            return;
        }
        setAllocatingComp(true);
        await handleLiveComponentChange(pendingCompValue);
        setAllocatingComp(false);
        setAllocateCompModalOpen(false);
        setPendingCompValue('');
        setLiveCompSearch('');
    };

    const formattedReasons = reasons.map(reason => ({
        ...reason,
        label: reason.label
    }));

    const handleConfirmAlert = () => {
        const operator = operators.find((o) => o.id === pendingOperator);
        if (confirmType === "operator" && !operator) return;
        Swal.fire({
            title: "Confirm Change",
            text:
                confirmType === "machine"
                    ? `Are you sure you want to change the machine to "${pendingMachine}"?`
                    : `Are you sure you want to change the operator to "${operator.id} - ${operator.name}"?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#F99022",
            cancelButtonColor: "#6b7280",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                handleConfirm();
            } else {
                handleCancel();
            }
        });
    };

    const handleRejectParts = async () => {
        setSelectedRow({
            machineName: selectedMachine,
            op: {
                goodvsexp: `${telemetry.totalShots}/0`,
                operation_name: telemetry.jobName || "No Operations",
            },
        });
        setExistingCount(telemetry.scrap || 0);
        setRejectRows([{ count: 0, reason: [], remark: "", isExisting: false }]);
        setIsFetchingBluecard(false);
        setPrevOperatorData(null);
        setEditingPrevOperator(null);
        setOpenReject(true);

        const deviceId = deviceNameIdJson[selectedMachine];

        // Fetch operations for current shift to get actual (goodvsexp numerator) and rejected counts
        if (deviceId && currentShift) {
            try {
                const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
                const opsData = await telemetrykeydata(deviceId, "DEVICE", "operations", shiftStart, shiftEnd);
                const rawOps = opsData?.operations || [];
                const parsedOps = rawOps
                    .map(item => {
                        try {
                            const v = typeof item.value === "string" ? JSON.parse(item.value) : item.value;
                            return { ts: item.ts, ...v };
                        } catch { return null; }
                    })
                    .filter(Boolean);

                if (parsedOps.length > 0) {
                    parsedOps.sort((a, b) => b.ts - a.ts);
                    const latestOp = parsedOps[0];
                    const actualFromOps = Number((latestOp.goodvsexp?.split("/") || [])[0] || 0);
                    const rejectedFromOps = Number(latestOp.rejected ?? 0);
                    setSelectedRow({
                        machineName: selectedMachine,
                        op: {
                            goodvsexp: latestOp.goodvsexp || `${actualFromOps}/0`,
                            operation_name: telemetry.jobName || "No Operations",
                        },
                    });
                    setExistingCount(rejectedFromOps);
                }
            } catch (err) {
                console.warn("Could not fetch operations data for reject parts", err);
            }
        }

        const startTime = telemetry?.liveComponent?.start_time;
        if (deviceId && startTime) {
            try {
                const existingData = await telemetrykeydata(deviceId, "DEVICE", "rejection", startTime - 1000, startTime + 1000);
                const entries = existingData?.rejection || [];
                if (entries.length > 0) {
                    let parsed = null;
                    try { parsed = typeof entries[0].value === "string" ? JSON.parse(entries[0].value) : entries[0].value; } catch { }
                    if (parsed && Number(parsed.operator_count || 0) > 0) {
                        setPrevOperatorData({
                            count: Number(parsed.operator_count || 0),
                            reason: Array.isArray(parsed.operator_reason) ? parsed.operator_reason : parsed.operator_reason ? [parsed.operator_reason] : [],
                            remark: Array.isArray(parsed.operator_remark) ? parsed.operator_remark.join(", ") : parsed.operator_remark || "",
                        });
                    }
                }
            } catch (err) {
                console.warn("Could not fetch previous operator rejection data", err);
            }
        }
    };

    const formatReason = (val) => {
        if (!val) return "-";
        if (Array.isArray(val)) return val.map(v => String(v).trim()).filter(Boolean).join(", ");
        return String(val);
    };
    const isGplast = cleanCustomerId(customerId1) === window._env_.GPLAST_CUSTOMER_ID;


    const handleLoginAndFetch = async (machineName,
        formattedDate,
        selectedShift,
        isLiveShift) => {
        try {
            const loginRes = await getReportToken(
                isGplast ? "gd" : "pmi",
                isGplast ? "gd" : "pmi"
            );
            const token = loginRes?.accessToken;
            if (!token) {
                console.warn("Token missing — skipping report call");
                return;
            }
            await getReportGenerate1(
                machineName,
                formattedDate,
                selectedShift,
                isLiveShift
            );
        } catch (err) {
            console.error("Login/report flow failed:", err);
        }
    };

    const handleSave = async () => {

        const filledRows = rejectRows.filter(
            row => !row.isExisting && (Number(row.count) || 0) > 0
        );

        if (filledRows.length === 0) return;

        const newCount = filledRows.reduce((sum, row) => sum + Number(row.count), 0);

        const newReasons = filledRows
            .flatMap(row => Array.isArray(row.reason) ? row.reason : [row.reason])
            .filter(Boolean);

        const newRemarks = filledRows
            .map(row => row.remark)
            .filter(Boolean);

        const deviceId = deviceNameIdJson[selectedMachine];
        const startTime = telemetry?.liveComponent?.start_time;

        if (!deviceId || !startTime) {
            Swal.fire("Error", "No active component found.", "error");
            return;
        }

        /* -------------------------------
           Existing Values
        --------------------------------*/

        let prevEmails = [];

        let prevOperatorCount = 0;
        let prevOperatorReasons = [];
        let prevOperatorRemarks = [];

        let prevQualityCount = 0;
        let prevQualityReason = [];
        let prevQualityRemark = [];
        let prevQualityRows = [];

        let prevCount = 0;
        let prevReasons = [];
        let prevRemarks = [];

        try {

            const existingData = await telemetrykeydata(
                deviceId,
                "DEVICE",
                "rejection",
                startTime - 1000,
                startTime + 1000
            );

            const entries = existingData?.rejection || [];

            if (entries.length > 0) {

                let parsed = null;

                try {
                    parsed = typeof entries[0].value === "string"
                        ? JSON.parse(entries[0].value)
                        : entries[0].value;
                } catch { }

                if (parsed) {

                    prevEmails = Array.isArray(parsed.operator_email)
                        ? parsed.operator_email
                        : parsed.operator_email
                            ? [parsed.operator_email]
                            : [];

                    prevOperatorCount = Number(parsed.operator_count || 0);

                    prevOperatorReasons = Array.isArray(parsed.operator_reason)
                        ? parsed.operator_reason
                        : parsed.operator_reason
                            ? [parsed.operator_reason]
                            : [];

                    prevOperatorRemarks = Array.isArray(parsed.operator_remark)
                        ? parsed.operator_remark
                        : parsed.operator_remark
                            ? [parsed.operator_remark]
                            : [];

                    prevQualityCount = Number(parsed.qualitycount || 0);

                    prevQualityReason = Array.isArray(parsed.qualityreason)
                        ? parsed.qualityreason
                        : parsed.qualityreason
                            ? [parsed.qualityreason]
                            : [];

                    prevQualityRemark = Array.isArray(parsed.quality_remark)
                        ? parsed.quality_remark
                        : parsed.quality_remark
                            ? [parsed.quality_remark]
                            : [];

                    prevQualityRows = Array.isArray(parsed.quality_rows)
                        ? parsed.quality_rows
                        : [];

                    prevCount = Number(parsed.count || 0);

                    prevReasons = Array.isArray(parsed.reason)
                        ? parsed.reason
                        : parsed.reason
                            ? [parsed.reason]
                            : [];

                    prevRemarks = Array.isArray(parsed.remark)
                        ? parsed.remark
                        : parsed.remark
                            ? [parsed.remark]
                            : [];
                }
            }

        } catch (err) {
            console.warn("Could not fetch existing rejection data", err);
        }

        /* -------------------------------
           Correct Merging Logic
        --------------------------------*/

        const combinedEmails = [
            ...new Set([...prevEmails, CustomerEmail])
        ];

        const operatorCount = prevOperatorCount + newCount;

        const operatorReasons = [
            ...new Set([...prevOperatorReasons, ...newReasons])
        ];

        const operatorRemarks = [
            ...prevOperatorRemarks,
            ...newRemarks
        ];

        const totalCount = prevCount + newCount;

        const finalReasons = [
            ...new Set([...prevReasons, ...newReasons])
        ];

        const finalRemarks = [
            ...prevRemarks,
            ...newRemarks
        ];

        /* -------------------------------
           Payload
        --------------------------------*/

        const key = {
            ts: startTime,
            values: {
                rejection: {

                    operator_email: combinedEmails,
                    operator_count: operatorCount,
                    operator_reason: operatorReasons,
                    operator_remark: operatorRemarks,

                    qualitycount: prevQualityCount,
                    qualityreason: prevQualityReason,
                    quality_remark: prevQualityRemark,
                    quality_rows: prevQualityRows,

                    count: totalCount,
                    reason: finalReasons,
                    remark: finalRemarks,

                    shift: currentShift?.shift_no
                }
            }
        };

        try {

            await Downtimeadd1("DEVICE", deviceId, "SERVER_SCOPE", key);

            setOpenReject(false);
            setRejectRows([{ count: 0, reason: [], remark: "" }]);

            Swal.fire({
                icon: "success",
                title: "Success",
                text: `${newCount} part(s) rejected successfully.`,
                timer: 2000,
                showConfirmButton: false
            });
            const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
            const todayStr = dayjs().format("YYYY-MM-DD");
            const selectedDateStr = dayjs(selectedDate).format("YYYY-MM-DD");
            const currentShift = getCurrentShift(shifts);

            const isToday = selectedDateStr === todayStr;
            const isCurrentShift = String(selectedShift) === String(currentShift);
            const isLiveShift = isToday && isCurrentShift;

            await handleLoginAndFetch(selectedMachine,
                formattedDate,
                currentShift?.shift_no,
                "true")

        } catch (err) {

            console.error("Reject API failed:", err);

            Swal.fire(
                "Error",
                "Failed to reject parts. Try again.",
                "error"
            );
        }
    };

    /**
     * GPLAST only — correct the operator rejection that was already saved for the
     * live component. Only the operator portion moves: the quality / blue-card
     * counts are written back untouched and the overall `count` drops by exactly
     * the amount the operator count was reduced by. The count field is capped at the
     * value already saved and floored at 1, so this can only ever lower a rejection,
     * never inflate one and never remove it entirely.
     */
    const handleUpdatePrevOperatorReject = async () => {
        if (!editingPrevOperator) return;

        const deviceId = deviceNameIdJson[selectedMachine];
        const startTime = telemetry?.liveComponent?.start_time;

        if (!deviceId || !startTime) {
            Swal.fire("Error", "No active component found.", "error");
            return;
        }

        const newCount = Number(editingPrevOperator.count) || 0;
        const newReasons = (Array.isArray(editingPrevOperator.reason) ? editingPrevOperator.reason : []).filter(Boolean);
        const newRemarks = [editingPrevOperator.remark].filter(Boolean);

        setIsSavingPrevOperator(true);
        try {
            const existingData = await telemetrykeydata(
                deviceId,
                "DEVICE",
                "rejection",
                startTime - 1000,
                startTime + 1000
            );

            const entries = existingData?.rejection || [];
            let parsed = null;
            if (entries.length > 0) {
                try {
                    parsed = typeof entries[0].value === "string"
                        ? JSON.parse(entries[0].value)
                        : entries[0].value;
                } catch { }
            }

            if (!parsed) {
                Swal.fire("Error", "Could not load the saved rejection entry.", "error");
                return;
            }

            const toArray = (val) => Array.isArray(val) ? val : val ? [val] : [];

            const prevOperatorCount = Number(parsed.operator_count || 0);
            const prevTotalCount = Number(parsed.count || 0);

            // Guard against a stale dialog: never write back more than was saved.
            const cappedCount = Math.min(newCount, prevOperatorCount);
            const delta = prevOperatorCount - cappedCount;

            const qualityReasons = toArray(parsed.qualityreason);
            const qualityRemarks = toArray(parsed.quality_remark);
            const bluecardReasons = toArray(parsed.bluecard_reason);
            const bluecardRemarks = toArray(parsed.bluecard_remark);

            const key = {
                ts: startTime,
                values: {
                    rejection: {
                        ...parsed,

                        operator_count: cappedCount,
                        operator_reason: newReasons,
                        operator_remark: newRemarks,

                        count: Math.max(0, prevTotalCount - delta),
                        reason: [...new Set([...newReasons, ...qualityReasons, ...bluecardReasons])].filter(Boolean),
                        remark: [...newRemarks, ...qualityRemarks, ...bluecardRemarks].filter(Boolean),

                        shift: parsed.shift ?? currentShift?.shift_no
                    }
                }
            };

            await Downtimeadd1("DEVICE", deviceId, "SERVER_SCOPE", key);

            setEditingPrevOperator(null);
            setOpenReject(false);
            setRejectRows([{ count: 0, reason: [], remark: "" }]);

            Swal.fire({
                icon: "success",
                title: "Updated",
                text: delta > 0
                    ? `Rejection reduced by ${delta} part(s).`
                    : "Rejection entry updated successfully.",
                timer: 2000,
                showConfirmButton: false
            });

            const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
            const liveShift = getCurrentShift(shifts);
            await handleLoginAndFetch(
                selectedMachine,
                formattedDate,
                liveShift?.shift_no,
                "true"
            );
        } catch (err) {
            console.error("Rejection update failed:", err);
            Swal.fire("Error", "Failed to update the rejection entry. Try again.", "error");
        } finally {
            setIsSavingPrevOperator(false);
        }
    };

    const isPrevOperatorEditValid = (() => {
        if (!editingPrevOperator) return false;
        // an emptied field is not "0" — make the operator type the number they mean
        if (editingPrevOperator.count === "" || editingPrevOperator.count === null) return false;
        const count = Number(editingPrevOperator.count);
        // 1 is the floor — reducing to nothing is not an edit, and reason/remark stay required
        if (!Number.isFinite(count) || count < 1 || count > Number(editingPrevOperator.maxCount || 0)) return false;
        return (editingPrevOperator.reason || []).length > 0 && !!String(editingPrevOperator.remark || "").trim();
    })();

    const formatBlueCardTimer = (seconds) => {
        const h = Math.floor(seconds / 3600);
        const m = Math.floor((seconds % 3600) / 60);
        const s = seconds % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
    };

    useEffect(() => {
        if (!blueCardTimerStart) {
            setBlueCardElapsed(0);
            return;
        }
        const interval = setInterval(() => {
            setBlueCardElapsed(Math.floor((Date.now() - blueCardTimerStart) / 1000));
        }, 1000);
        return () => clearInterval(interval);
    }, [blueCardTimerStart]);

    const showBlueCardSuccess = () => {
        Swal.fire({
            title: "Success",
            text: "Blue Card has been pushed successfully",
            icon: "success",
            showConfirmButton: false, // remove OK button
            timer: 1500,               // 3 seconds
            timerProgressBar: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
            width: "500px",
            customClass: {
                popup: "swal-wide"
            }
        });
    };


    const handleBlueCardPush = async (routeCardNo) => {
        if (!telemetry?.liveComponent?.name
        ) {
            console.warn("Blue card push skipped — missing component or shots");
            return;
        }
        showBlueCardSuccess();

        const operator = operators.find(
            op => String(op.id) === String(selectedOperator)
        );
        const payload = {
            job_name: telemetry.jobName || "",
            code: telemetry.jobCode || "",
            device_name: selectedMachine || "",
            clicked_ts: Date.now(),
            operator_name: operator?.name || "No Operator",
            component_starttime: telemetry?.liveComponent?.start_time,
            route_card_no: routeCardNo || "",
            total_shots: telemetry.totalShots ?? 0,
            target_parts: telemetry.targetParts ?? 0,
            shift: currentShift?.shift_no,

            status: "-",
            progress: "request",
        };

        setBlueCardLogs(prev => [...prev, payload]);

        blueCardTimerRef.current = payload.clicked_ts;
        setBlueCardTimerStart(payload.clicked_ts);
        setBlueCardElapsed(0);

        console.log("Stored in state:", payload);

        const customerId = getCustomerId();
        const deviceId = deviceNameIdJson[selectedMachine];

        const telemetryPayload = {
            ts: payload.clicked_ts,
            values: {
                bluecard_push: payload
            }
        };

        await operatorTelemetry(
            'CUSTOMER',
            customerId,
            telemetryPayload
        );

        try {
            const REQUEST_KEY = "request_payload";
            let existingRequests = [];
            try {
                const existing = await customerbasedshift(customerId, REQUEST_KEY);
                const val = existing[0]?.value;
                existingRequests = Array.isArray(val) ? val : [];
            } catch {
                existingRequests = [];
            }
            const updatedRequests = [...existingRequests, payload];
            await shiftadd(
                { [REQUEST_KEY]: updatedRequests, lastUpdateTs: Date.now() },
                customerId,
                "SERVER_SCOPE"
            );
            console.log("request_payload saved:", updatedRequests);
        } catch (err) {
            console.error("Failed to save request_payload:", err);
        }
    };

    useEffect(() => {
        const fetchRequestPayload = async () => {
            try {
                const customerId = getCustomerId();
                const result = await customerbasedshift(customerId, "request_payload");
                const val = result[0]?.value;
                setRequestPayload(Array.isArray(val) ? val : []);
            } catch (err) {
                console.error("request_payload fetch failed:", err);
                setRequestPayload([]);
            }
        };

        fetchRequestPayload();
        const poll = setInterval(fetchRequestPayload, 5000);
        return () => clearInterval(poll);
    }, []);

    useEffect(() => {
        const prev = prevRequestPayloadRef.current;
        const wasPending = prev.find(item => item.device_name === selectedMachine);
        const isStillPending = requestPayload.find(item => item.device_name === selectedMachine);

        if (wasPending && !isStillPending) {
            const fetchResponse = async () => {
                try {
                    const from = wasPending.clicked_ts - 1000;
                    const to = wasPending.clicked_ts + 1000;
                    const data = await telemetrykeydata(
                        cleanCustomerId(customerId1),
                        "CUSTOMER",
                        "bluecard_push",
                        from,
                        to
                    );
                    const entries = (data?.bluecard_push || [])
                        .map(p => {
                            try {
                                return typeof p.value === "string" ? JSON.parse(p.value) : p.value;
                            } catch { return null; }
                        })
                        .filter(e => e && e.device_name === wasPending.device_name && e.progress === "completed");

                    if (entries.length > 0) {
                        setBlueCardResponseData(entries[0]);
                        setOpenBlueCardResponse(true);
                        setBlueCardTimerStart(null);
                        setBlueCardElapsed(0);
                        blueCardTimerRef.current = null;
                    }
                } catch (err) {
                    console.error("Failed to fetch blue card response:", err);
                }
            };
            fetchResponse();
        }

        prevRequestPayloadRef.current = requestPayload;
    }, [requestPayload]);

    useEffect(() => {
        let blinkInterval;

        const hasPending = requestPayload.some(
            (item) => item.device_name === selectedMachine
        );

        if (hasPending) {
            setIsBlinking(true);
            setBlueCardText("Blue Card Pushed");

            blinkInterval = setInterval(() => {
                setIsBlinking((prev) => !prev);
            }, 500);
        } else {
            setIsBlinking(false);
            setBlueCardText("Blue Card Push");
        }

        return () => clearInterval(blinkInterval);
    }, [requestPayload, selectedMachine]);

    useEffect(() => {
        const machineData = requestPayload.find(
            item => item.device_name === selectedMachine
        );

        if (!machineData) {
            setBlueCardTimerStart(null);
            setBlueCardElapsed(0);
            return;
        }

        const startTime = machineData.clicked_ts;
        setBlueCardTimerStart(startTime);

        const interval = setInterval(() => {
            setBlueCardElapsed(
                Math.floor((Date.now() - startTime) / 1000)
            );
        }, 1000);

        return () => clearInterval(interval);
    }, [requestPayload, selectedMachine]);

    const showBlueCardConfirm = () => {
        Swal.fire({
            html: `
      <div style="text-align:center;padding:10px 10px;">
        <div
          style="
            width:80px;
            height:80px;
            border-radius:50%;
            border:4px solid #f4c7a1;
            display:flex;
            align-items:center;
            justify-content:center;
            margin:10px auto;
            color:#f4a261;
            font-size:40px;
            font-weight:bold;
          "
        >
          !
        </div>

        <p class="bluecard-swal-text" style="color:#000;margin-top:10px;font-size:20px;">
          Enter the Route Card No to push the Blue Card
        </p>

        <input
          id="routeCardInput"
          class="swal2-input"
          placeholder="Enter Route Card No"
          style="margin-top:10px;"
        />
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            confirmButtonColor: "#f97316",
            cancelButtonColor: "#6b7280",
            allowOutsideClick: false,
            width: "420px",

            didOpen: () => {
                const input = document.getElementById("routeCardInput");
                const confirmBtn = Swal.getConfirmButton();

                confirmBtn.disabled = true;

                const validateInput = () => {
                    const value = input.value.trim();
                    const isValid = /^[a-z0-9 ]+$/i.test(value) && value.length > 0;
                    confirmBtn.disabled = !isValid;
                };

                input.addEventListener("input", validateInput);
                input.addEventListener("keyup", validateInput);
            },

            preConfirm: () => {
                const value = document.getElementById("routeCardInput").value.trim();
                return value;
            }
        }).then((result) => {
            if (result.isConfirmed) {
                handleBlueCardPush(result.value);
                showBlueCardSuccess();
            }
        });
    };

    console.log('blue card data------------', blueCardLogs)
    console.log('selected shift', currentShift?.shift_no)
    console.log('selected shift no is', selectedShift)

    const blinkGreenBorder = keyframes`
  0%, 100% {
    box-shadow:
      inset 0 4px 0 0 rgba(21,128,61,0.9),
      inset -4px 0 0 0 rgba(21,128,61,0.9),
      inset 0 -4px 0 0 rgba(21,128,61,0.9),
      inset 4px 0 0 0 rgba(21,128,61,0.9),
      0 0 14px rgba(21,128,61,0.6);
  }
  50% {
    box-shadow:
      inset 0 4px 0 0 rgba(21,128,61,0.25),
      inset -4px 0 0 0 rgba(21,128,61,0.25),
      inset 0 -4px 0 0 rgba(21,128,61,0.25),
      inset 4px 0 0 0 rgba(21,128,61,0.25),
      0 0 6px rgba(21,128,61,0.25);
  }
`;

    /* ===== DARK RED ===== */
    const blinkRedBorder = keyframes`
  0%, 100% {
    box-shadow:
      inset 0 4px 0 0 rgba(185,28,28,0.9),
      inset -4px 0 0 0 rgba(185,28,28,0.9),
      inset 0 -4px 0 0 rgba(185,28,28,0.9),
      inset 4px 0 0 0 rgba(185,28,28,0.9),
      0 0 14px rgba(185,28,28,0.6);
  }
  50% {
    box-shadow:
      inset 0 4px 0 0 rgba(185,28,28,0.25),
      inset -4px 0 0 0 rgba(185,28,28,0.25),
      inset 0 -4px 0 0 rgba(185,28,28,0.25),
      inset 4px 0 0 0 rgba(185,28,28,0.25),
      0 0 6px rgba(185,28,28,0.25);
  }
`;

    const totalShotsNum = Number(telemetry?.totalShots || 0);

    const currentTimeTarget = (() => {
        if (!currentShift || !telemetry.targetParts) return 0;
        if (!telemetry.jobName || telemetry.jobName === "Route card not assigned") {
            return telemetry.targetParts;
        }
        const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
        if (!shiftStart || !shiftEnd) return 0;
        const elapsed = Math.max(0, Date.now() - shiftStart);
        const totalDuration = shiftEnd - shiftStart;
        return Math.min(telemetry.targetParts, Math.round((elapsed / totalDuration) * telemetry.targetParts));
    })();

    // ATECH single-component Actual vs Target (current-time based):
    // actual = good count (goodvsexp numerator); target = elapsed ÷ cycle_time, capped at full exp.
    const atechComponentActual = (() => {
        const op = telemetry.operations;
        if (!op || !op.goodvsexp) return null;
        const [actualStr, expStr] = String(op.goodvsexp).split('/');
        const actual = parseInt(actualStr, 10) || 0;
        const fullExp = parseInt(expStr, 10) || 0;
        const [h = 0, m = 0, s = 0] = String(op.cycle_time || '').split(':').map(Number);
        const cycleSecs = (h * 3600) + (m * 60) + s;
        // Fall back to the backend's full exp when we can't prorate (no cycle time / no start / no exp).
        if (!op.start_time || cycleSecs <= 0 || fullExp <= 0) return { actual, target: fullExp };
        const elapsedSecs = Math.max(0, (Date.now() - op.start_time) / 1000);
        const target = Math.min(fullExp, Math.floor(elapsedSecs / cycleSecs));
        return { actual, target };
    })();

    const blueCardPushCount = blueCardLogs.filter(log => log.device_name === selectedMachine &&
        log.component === telemetry.jobName).length;
    const isBlueCardLimitReached = blueCardPushCount >= totalShotsNum && totalShotsNum != 0;
    console.log('telemetry', telemetry)

    const prevRejectHeaders = isGplast ? ["Count", "Reason", "Remark", "Action"] : ["Count", "Reason", "Remark"];
    const prevRejectGridColumns = isGplast ? "100px 1fr 1fr 120px" : "100px 1fr 1fr";

    const rejectActual = Number((selectedRow?.op?.goodvsexp?.split("/") || [])[0] || 0);
    const rejectAllowed = Math.max(0, rejectActual - (existingCount || 0));
    const totalNewRejectCount = rejectRows.reduce((sum, r) => !r.isExisting ? sum + Number(r.count || 0) : sum, 0);
    const isMaxReached = totalNewRejectCount >= rejectAllowed;
    const existingRows = rejectRows.filter(r => r.isExisting);

    const handleRejectParts1 = async (deviceId, initialCount = 0) => {
        let rejectCount = initialCount;
        await Swal.fire({
            title: "Reject Parts",
            html: `
      <div style="display:flex; align-items:center; justify-content:center; gap:30px;">
        <button id="decrement" 
          style="width:50px;height:50px;border-radius:50%;font-size:24px;font-weight:bold;background:#f56565;color:white;border:none;cursor:pointer;">-</button>
        <span id="counterValue" style="font-size:28px; font-weight:bold; min-width:50px; text-align:center;">${rejectCount}</span>
        <button id="increment" 
          style="width:50px;height:50px;border-radius:50%;font-size:24px;font-weight:bold;background:#48bb78;color:white;border:none;cursor:pointer;">+</button>
      </div>
    `,
            showCancelButton: true,
            confirmButtonText: "Continue",
            cancelButtonText: "Cancel",
            didOpen: () => {
                const counterEl = Swal.getHtmlContainer().querySelector("#counterValue");
                const incBtn = Swal.getHtmlContainer().querySelector("#increment");
                const decBtn = Swal.getHtmlContainer().querySelector("#decrement");
                const produced = telemetry.totalShots || 0;
                const alreadyRejected = telemetry.scrap || 0;
                const maxReject = produced - alreadyRejected;
                incBtn.addEventListener("click", () => {
                    if (rejectCount < maxReject) {
                        rejectCount++;
                        counterEl.textContent = rejectCount;
                    } else {
                        Swal.showValidationMessage(`Cannot exceed ${maxReject} parts`);
                    }
                });
                decBtn.addEventListener("click", () => {
                    if (rejectCount > 0) {
                        rejectCount--;
                        counterEl.textContent = rejectCount;
                    }
                });
            },
            preConfirm: () => {
                if (rejectCount <= 0) {
                    Swal.showValidationMessage("Please select at least 1 reject part");
                    return false;
                }
                return rejectCount;
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const count = result.value;
                Swal.fire({
                    title: "Confirm Rejection",
                    text: `Are you sure you want to reject ${count} part(s)?`,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: "Yes, Reject",
                    cancelButtonText: "No, Go Back",
                }).then(async (confirmResult) => {
                    if (confirmResult.isConfirmed) {
                        try {
                            const payload = { ts: dayjs().valueOf(), values: { rejection_id: count } };
                            await operatorTelemetry("DEVICE", deviceId, payload);
                            Swal.fire({
                                icon: "success",
                                title: "Success",
                                text: `${count} part(s) rejected successfully.`,
                                timer: 2000,
                                showConfirmButton: false,
                            });
                        } catch (err) {
                            console.error("Reject API failed:", err);
                            Swal.fire("Error", "Failed to reject parts. Try again.", "error");
                        }
                    } else if (confirmResult.dismiss === Swal.DismissReason.cancel) {
                        handleRejectParts1(deviceId, count);
                    }
                });
            }
        });
    };

    // Pending-unlock banner: shown ONLY as a warning when a queued unlock can't be
    // delivered because there's no network or TB is unreachable. While delivery is
    // actually in progress (netStatus === 'online') no banner is shown — the queue
    // finishes on its own and the header icon already reflects the connection state.
    const bannerInfo = netStatus === 'offline'
        ? {
            background: '#E53E3E', // red
            Icon: MdWifiOff,
            text: 'No network connection — machine will unlock automatically once connection is restored.',
        }
        : netStatus === 'server-down'
            ? {
                background: '#B7791F', // amber
                Icon: MdCloudOff,
                text: 'Server unreachable — machine will unlock automatically once the server is back.',
            }
            : null;
    const BannerIcon = bannerInfo?.Icon;

    if (unknownPlantSlug) {
        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    width: '100%',
                    background: '#ffffff',
                    textAlign: 'center',
                    padding: '1.5rem',
                }}
            >
                <div
                    style={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        background: '#FCE7E7',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: '1rem',
                    }}
                >
                    <MdErrorOutline size={24} color="#E53E3E" />
                </div>
                <h2 style={{ margin: 0, marginBottom: '0.4rem', color: '#1a1a1a', fontSize: '1.1rem' }}>Unknown plant</h2>
                <p style={{ margin: 0, color: '#6b7280', maxWidth: 380, fontSize: '0.85rem' }}>
                    "{unknownPlantSlug}" is not a configured plant for this screen. Check the URL or contact your administrator.
                </p>
            </div>
        );
    }

    return (
        <div className="operator-screen" data-theme={isDark ? 'dark' : 'light'}>
            {reliableStatus.pending > 0 && bannerInfo && (
                <div
                    role="status"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        zIndex: 99999,
                        background: bannerInfo.background,
                        color: '#fff',
                        padding: '8px 16px',
                        textAlign: 'center',
                        fontSize: 15,
                        fontWeight: 600,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 8,
                    }}
                >
                    <BannerIcon style={{ flexShrink: 0 }} />
                    <span>
                        {bannerInfo.text}
                        {reliableStatus.pending > 1 ? ` (${reliableStatus.pending} pending)` : ''}
                    </span>
                </div>
            )}
            <div className="header">
                <img className="Logo" src={logo} alt="Logo" />
                <div className="header-text-element">
                    <h5>
                        <span className="span-1">Yantra </span>
                        <span className="span-2">Smart Buddy</span>
                    </h5>
                </div>
                <div className="calendar-container">
                    <div className="calendar">
                        <FaRegCalendarAlt className="icon" style={{ color: '#F99022' }} />
                        <p className='date-label'>{date}</p>
                    </div>

                    <div className="calendar">
                        <FaRegClock className='icon' style={{ color: '#F99022' }} />
                        <p className='date-label'>{time}</p>
                    </div>
                    <div
                        className="calendar"
                        title={
                            netStatus === 'online' ? 'Server connected'
                                : netStatus === 'offline' ? 'No network connection'
                                    : 'Server unreachable'
                        }
                    >
                        {netStatus === 'online'
                            ? <FaWifi className="icon" style={{ color: '#38A169' }} />
                            : netStatus === 'offline'
                                ? <MdWifiOff className="icon" style={{ color: '#E53E3E' }} />
                                : <MdCloudOff className="icon" style={{ color: '#E53E3E' }} />}
                    </div>
                    <button className="theme-toggle" onClick={toggleTheme} title={isDark ? 'Switch to Light' : 'Switch to Dark'}>
                        {isDark ? <FaSun /> : <FaMoon />}
                    </button>
                    <button
                        className={`theme-toggle ${keyboardEnabled ? 'keyboard-toggle-on' : 'keyboard-toggle-off'}`}
                        onClick={toggleKeyboard}
                        title={keyboardEnabled ? 'Virtual keyboard: ON (click to hide)' : 'Virtual keyboard: OFF (click to show)'}
                    >
                        {keyboardEnabled ? <MdKeyboard /> : <MdKeyboardHide />}
                    </button>
                    <button
                        className="theme-toggle"
                        onClick={() => window.location.reload()}
                        title="Refresh screen"
                    >
                        <FaSyncAlt />
                    </button>
                    {isAtechCondition && (() => {
                        const url = window.location.origin + '/';
                        return (
                            <button
                                onClick={() => window.open(url, '_blank')}
                                title="Open Portal"
                                onMouseEnter={e => e.currentTarget.style.background = '#ea6c00'}
                                onMouseLeave={e => e.currentTarget.style.background = '#F99022'}
                                style={{
                                    background: '#F99022',
                                    border: 'none',
                                    borderRadius: '6px',
                                    padding: '6px 12px',
                                    cursor: 'pointer',
                                    color: '#fff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    marginLeft: '8px',
                                    transition: 'background 0.2s ease',
                                    boxShadow: '0 2px 6px rgba(249,144,34,0.4)',
                                    fontSize: '0.82rem',
                                    fontWeight: 700,
                                }}
                            >
                                <FaExternalLinkAlt size={13} style={{ marginRight: '6px' }} />
                                Setter Login
                            </button>
                        );
                    })()}
                    {/* Blue Card Notification Bell */}
                    {isPMIBlueCardPage && (

                        <div ref={notifBellRef} style={{ position: 'relative', marginLeft: '16px', cursor: 'pointer' }}>
                            <div onClick={() => setShowBlueCardNotif(prev => !prev)} style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <FaBell size={22} style={{ color: '#6b7280' }} />
                                {blueCardNotifications.length > 0 && (
                                    <span style={{
                                        position: 'absolute', top: -6, right: -6,
                                        background: '#F99022', color: 'white',
                                        borderRadius: '50%', width: 18, height: 18,
                                        fontSize: 11, fontWeight: 700,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        lineHeight: 1,
                                    }}>
                                        {blueCardNotifications.length}
                                    </span>
                                )}
                            </div>

                            {showBlueCardNotif && (
                                <div style={{
                                    position: 'absolute', top: '110%', right: 0, zIndex: 1100,
                                    background: t.bg, border: `1px solid ${t.border}`,
                                    borderRadius: '10px', boxShadow: isDark ? '0 8px 24px rgba(0,0,0,0.5)' : '0 8px 24px rgba(0,0,0,0.14)',
                                    minWidth: 320, maxHeight: 360, overflowY: 'auto',
                                }}>
                                    <div style={{ padding: '10px 16px', fontWeight: 700, fontSize: 14, borderBottom: `1px solid ${t.border}`, color: t.text }}>
                                        Blue Card Responses
                                        {telemetry?.liveComponent?.name && (
                                            <span style={{ fontWeight: 400, fontSize: 12, color: t.textSub, marginLeft: 8 }}>
                                                ({telemetry.liveComponent.name})
                                            </span>
                                        )}
                                    </div>
                                    {blueCardNotifications.length === 0 ? (
                                        <div style={{ padding: '24px 16px', textAlign: 'center', color: t.textSub, fontSize: 13 }}>
                                            No responses yet for this component
                                        </div>
                                    ) : (
                                        [...blueCardNotifications].reverse().map((n, i) => {
                                            const relTime = (() => {
                                                if (!n.receivedAt) return '';
                                                const diff = Math.floor((Date.now() - n.receivedAt) / 1000);
                                                if (diff < 60) return 'Just now';
                                                if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
                                                return `${Math.floor(diff / 3600)}h ago`;
                                            })();
                                            return (
                                                <div key={i} style={{
                                                    padding: '10px 16px', borderBottom: `1px solid ${t.border}`,
                                                    background: i === 0 ? t.bgRow : t.bg,
                                                    color: t.text,
                                                }}>
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
                                                        <span style={{ fontWeight: 600, fontSize: 14, color: n.status === 'OK' ? '#16a34a' : '#dc2626' }}>
                                                            {n.status === 'OK' ? '✓ Approved' : '✗ Rejected'} — {n.device_name || '-'}
                                                        </span>
                                                        <span style={{ fontSize: 11, color: t.textSub, whiteSpace: 'nowrap', marginLeft: 8 }}>
                                                            {relTime}
                                                        </span>
                                                    </div>
                                                    {n.status === 'NOK' && n.reason && (
                                                        <div style={{ fontSize: 12, color: t.text, marginBottom: 2 }}>
                                                            <strong>Reason:</strong> {Array.isArray(n.reason) ? n.reason.join(', ') : n.reason}
                                                        </div>
                                                    )}
                                                    {n.status === 'NOK' && n.remarks && n.remarks !== '-' && (
                                                        <div style={{ fontSize: 12, color: t.text }}>
                                                            <strong>Remark:</strong> {n.remarks}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                </div>
            </div>
            <div className="header-2" style={{ background: telemetry.machineColor }}>
                <div className="machine-name">
                    <p>Machine:</p>
                    {(() => {
                        const machineInfo = JSON.parse(localStorage.getItem("machineInfo"));
                        const urlDeviceId = getUrlDeviceId();
                        if (urlDeviceId) {
                            const urlLockedMachine = Object.keys(deviceNameIdJson).find((n) => deviceNameIdJson[n] === urlDeviceId);
                            // Device id came from the URL — show only that machine, no dropdown.
                            return (
                                <div style={{ color: "white", marginLeft: "0.5rem" }}>
                                    {urlLockedMachine || selectedMachine || "Loading..."}
                                </div>
                            );
                        }
                        if (machineInfo?.machine_name && machineInfo?.machine_id) {
                            // Show only the stored machine
                            return (
                                <div style={{ color: "white", marginLeft: "0.5rem" }}>
                                    {machineInfo.machine_name}
                                </div>
                            );
                        } else {
                            // Show dropdown
                            return (
                                <FormControl
                                    size="small"
                                    variant="standard"
                                    sx={{
                                        minWidth: 120,
                                        marginLeft: "0.5rem",
                                        "& .MuiInputBase-root": { color: "white" },
                                        "& .MuiSvgIcon-root": { color: "white" },
                                        "& .MuiInput-underline:before": { borderBottom: "1px solid white" },
                                        "& .MuiInput-underline:hover:before": {
                                            borderBottom: "2px solid white",
                                        },
                                    }}
                                >
                                    <Select
                                        value={selectedMachine}
                                        open={machineMenuOpen}
                                        onOpen={() => setMachineMenuOpen(true)}
                                        onClose={() => { setMachineMenuOpen(false); setMachineSearch(""); }}
                                        onChange={(e) => {
                                            if (!e.target.value) return;
                                            setPendingMachine(e.target.value);
                                            setConfirmType("machine");
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                className: "operator-select-menu",
                                                style: { maxHeight: "40vh" },
                                            },
                                            anchorOrigin: { vertical: "bottom", horizontal: "left" },
                                            transformOrigin: { vertical: "top", horizontal: "left" },
                                            autoFocus: false,
                                        }}
                                    >
                                        <MenuItem
                                            disableRipple
                                            onKeyDown={(e) => e.stopPropagation()}
                                            sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                        >
                                            <TextField
                                                size="small"
                                                placeholder="Search machine…"
                                                value={machineSearch}
                                                onChange={(e) => setMachineSearch(e.target.value)}
                                                autoFocus
                                                fullWidth
                                                onClick={(e) => e.stopPropagation()}
                                                autoComplete="off"
                                                sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                            />
                                        </MenuItem>
                                        {machines
                                            .filter((machine) => machine.toLowerCase().includes(machineSearch.toLowerCase()))
                                            .map((machine) => (
                                                <MenuItem key={machine} value={machine}>
                                                    {machine}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            );
                        }
                    })()}

                </div>
                <div className="header-2-right">
                    <div className="machine-name">
                        <p>Status: {telemetry.machineStatus.charAt(0).toUpperCase() + telemetry.machineStatus.slice(1)}
                        </p>
                    </div>
                    {isLocked && (
                        <Button
                            variant="contained"
                            size="small"
                            onClick={() => reopenReasonPopupRef.current && reopenReasonPopupRef.current()}
                            sx={{
                                marginLeft: "0.75rem",
                                backgroundColor: "#fff",
                                color: "#b91c1c",
                                fontWeight: 600,
                                textTransform: "none",
                                whiteSpace: "nowrap",
                                "&:hover": { backgroundColor: "#f3f4f6" },
                            }}
                        >
                            Enter / Change Reason
                        </Button>
                    )}
                </div>
            </div>
            {isAtechCondition && deviceNameIdJson[selectedMachine] && currentShift && (() => {
                const { shiftStart, shiftEnd } = getShiftEpoch(currentShift.start_time, currentShift.end_time);
                if (!shiftStart || !shiftEnd) return null;
                const bearerToken = encodeURIComponent('Bearer+' + localStorage.getItem('token1'));
                const deviceId = deviceNameIdJson[selectedMachine];
                const grafanaUrl = window._env_.GRAFANA_URL;
                const serverUrl = window._env_.SERVER_URL;
                const iframeSrc = `${grafanaUrl}d/dfl4xwf27vp4we/machine-status-timeline?orgId=1&var-token=${bearerToken}&var-deviceId=${deviceId}&var-url=${serverUrl}&var-grafanaurl=${grafanaUrl}&from=${shiftStart}&to=now&theme=${isDark ? 'dark' : 'light'}&kiosk`;
                return (
                    <iframe
                        key={`grafana-mchstat-${currentShift.shift_no}-${selectedMachine}`}
                        src={iframeSrc}
                        style={{ display: 'block', width: '100%', height: '100px', border: 'none' }}
                        scrolling="no"
                        title="Machine Status Timeline"
                    />
                );
            })()}
            <div className="content">
                <div className="contect-section" style={{ width: '10rem' }}>
                    <VerticalProgress
                        shiftNo={currentShift?.shift_no}
                        shiftStart={currentShift?.start_time}
                        shiftEnd={currentShift?.end_time}
                        firstActive={telemetry?.firstActive}
                    />
                </div>
                <div className="contect-section circular-progress-section">
                    <CircularProgress
                        actual={telemetry.totalShots}
                        target={isAtechCondition && currentTimeTarget > 0 ? currentTimeTarget : telemetry.targetParts}
                        partsBehind={Math.max(0, (isAtechCondition && currentTimeTarget > 0 ? currentTimeTarget : telemetry.targetParts) - telemetry.totalShots)}
                        partsRejects={telemetry.scrap}
                        status={telemetry.machineStatus}
                    />
                    <div className="username-section">
                        <FormControl
                            variant="standard"
                            sx={{
                                minWidth: 140,
                                "& .MuiInputBase-root": { color: "#f99022", fontWeight: 600 },
                                "& .MuiSvgIcon-root": { color: "#f99022" },
                            }}
                        >
                            <Select
                                value={operatorSearch ? "" : (selectedOperator || "")}
                                open={operatorMenuOpen}
                                onOpen={() => setOperatorMenuOpen(true)}
                                onClose={() => { setOperatorMenuOpen(false); setOperatorSearch(""); }}
                                onChange={(e) => {
                                    if (!e.target.value) return;
                                    setPendingOperator(e.target.value);
                                    setConfirmType("operator");
                                }}
                                MenuProps={{
                                    PaperProps: {
                                        className: "operator-select-menu operator-select-list-menu",
                                        style: {
                                            maxHeight: 320,
                                        },
                                    },
                                    anchorOrigin: { vertical: "top", horizontal: "left" },
                                    transformOrigin: { vertical: "bottom", horizontal: "left" },
                                    autoFocus: false,
                                }}
                                displayEmpty
                                renderValue={() => {
                                    if (!selectedOperator) return <span style={{ color: "#f99022" }}>No operator assigned</span>;
                                    const operator = operators.find(op => String(op.id) === String(selectedOperator));
                                    return operator ? `${operator.id} - ${operator.name}` : "";
                                }}
                                disableUnderline
                            >
                                <MenuItem
                                    disableRipple
                                    onKeyDown={(e) => e.stopPropagation()}
                                    sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                >
                                    <TextField
                                        size="small"
                                        placeholder="Search by ID or name…"
                                        value={operatorSearch}
                                        onChange={(e) => setOperatorSearch(e.target.value)}
                                        autoFocus
                                        fullWidth
                                        onClick={(e) => e.stopPropagation()}
                                        autoComplete="off"
                                        sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                    />
                                </MenuItem>
                                <MenuItem disabled value="">
                                    No operator assigned
                                </MenuItem>
                                {operators
                                    .filter(op => {
                                        const q = operatorSearch.toLowerCase();
                                        return !q || String(op.id).toLowerCase().includes(q) || op.name.toLowerCase().includes(q);
                                    })
                                    .map((op, idx) => (
                                        <MenuItem key={`${op.id}-${idx}`} value={op.id}>
                                            {op.id} - {op.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </div>
                </div>
                <div className="contect-section">
                    {isGplastCondition && window._env_.GPLAST_DEVICE_IDS?.includes(deviceNameIdJson[selectedMachine]) ? (
                        <div className="job-info">
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Button
                                    variant="contained"
                                    className="filter_btn btn_orange"
                                    sx={{
                                        backgroundColor: '#ff9800',
                                        fontSize: '0.85rem',
                                        textTransform: 'none',
                                        '&:hover': { backgroundColor: '#e68900' },
                                        '&:active': { backgroundColor: '#cc7a00' },
                                        '& .MuiTouchRipple-child': { backgroundColor: 'rgba(255,255,255,0.6)' },
                                    }}
                                    onClick={openAllocateCompModal}
                                >
                                    {liveCompSelected ? 'Change Component' : 'Allocate Component'}
                                </Button>
                                <div style={{ marginTop: 20, fontWeight: 600, fontSize: '1.1rem', color: '#444', textAlign: 'center' }}>
                                    {getComponentLabelForKey(liveCompSelected) || (
                                        <span style={{ color: "#aaa", fontWeight: 400 }}>No component</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ) : (

                        <div className="job-info">
                            <p className="job-code">{telemetry.jobCode || ""}</p>
                            <p className="job-name">{telemetry.jobName || "—"}</p>
                        </div>
                    )}

                    <div className="time-wrapper">
                        <div className="time-item">
                            <span>Cycle Time</span>
                            <p>{telemetry?.liveComponent?.cycle_time || "00:00:00"}</p>
                        </div>
                        <div className="time-item">
                            <span>Handling Time</span>
                            <p>{telemetry?.liveComponent?.handling_time || "00:00:00"}</p>
                        </div>
                    </div>

                    <div className="actual-wrapper">
                        <p className="actual-label">{isAtechCondition ? 'Actual vs Target (Current)' : 'Actual vs Target'}</p>
                        <p className="actual-value">
                            {isAtechCondition
                                ? (atechComponentActual
                                    ? `${atechComponentActual.actual}/${atechComponentActual.target}`
                                    : `${telemetry.totalShots ?? 0}/${telemetry.targetParts ?? 0}`)
                                : `${telemetry.totalShots ?? 0}/${telemetry.targetParts ?? 0}`}
                        </p>
                        {isAtechCondition && telemetry.targetParts > 0 && (
                            <>
                                <p className="actual-label" style={{ marginTop: '20px' }}>Actual vs Target (Overall)</p>
                                <p className="actual-value">
                                    {telemetry.totalShots ?? 0}/{telemetry.targetParts}
                                </p>
                            </>
                        )}
                    </div>

                    {/* Blue card button */}
                    {isPMIBlueCardPage && (
                        <div
                            className="button-wrapper"
                            style={{
                                padding: "12px",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <button
                                className={`blue-card-button ${isBlinking ? "blink" : ""}`}
                                style={{
                                    fontSize: "20px",
                                    cursor: (blueCardText === "Blue Card Pushed" || !telemetry.jobName || telemetry.jobName === "Route card not assigned")
                                        ? "not-allowed"
                                        : "pointer",
                                    opacity: (blueCardText === "Blue Card Pushed" || !telemetry.jobName || telemetry.jobName === "Route card not assigned") ? 0.7 : 1
                                }}
                                onClick={() => {
                                    if (
                                        blueCardText === "Blue Card Pushed" ||
                                        !telemetry.jobName ||
                                        telemetry.jobName === "Route card not assigned"
                                    ) {
                                        return;
                                    }

                                    // ⭐ IMPORTANT: show error when limit reached
                                    if (isBlueCardLimitReached) {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Limit Reached",
                                            text: `Blue Card can only be pushed ${telemetry.totalShots} times.`,
                                            confirmButtonColor: "#d33",
                                        });
                                        return;
                                    }

                                    showBlueCardConfirm();
                                }}
                                disabled={
                                    blueCardText === "Blue Card Pushed" ||
                                    !telemetry.jobName ||
                                    telemetry.jobName === "Route card not assigned"
                                }
                            >
                                {blueCardText}
                            </button>

                            {blueCardTimerStart && (
                                <div
                                    style={{
                                        marginTop: "10px",
                                        fontSize: "16px",
                                        fontWeight: "600",
                                        color: "#cc5500",
                                    }}
                                >
                                    Waiting Time: {formatBlueCardTimer(blueCardElapsed)}
                                </div>
                            )}
                            <style jsx>{`
  .blue-card-button {
    position: relative;
    padding: 12px 24px;
    font-size: 16px;
    border-radius: 50px; /* pill shape */
    border: none;
    background-color: #007bff;
    color: white;
    cursor: pointer;
    z-index: 0;
    overflow: visible;
  }

  /* Ripple layers radiating outward */
  .blue-card-button.blink::before,
  .blue-card-button.blink::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 100%;
    height: 100%;
    border-radius: inherit;
    background-color: rgba(0, 123, 255, 0.4);
    z-index: -1;
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.7;
  }

  /* First layer */
  .blue-card-button.blink::before {
    animation: pulse1 2s infinite;
  }

  /* Second layer with staggered start and longer duration */
  .blue-card-button.blink::after {
    animation: pulse2 3s infinite;
  }

  @keyframes pulse1 {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.7;
    }
    70% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }

  @keyframes pulse2 {
    0% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.6;
    }
    70% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
    100% {
      transform: translate(-50%, -50%) scale(2.5);
      opacity: 0;
    }
  }
`}</style>
                        </div>
                    )}
                </div>

                <Dialog
                    open={openBlueCardConfirm}
                    onClose={() => setOpenBlueCardConfirm(false)}
                    PaperProps={{
                        sx: {
                            borderRadius: "8px",
                            padding: "10px 20px",
                            minWidth: "420px",
                            textAlign: "center",
                        },
                    }}
                >
                    <DialogContent>
                        <div
                            style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                border: "4px solid #f4c7a1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "10px auto",
                                color: "#f4a261",
                                fontSize: 40,
                                fontWeight: "bold",
                            }}
                        >
                            !
                        </div>
                        <p style={{ color: "#555", marginBottom: 20, fontSize: "20px" }}>
                            Enter the Route Card No to push Blue Card
                        </p>

                        <div style={{ display: "flex", justifyContent: "center", gap: 12, fontSize: "14px" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#f97316",
                                    padding: "10px 20px",
                                    "&:hover": { backgroundColor: "#ea580c" },
                                }}
                                onClick={() => {
                                    setOpenBlueCardConfirm(false);   // close confirm dialog
                                    handleBlueCardPush();            // push data
                                    setOpenBlueCardSuccess(true);    // open success dialog
                                }}
                            >
                                Confirm
                            </Button>

                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#6b7280",
                                    padding: "6px 20px",
                                    "&:hover": { backgroundColor: "#4b5563" },
                                }}
                                onClick={() => setOpenBlueCardConfirm(false)}
                            >
                                cancel
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={openBlueCardResponse} disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason !== "backdropClick") {
                            setOpenBlueCardResponse(false);
                        }
                    }}
                    PaperProps={{
                        sx: {
                            borderRadius: "12px",
                            minWidth: "380px",
                            textAlign: "center",
                            overflow: "hidden",
                            background: blueCardResponseData?.status === "OK" ? "#0b9348" : "#fd3f3f",
                        },
                    }}
                >

                    <DialogContent
                        sx={{
                            padding: "28px 32px 20px",
                            background: "#ffffff",
                            textAlign: "center",

                            borderRadius: "12px",
                            animation:
                                blueCardResponseData?.status === "OK"
                                    ? `${blinkGreenBorder} 1.5s ease-in-out infinite`
                                    : `${blinkRedBorder} 1.5s ease-in-out infinite`,
                        }}
                    >
                        {/* Icon */}
                        <div
                            style={{
                                width: 80,
                                height: 80,
                                borderRadius: "50%",
                                background:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0 auto 16px",
                                color: "#fff",
                                fontSize: 40,
                                fontWeight: "bold",
                            }}
                        >
                            {blueCardResponseData?.status === "OK" ? "✓" : "✗"}
                        </div>

                        {/* Status heading */}
                        <h3
                            style={{
                                margin: "0 0 6px",
                                fontSize: "23px",
                                fontWeight: 700,
                                color:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                            }}
                        >
                            {blueCardResponseData?.status === "OK"
                                ? "Blue Card Approved"
                                : "Blue Card Rejected"}
                        </h3>

                        {/* Machine */}
                        <p style={{ marginBottom: "6px", fontSize: "16px", color: "#374151" }}>
                            <strong>Machine:</strong>{" "}
                            <span
                                style={{
                                    color:
                                        blueCardResponseData?.status === "OK"
                                            ? "#16a34a"
                                            : "#dc2626",
                                    fontWeight: 600
                                }}
                            >
                                {blueCardResponseData?.device_name || "-"}
                            </span>
                        </p>

                        {/* Time */}
                        {blueCardResponseData?.end_time && (
                            <p style={{ marginBottom: "16px", fontSize: "14px", color: "#374151" }}>
                                at{" "}
                                <strong
                                    style={{
                                        color:
                                            blueCardResponseData?.status === "OK"
                                                ? "#16a34a"
                                                : "#dc2626",
                                    }}
                                >
                                    {new Date(blueCardResponseData.end_time).toLocaleTimeString(
                                        "en-IN",
                                        {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                            second: "2-digit",
                                            hour12: true,
                                        }
                                    )}
                                </strong>
                            </p>
                        )}

                        {/* NOK details */}
                        {blueCardResponseData?.status === "NOK" && (
                            <div
                                style={{
                                    background: "#ffffff",
                                    border:
                                        blueCardResponseData?.status === "OK"
                                            ? "1px solid #bbf7d0"
                                            : "1px solid #f04343",
                                    borderRadius: "8px",
                                    padding: "14px 16px",
                                    textAlign: "left",
                                    marginBottom: "16px",
                                }}
                            >
                                <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#374151" }}>
                                    <strong>Reason:</strong>{" "}
                                    <span
                                        style={{
                                            color:
                                                blueCardResponseData?.status === "OK"
                                                    ? "#16a34a"
                                                    : "#dc2626",
                                            fontWeight: 600,
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {Array.isArray(blueCardResponseData?.reason)
                                            ? blueCardResponseData.reason.join(", ")
                                            : blueCardResponseData?.reason || "Not provided"}
                                    </span>
                                </p>

                                <p style={{ margin: 0, fontSize: "14px", color: "#374151" }}>
                                    <strong>Remark:</strong>{" "}
                                    <span
                                        style={{
                                            color:
                                                blueCardResponseData?.status === "OK"
                                                    ? "#16a34a"
                                                    : "#dc2626",
                                            fontWeight: 600,
                                            wordBreak: "break-word",
                                            overflowWrap: "anywhere",
                                            whiteSpace: "normal",
                                        }}
                                    >
                                        {blueCardResponseData?.remarks &&
                                            blueCardResponseData.remarks !== "-"
                                            ? blueCardResponseData.remarks
                                            : "Not provided"}
                                    </span>
                                </p>
                            </div>
                        )}

                        <Button
                            variant="contained"
                            sx={{
                                marginTop: 1,
                                backgroundColor:
                                    blueCardResponseData?.status === "OK" ? "#16a34a" : "#dc2626",
                                "&:hover": {
                                    backgroundColor:
                                        blueCardResponseData?.status === "OK" ? "#15803d" : "#b91c1c",
                                },
                                minWidth: 120,
                            }}
                            onClick={() => {
                                if (blueCardResponseData) {
                                    setBlueCardNotifications(prev => [...prev, { ...blueCardResponseData, receivedAt: Date.now() }]);
                                }
                                setOpenBlueCardResponse(false);
                            }}
                        >
                            OK
                        </Button>
                    </DialogContent>
                </Dialog>

            </div>
            <div className="footer1">
                <div
                    className="footer-left"
                    onClick={() => {
                        if (telemetry.jobName && telemetry.jobName !== "Route card not assigned") {
                            if (isGplastCondition) {
                                handleRejectParts();
                            } else {
                                handleRejectParts1(deviceNameIdJson[selectedMachine]);
                            }
                        }
                    }}
                    style={{ opacity: (telemetry.jobName && telemetry.jobName !== "Route card not assigned") ? 1 : 0.4, cursor: (telemetry.jobName && telemetry.jobName !== "Route card not assigned") ? "pointer" : "not-allowed" }}
                >
                    <FaPause />
                    Reject Parts
                </div>
                <div
                    className="footer-right"
                    onClick={() =>
                        openDownTime(selectedMachine, deviceNameIdJson[selectedMachine])
                    }                >
                    <RxCross2 />
                    Reason for Downtime
                </div>
            </div>
            <Dialog
                open={openDownTimeModal}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        setopenDownTimeModal(false);
                    }
                }}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '70%',
                        maxWidth: '70%'
                    }
                }}
            >
                <DialogTitle style={{ textAlign: "center" }}>
                    Assign Reason
                </DialogTitle>                <DialogContent>
                    <br></br>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginLeft: '10px' }}>
                    </div>
                    {filteredResult.length > 0 ? (
                        <div style={{ marginTop: '20px', maxHeight: '300px', overflowY: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                <colgroup>
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '12%' }} />
                                    <col style={{ width: '12%' }} />
                                    {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (
                                        <col style={{ width: '12%' }} />
                                    )}
                                    <col style={{ width: '36%' }} />
                                </colgroup>
                                <thead>
                                    <tr style={{ backgroundColor: t.tableHeader }}>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Start Time (IST)</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>End Time (IST)</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Duration</th>
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Status</th>
                                        {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (<th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Group</th>)}
                                        <th style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>Reason</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredResult.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatEpochToIST(item.start)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatEpochToIST(item.end)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{formatDuration(item.duration)}</td>
                                            <td style={{ border: `1px solid ${t.borderTable}`, padding: '8px', color: t.text }}>{item.status}</td>
                                            {(getCustomerId() === window._env_.GPLAST_CUSTOMER_ID) && (
                                                <td>
                                                    <SearchableTableSelect
                                                        name={`groupselected-${index}`}
                                                        value={item.groupselected || ""}
                                                        onChange={(e) => handleGroupChange(index, e.target.value)}
                                                        label="Select Group"
                                                        options={reasonGroupOptions}
                                                    />
                                                </td>)}
                                            <td>
                                                <SearchableTableSelect
                                                    name={`reasonselected-${index}`}
                                                    value={item.reasonselected || ""}
                                                    onChange={(e) => handleReasonChange(index, e.target.value)}
                                                    label="Select Reason"
                                                    required
                                                    options={
                                                        (() => {
                                                            const filtered = formattedReasons.filter(r =>
                                                                !item.groupselected || r.group === item.groupselected
                                                            );
                                                            if (item.reasonselected === "UNKNOWN" && !filtered.some(r => r.value === "UNKNOWN")) {
                                                                return [{ value: "UNKNOWN", label: "UNKNOWN", group: item.groupselected }, ...filtered];
                                                            }
                                                            return filtered;
                                                        })()
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <div style={{ marginTop: '20px', textAlign: 'center', color: '#888' }}>
                            <h3>No Data Found</h3>
                        </div>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} onClick={() => cancelreason()}>Cancel</Button>
                    <Button type="submit" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff9800' }} onClick={handleSaveThreshold2}>Save</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={allocateCompModalOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        cancelAllocateCompModal();
                    }
                }}
                sx={{ '& .MuiDialog-paper': { width: '520px', maxWidth: '90%' } }}
            >
                <DialogTitle style={{ textAlign: "center" }}>
                    {liveCompSelected ? 'Change Component' : 'Allocate Component'}
                </DialogTitle>
                <DialogContent sx={{ pb: 3 }}>
                    {liveCompSelected && (
                        <p style={{ margin: '0 0 16px', fontSize: '0.85rem', color: '#777', textAlign: 'center' }}>
                            A component is already allocated for this shift — selecting another will change the current allocation.
                        </p>
                    )}
                    <FormControl
                        variant="standard"
                        fullWidth
                        sx={{ mt: 1 }}
                    >
                        <Select
                            value={pendingCompValue || ""}
                            onChange={(e) => setPendingCompValue(e.target.value)}
                            onOpen={() => setLiveCompSearch("")}
                            MenuProps={{
                                PaperProps: { className: "operator-select-menu", style: { maxHeight: "40vh" } },
                                autoFocus: false,
                            }}
                            displayEmpty
                        >
                            <MenuItem
                                disableRipple
                                onKeyDown={(e) => e.stopPropagation()}
                                sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                            >
                                <TextField
                                    size="small"
                                    placeholder="Search component…"
                                    value={liveCompSearch}
                                    onChange={(e) => setLiveCompSearch(e.target.value)}
                                    autoFocus
                                    fullWidth
                                    onClick={(e) => e.stopPropagation()}
                                    sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                />
                            </MenuItem>
                            <MenuItem disabled value="">
                                No component selected
                            </MenuItem>
                            {(Array.isArray(currentMachinePlan) ? [...currentMachinePlan] : [])
                                .sort((a, b) => String(a.plan_no).localeCompare(String(b.plan_no), undefined, { numeric: true }))
                                .flatMap((plan) =>
                                    (Array.isArray(plan?.details) ? plan.details : [])
                                        .map((detail, dIdx) => ({ plan, detail, dIdx, label: buildDetailLabel(plan, detail) }))
                                        .filter(({ label }) => label?.toString().toLowerCase().includes(liveCompSearch.toLowerCase()))
                                        .map(({ plan, detail, dIdx, label }) => {
                                            const key = `${plan.plan_no}|${dIdx}`;
                                            const isCurrent = key === liveCompSelected;
                                            return (
                                                <MenuItem key={key} value={key} disabled={isCurrent}>
                                                    {label}{isCurrent ? ' (Currently allocated)' : ''}
                                                </MenuItem>
                                            );
                                        })
                                )}
                        </Select>
                    </FormControl>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 3 }}>
                    <Button type="button" variant="contained" className="filter_btn btn_orange" sx={{ backgroundColor: '#ff4444' }} disabled={allocatingComp} onClick={cancelAllocateCompModal}>Cancel</Button>
                    <Button
                        type="button"
                        variant="contained"
                        className="filter_btn btn_orange"
                        sx={{ backgroundColor: '#ff9800' }}
                        disabled={!pendingCompValue || allocatingComp}
                        startIcon={allocatingComp ? <MuiCircularProgress size={16} sx={{ color: '#fff' }} /> : null}
                        onClick={confirmAllocateCompModal}
                    >
                        {allocatingComp ? 'Allocating…' : (liveCompSelected ? 'Change & Allocate' : 'Allocate')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openReject}
                onClose={() => setOpenReject(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        width: 800,
                        maxWidth: "95%",
                        borderRadius: "14px",
                        overflow: "hidden",
                    },
                }}
            >
                <div style={{
                    padding: "18px 24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: `1px solid ${t.headerBorder}`,
                    background: t.bg,
                }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span style={{ fontSize: "22px" }}>🚫</span>
                        <span style={{ fontSize: "20px", fontWeight: "600", color: t.text, letterSpacing: "0.4px" }}>
                            Reject Parts Entry
                        </span>
                        {selectedRow?.machineName && (
                            <span style={{ fontSize: "20px", fontWeight: "600", color: t.text }}>
                                - {selectedRow.machineName}
                            </span>
                        )}
                        {selectedRow?.op?.operation_name && selectedRow.op.operation_name !== "No Operations" && (
                            <span style={{ fontSize: "15px", fontWeight: "500", color: t.textSub, marginLeft: "4px" }}>
                                ({selectedRow.op.operation_name})
                            </span>
                        )}
                    </div>
                </div>

                <DialogContent
                    sx={{
                        padding: "20px 24px",
                        background: t.dialogContent,
                        maxHeight: "70vh",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        gap: "18px"
                    }}
                >
                    {selectedRow && !isFetchingBluecard && (() => {
                        const actual = Number((selectedRow.op?.goodvsexp?.split("/") || [])[0] || 0);
                        const canReject = Math.max(0, actual - (existingCount || 0));
                        const rejectedAlready = existingCount || 0;
                        const stats = [
                            { label: "Actual", value: actual, color: "#fff", bg: "#1976d2", border: "#1565c0" },
                            { label: "Rejected", value: rejectedAlready, color: "#fff", bg: "#e53935", border: "#c62828" },
                            { label: "Remaining", value: canReject, color: "#fff", bg: "#2e7d32", border: "#1b5e20" },
                        ];
                        return (
                            <div style={{ display: "flex", gap: "10px", flexShrink: 0 }}>
                                {stats.map(s => (
                                    <div key={s.label} style={{ flex: 1, background: s.bg, border: `1px solid ${s.border}`, borderRadius: "8px", padding: "10px 8px", textAlign: "center" }}>
                                        <div style={{ fontSize: "14px", color: "rgba(255,255,255,0.85)", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "4px" }}>{s.label}</div>
                                        <div style={{ fontSize: "24px", fontWeight: "800", color: s.color, lineHeight: 1 }}>{s.value}</div>
                                    </div>
                                ))}
                            </div>
                        );
                    })()}

                    {prevOperatorData && prevOperatorData.count > 0 && (
                        <>
                            <div style={{ fontWeight: 600, fontSize: "16px", marginBottom: "8px" }}>
                                Previously Rejected
                            </div>

                            <div
                                style={{
                                    border: `1px solid ${t.borderLight}`,
                                    borderRadius: "8px",
                                    overflow: "hidden",
                                    flexShrink: 0
                                }}
                            >
                                {/* Header */}
                                <div
                                    style={{
                                        display: "grid",
                                        gridTemplateColumns: prevRejectGridColumns,
                                        background: t.bgCard,
                                        borderBottom: `1px solid ${t.borderLight}`
                                    }}
                                >
                                    {prevRejectHeaders.map((h, i) => (
                                        <div
                                            key={h}
                                            style={{
                                                padding: "14px",
                                                fontWeight: "600",
                                                fontSize: "15px",
                                                textAlign: "center",
                                                color: t.text,
                                                borderRight: i !== prevRejectHeaders.length - 1 ? `1px solid ${t.borderLight}` : "none"
                                            }}
                                        >
                                            {h}
                                        </div>
                                    ))}
                                </div>

                                {/* Rows container */}
                                <div
                                    style={{
                                        maxHeight: "260px", // ~4 rows
                                        overflowY: "auto"
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: prevRejectGridColumns,
                                            borderBottom: `1px solid ${t.borderLight}`,
                                            alignItems: "center",
                                            minHeight: "65px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "14px",
                                                textAlign: "center",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                borderRight: `1px solid ${t.borderLight}`,
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center"
                                            }}
                                        >
                                            {editingPrevOperator ? (
                                                <TextField
                                                    type="number"
                                                    size="small"
                                                    value={editingPrevOperator.count}
                                                    onChange={(e) => {
                                                        let val = e.target.value;
                                                        if (val !== "") {
                                                            val = Number(val);
                                                            // decrease only — never above what was already saved,
                                                            // and never below 1: an entry cannot be zeroed out
                                                            if (val > editingPrevOperator.maxCount) val = editingPrevOperator.maxCount;
                                                            if (val < 1) val = 1;
                                                        }
                                                        setEditingPrevOperator({ ...editingPrevOperator, count: val });
                                                    }}
                                                    inputProps={{
                                                        min: 1,
                                                        max: editingPrevOperator.maxCount,
                                                        style: { textAlign: "center", fontWeight: "600" }
                                                    }}
                                                    sx={{ width: "76px", "& .MuiInputBase-root": { height: "40px" } }}
                                                />
                                            ) : (
                                                prevOperatorData.count
                                            )}
                                        </div>

                                        <div
                                            style={{
                                                padding: "14px",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                borderRight: `1px solid ${t.borderLight}`,
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                textAlign: "center"
                                            }}
                                        >
                                            {editingPrevOperator ? (
                                                <FormControl size="small" fullWidth>
                                                    <InputLabel>Reason</InputLabel>
                                                    <Select
                                                        multiple
                                                        label="Reason"
                                                        value={editingPrevOperator.reason || []}
                                                        MenuProps={{
                                                            PaperProps: { className: "operator-select-menu", style: { maxHeight: "40vh", overflowY: "auto" } },
                                                            anchorOrigin: { vertical: "top", horizontal: "left" },
                                                            transformOrigin: { vertical: "bottom", horizontal: "left" },
                                                            autoFocus: false,
                                                        }}
                                                        onOpen={() => setRejectReasonSearch("")}
                                                        onChange={(e) => {
                                                            const { value } = e.target;
                                                            setEditingPrevOperator({
                                                                ...editingPrevOperator,
                                                                reason: typeof value === "string" ? value.split(",") : value
                                                            });
                                                        }}
                                                        renderValue={(selected) => selected.length <= 2 ? selected.join(", ") : `${selected.slice(0, 2).join(", ")} ...`}
                                                        sx={{ height: "40px" }}
                                                    >
                                                        <MenuItem
                                                            disableRipple
                                                            onKeyDown={(e) => e.stopPropagation()}
                                                            sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                                        >
                                                            <TextField
                                                                size="small"
                                                                placeholder="Search reason…"
                                                                value={rejectReasonSearch}
                                                                onChange={(e) => setRejectReasonSearch(e.target.value)}
                                                                autoFocus
                                                                fullWidth
                                                                onClick={(e) => e.stopPropagation()}
                                                                autoComplete="off"
                                                                sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                                            />
                                                        </MenuItem>
                                                        {(qualityReasonList || [])
                                                            .filter((item) => item.reason?.toLowerCase().includes(rejectReasonSearch.toLowerCase()))
                                                            .map((item, i) => (
                                                                <MenuItem key={i} value={item.reason}>
                                                                    <Checkbox checked={(editingPrevOperator.reason || []).includes(item.reason)} size="small" />
                                                                    <ListItemText primary={item.reason} />
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                </FormControl>
                                            ) : Array.isArray(prevOperatorData.reason)
                                                ? prevOperatorData.reason.join(", ")
                                                : prevOperatorData.reason || "-"}
                                        </div>

                                        <div
                                            style={{
                                                padding: "14px",
                                                fontSize: "15px",
                                                fontWeight: "500",
                                                color: t.text,
                                                whiteSpace: "normal",
                                                wordBreak: "break-word",
                                                textAlign: "center",
                                                borderRight: isGplast ? `1px solid ${t.borderLight}` : "none"
                                            }}
                                        >
                                            {editingPrevOperator ? (
                                                <TextField
                                                    size="small"
                                                    fullWidth
                                                    label="Remark"
                                                    value={editingPrevOperator.remark}
                                                    onChange={(e) => setEditingPrevOperator({ ...editingPrevOperator, remark: e.target.value })}
                                                    sx={{ "& .MuiInputBase-root": { height: "40px" } }}
                                                />
                                            ) : (
                                                prevOperatorData.remark || "-"
                                            )}
                                        </div>

                                        {isGplast && (
                                            <div style={{ display: "flex", justifyContent: "center", gap: "6px", padding: "8px" }}>
                                                {editingPrevOperator ? (
                                                    <>
                                                        <IconButton
                                                            title="Save"
                                                            disabled={!isPrevOperatorEditValid || isSavingPrevOperator}
                                                            onClick={handleUpdatePrevOperatorReject}
                                                            sx={{
                                                                background: "#e8f5e9",
                                                                border: "1px solid #c8e6c9",
                                                                color: "#2e7d32",
                                                                "&:hover": { background: "#d3ecd5" }
                                                            }}
                                                        >
                                                            <CheckIcon fontSize="small" />
                                                        </IconButton>
                                                        <IconButton
                                                            title="Cancel"
                                                            disabled={isSavingPrevOperator}
                                                            onClick={() => setEditingPrevOperator(null)}
                                                            sx={{
                                                                background: "#fafafa",
                                                                border: "1px solid #e0e0e0",
                                                                "&:hover": { background: "#ffeaea", color: "#d32f2f" }
                                                            }}
                                                        >
                                                            <CloseIcon fontSize="small" />
                                                        </IconButton>
                                                    </>
                                                ) : (
                                                    <IconButton
                                                        title="Edit — count can only be reduced"
                                                        onClick={() => setEditingPrevOperator({
                                                            maxCount: Number(prevOperatorData.count) || 0,
                                                            count: Number(prevOperatorData.count) || 0,
                                                            reason: Array.isArray(prevOperatorData.reason)
                                                                ? prevOperatorData.reason
                                                                : prevOperatorData.reason ? [prevOperatorData.reason] : [],
                                                            remark: prevOperatorData.remark || ""
                                                        })}
                                                        sx={{
                                                            background: "#fafafa",
                                                            border: "1px solid #e0e0e0",
                                                            "&:hover": { background: "#fff1e6", color: "#EC6E17" }
                                                        }}
                                                    >
                                                        <EditIcon fontSize="small" />
                                                    </IconButton>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div style={{ fontWeight: 600, fontSize: "16px", color: t.text }}>Add New Reject Parts</div>

                    {rejectRows.map((row, idx) => {
                        if (row.isExisting) return null;
                        const actual = Number((selectedRow?.op?.goodvsexp?.split("/") || [])[0] || 0);
                        const allowed = Math.max(0, actual - (existingCount || 0));
                        const usedByOthers = rejectRows.reduce((sum, r, i) => i !== idx && !r.isExisting ? sum + Number(r.count || 0) : sum, 0);
                        const remaining = Math.max(0, allowed - usedByOthers);
                        return (
                            <div key={idx} style={{ display: "grid", gridTemplateColumns: "80px 260px 1fr 50px", borderBottom: `1px solid ${t.borderRow}`, alignItems: "center", gap: "8px", padding: "6px 8px" }}>
                                <div>
                                    <TextField
                                        type="number"
                                        value={row.count}
                                        size="small"
                                        label="Count"
                                        onFocus={() => { if (row.count === 0) setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, count: "" } : r)); }}
                                        onChange={(e) => {
                                            let val = e.target.value;
                                            if (val === "") val = "";
                                            else { val = Number(val); if (val > remaining) val = remaining; if (val < 0) val = 0; }
                                            setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, count: val } : r));
                                        }}
                                        inputProps={{ min: 0, max: remaining, style: { textAlign: "center", fontWeight: "600" } }}
                                        sx={{ width: "80px", "& .MuiInputBase-root": { height: "40px" } }}
                                    />
                                </div>
                                <div>
                                    <FormControl size="small" fullWidth>
                                        <InputLabel>Reason</InputLabel>
                                        <Select
                                            multiple
                                            label="Reason"
                                            value={row.reason || []}
                                            MenuProps={{
                                                PaperProps: { className: "operator-select-menu", style: { maxHeight: "40vh", overflowY: "auto" } },
                                                anchorOrigin: { vertical: "top", horizontal: "left" },
                                                transformOrigin: { vertical: "bottom", horizontal: "left" },
                                                autoFocus: false,
                                            }}
                                            onOpen={() => setRejectReasonSearch("")}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, reason: typeof value === "string" ? value.split(",") : value } : r));
                                            }}
                                            renderValue={(selected) => selected.length <= 2 ? selected.join(", ") : `${selected.slice(0, 2).join(", ")} ...`}
                                            sx={{ height: "40px" }}
                                        >
                                            <MenuItem
                                                disableRipple
                                                onKeyDown={(e) => e.stopPropagation()}
                                                sx={{ p: 1, "&:hover": { background: "transparent" }, "&.Mui-focusVisible": { background: "transparent" } }}
                                            >
                                                <TextField
                                                    size="small"
                                                    placeholder="Search reason…"
                                                    value={rejectReasonSearch}
                                                    onChange={(e) => setRejectReasonSearch(e.target.value)}
                                                    autoFocus
                                                    fullWidth
                                                    onClick={(e) => e.stopPropagation()}
                                                    autoComplete="off"
                                                    sx={{ "& .MuiInputBase-input": { fontSize: "0.85rem" } }}
                                                />
                                            </MenuItem>
                                            {(qualityReasonList || [])
                                                .filter((item) => item.reason?.toLowerCase().includes(rejectReasonSearch.toLowerCase()))
                                                .map((item, i) => (
                                                    <MenuItem key={i} value={item.reason}>
                                                        <Checkbox checked={(row.reason || []).includes(item.reason)} size="small" />
                                                        <ListItemText primary={item.reason} />
                                                    </MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div>
                                    <TextField
                                        value={row.remark}
                                        size="small"
                                        label="Remark"
                                        fullWidth
                                        onChange={(e) => setRejectRows(rejectRows.map((r, i) => i === idx ? { ...r, remark: e.target.value } : r))}
                                        sx={{ "& .MuiInputBase-root": { height: "40px" } }}
                                    />
                                </div>
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <IconButton
                                        size="small"
                                        onClick={() => setRejectRows(rejectRows.filter((_, i) => i !== idx))}
                                        sx={{ background: "#fafafa", border: "1px solid #e0e0e0", "&:hover": { background: "#ffeaea", color: "#d32f2f" } }}
                                    >
                                        <DeleteOutlineIcon fontSize="small" />
                                    </IconButton>
                                </div>
                            </div>
                        );
                    })}

                    <div style={{ padding: "12px 0" }}>
                        <Button
                            variant="outlined"
                            size="small"
                            disabled={isMaxReached}
                            style={{
                                border: `1px solid ${isMaxReached ? "#bdbdbd" : "#EC6E17"}`,
                                color: isMaxReached ? "#9e9e9e" : "#EC6E17",
                                backgroundColor: "transparent",
                                cursor: isMaxReached ? "not-allowed" : "pointer"
                            }}
                            onClick={() => setRejectRows([...rejectRows, { count: 0, reason: [], remark: "", isExisting: false }])}
                        >
                            + Add Row
                        </Button>
                    </div>
                </DialogContent>

                <DialogActions sx={{ padding: "14px 24px", gap: 1.5, backgroundColor: "#f8f9fb", borderTop: "1px solid #e8eaf0" }}>
                    <Button
                        onClick={() => { setOpenReject(false); setEditingPrevOperator(null); }}
                        variant="outlined"
                        sx={{ borderRadius: "4px", minWidth: "110px", borderColor: "#90a4ae", background: "#969392", color: "#ffffff", "&:hover": { borderColor: "#788388", background: "#a5a2a1" } }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleSave}
                        disabled={(() => {
                            if (editingPrevOperator) return true;
                            const newRows = rejectRows.filter(row => !row.isExisting);
                            if (newRows.length === 0) return true;
                            return newRows.some(row => (Number(row.count) || 0) <= 0 || (row.reason || []).length === 0 || !row.remark);
                        })()}
                        sx={{ borderRadius: "4px", minWidth: "110px", background: "#EC6E17", "&:hover": { background: "#e08529" } }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {confirmType && handleConfirmAlert()}

            <DynamicSlidingKeyboard touchEnabled={keyboardEnabled} />


        </div>
    );
}

export default Operator;